// Solano Essence i18n — it
const it = {
  "webGate": {
    "title": "Usa l'app per iPhone",
    "body": "Solano Essence vive esclusivamente nell'app per iPhone. Apri l'app sul tuo telefono per continuare — il tuo coach ti aspetta lì."
  },
  "engagement": {
    "title": "Attività clienti",
    "filterAll": "Tutti",
    "filterRed": "Inattivi",
    "filterAmber": "In calo",
    "filterGreen": "Attivi",
    "statusActive": "Attivo",
    "statusFading": "In calo",
    "statusInactive": "Inattivo",
    "lastActive": "Ultima attività",
    "today": "Oggi",
    "yesterday": "Ieri",
    "daysAgo": "giorni fa",
    "never": "Mai attivo",
    "emptyFilter": "Nessun cliente in questa categoria"
  },
  "auth": {
    "accountBlocked": "Il tuo account è stato sospeso. Contatta l'assistenza.",
    "blockedTitle": "Il tuo account è stato sospeso",
    "blockedBody": "Questo account è stato sospeso per violazione delle nostre regole d'uso e non può accedere. Se pensi che sia un errore, contattaci – esaminiamo ogni caso entro 48 ore.",
    "blockedCta": "Contatta l'assistenza: info@solano-essence.com",
    "socialLoginOnly": "Questo account usa il login Google o Apple. Accedi con quel metodo oppure imposta una password tramite 'Password dimenticata?'.",
    "tooManyAttempts": "Troppi tentativi di accesso falliti. Riprova tra 15 minuti.",
    "nameRequired": "Inserisci il tuo nome.",
    "emailExists": "Email già registrata. Effettua il login.",
    "emailExistsSocial": "Email già registrata con Google o Apple. Accedi con quel metodo — oppure imposta una password tramite 'Password dimenticata?'.",
    "resetLinkInvalid": "Link non valido o già utilizzato.",
    "resetLinkExpired": "Link scaduto. Richiedine uno nuovo."
  },
  "admin": {
    "illu_title": "Immagini mascotte allenamento",
    "illu_exercises": "esercizi",
    "illu_today": "Stanotte",
    "illu_last_night": "Notte scorsa",
    "illu_eta": "Tempo restante",
    "illu_nights": "{n} notti",
    "illu_window": "Gira di notte {w}",
    "illu_running": "in corso",
    "illu_next": "prossimo giro {at}",
    "illu_remaining": "{n} esercizi mancanti",
    "subKind": "Subscription type",
    "subSince": "Since",
    "segNew": "New (7 days)",
    "segInactive": "Inactive (7 days+)",
    "segPaid": "Pro paid",
    "segComp": "Pro gifted",
    "testAccount": "Test account",
    "testMark": "Mark as test account (excluded from stats)",
    "testUnmark": "Remove mark",
    "testMarked": "Marked as test account — excluded from numbers",
    "testUnmarked": "Test mark removed",
    "adherence": "Adherence",
    "untilShort": "until",
    "expiredShort": "expired",
    "activeUsersLegend": "Active users",
    "aiCostMonth": "AI cost this month",
    "aiShareNet": "Share of net revenue",
    "aiUsageEstNote": "Costs = estimates per call type",
    "aiLimitsTitle": "Pro limits per month",
    "countsNote": "Counts exclude test and team accounts — same everywhere.",
    "revenueEstimate": "Estimate from active subscriptions × price",
    "filterAll": "All",
    "onlyPublic": "Public only",
    "onlyPrivate": "Private only",
    "onlyDupes": "Duplicates",
    "publicLabel": "Public",
    "privateLabel": "Private",
    "merge": "Merge",
    "mergeTitle": "Merge duplicate recipes",
    "mergeHint": "Pick the recipe to keep. Favorites and collections of the others are carried over, the duplicates are deleted.",
    "mergeKeep": "Merge",
    "mergeDone": "{n} duplicate(s) merged",
    "ingredientsShort": "ingredients",
    "recipeDeleteTitle": "Really delete this recipe?",
    "recipeDeleteBody": "This cannot be undone.",
    "foodDeleteTitle": "Really delete this food?",
    "editFood": "Edit food",
    "foodName": "Name",
    "per100g": "Nutrition per 100 g",
    "fiberShort": "Fiber",
    "markVerified": "Mark as verified",
    "verified": "verified",
    "settings": "Settings",
    "appleFee": "Apple fee (%)",
    "usdChf": "USD → CHF rate",
    "settingsHint": "Default 15% (Small Business Program). The rate converts AI costs to CHF.",
    "gross": "Gross",
    "net": "Net",
    "expiresOn": "expires on",
    "expiredOn": "expired on",
    "daysShort": "days",
    "noExpiry": "no expiry",
    "inviteUpgrade": "Invite",
    "inviteSent": "Pro upgrade invitation sent",
    "manualSet": "Manual",
    "sourcesHint": "Apple ✓ = paid via Apple and confirmed by receipt. Manual = Pro set without a payment source.",
    "expiringSoon": "Expiring in the next 14 days",
    "expiringNone": "No gifted Pro expires in the next 14 days.",
    "paidSubs": "Paid subscriptions",
    "unverifiedSubs": "Unconfirmed / manual",
    "unverifiedHint": "These Pro accesses are not backed by an Apple receipt.",
    "giftedSubs": "Gifted Pro accesses",
    "sortedByExpiry": "sorted by expiry",
    "revenueTitle": "Revenue / month",
    "revenueNoPrices": "Apple prices not configured (APPLE_PRICE_MONTHLY/_YEARLY)",
    "revenueMonthly": "monthly",
    "revenueYearly": "yearly",
    "revMonthlySubs": "Monthly plans",
    "revYearlySubs": "Yearly plans",
    "revPerMonth": "per month",
    "revPerYear": "per year (one-off)",
    "gifted": "Regalato",
    "aiLimitsSaved": "Limiti salvati",
    "tab_ai": "Consumo AI",
    "aiUsageTotals": "Intera app",
    "aiUsageCalls": "chiamate",
    "aiUsageEmpty": "Nessuna chiamata AI questo mese.",
    "grantAllBtn": "Regala Pro gratuito a tutti gli utenti esistenti (una tantum, per i tester)",
    "grantAllConfirm": "Regalare ora Pro gratuito (🎁) a tutti gli utenti senza Pro?",
    "grantAllOk": "Pro regalato a {n} utenti 🎁",
    "compProTitle": "Pro gratuito",
    "compProActive": "In regalo — l'utente ha Pro gratis",
    "compProPaid": "L'utente ha un abbonamento a pagamento",
    "compProOff": "Sblocca la versione completa gratis",
    "compProGrant": "Regala Pro",
    "compProRevoke": "Revoca",
    "compProGrantedOk": "Pro regalato 🎁",
    "compProUntil": "Regalato fino al",
    "compProGrant3m": "3 mesi",
    "compProGrant1m": "1 mese",
    "compProGranted1mOk": "Pro regalato per 1 mese 🎁",
    "compProGrant12m": "1 anno",
    "compProGrantUnlimited": "Illimitato",
    "compProGranted3mOk": "Pro regalato per 3 mesi 🎁",
    "compProGranted12mOk": "Pro regalato per 1 anno 🎁",
    "compProRevokedOk": "Pro gratuito revocato",
    "tab_content": "Contenuti",
    "tab_stats": "Statistiche",
    "recipes": "Ricette",
    "foods": "Alimenti",
    "searchRecipes": "Cerca ricette…",
    "searchFoods": "Cerca alimenti (min. 2 caratteri per DB standard)…",
    "noRecipes": "Nessuna ricetta trovata.",
    "publish": "Pubblica",
    "unpublish": "Nascondi",
    "publishOk": "Ricetta pubblicata",
    "unpublishOk": "Ricetta nascosta",
    "recipeDeletedOk": "Ricetta eliminata",
    "foodDeletedOk": "Voce eliminata",
    "foodsLearned": "Alimenti appresi",
    "foodsCustom": "Alimenti personalizzati (utenti)",
    "bp": {
      "tab": "Appresi",
      "hint": "Prodotti insegnati dagli utenti tramite codice a barre (foto della tabella nutrizionale o inserimento manuale). I prodotti verificati valgono per tutti gli utenti.",
      "search": "Cerca nome, marca o codice a barre…",
      "toReview": "Da verificare",
      "empty": "Nessun prodotto appreso",
      "global": "Globale",
      "fromLabel": "Foto etichetta",
      "verify": "Verifica",
      "unverify": "Verificato",
      "verifiedOk": "Prodotto verificato – ora vale per tutti gli utenti",
      "unverifiedOk": "Verifica rimossa",
      "deletedOk": "Prodotto eliminato",
      "deleteTitle": "Eliminare il prodotto?",
      "deleteBody": "verrà rimosso per tutti gli utenti. Alla prossima scansione sarà di nuovo segnalato come sconosciuto.",
      "editTitle": "Correggi prodotto",
      "brand": "Marca",
      "ingredients": "Ingredienti",
      "markVerified": "Segna come verificato (vale per tutti gli utenti)"
    },
    "foodsBuiltin": "Database standard (sola lettura)",
    "dailyActivity": "Attività (14 giorni): log alimentari e utenti attivi",
    "signups": "Registrazioni a settimana",
    "total_recipes": "Ricette",
    "total_recipes_public": "Ricette pubbliche",
    "total_foods_learned": "Alimenti appresi",
    "total_foods_custom": "Alimenti personalizzati",
    "total_ai_photo_cache": "Analisi AI (cache)",
    "total_food_logs_total": "Log alimentari totali",
    "total_workouts_total": "Allenamenti totali",
    "changeRole": "Ruolo",
    "roleChangedOk": "Ruolo modificato",
    "title": "Area Admin",
    "subtitle": "Gestione dell'app — solo super admin",
    "navAdmin": "Admin",
    "tab_overview": "Panoramica",
    "mrr": "Ricavi/mese",
    "subsApple": "Apple",
    "subsWeb": "Web",
    "subsComp": "Regalato",
    "recentUsers": "Utenti recenti",
    "seeAllUsers": "Tutti gli utenti",
    "todayImportant": "Importante oggi",
    "todayImportantEmpty": "Tutto a posto. Niente da fare.",
    "grpInactive": "{n} utenti inattivi da 7+ giorni",
    "grpFading": "{n} utenti con attività in calo",
    "grpOverKcal": "{n} utenti sopra l'obiettivo calorico",
    "grpLowProtein": "{n} utenti sotto l'obiettivo proteico",
    "grpNewLogs": "{n} nuove voci del diario oggi",
    "foodEntries": "Voci alimentari",
    "logoutConfirmTitle": "Uscire?",
    "logoutConfirmBody": "Dovrai accedere di nuovo.",
    "tab_users": "Utenti",
    "tab_subs": "Abbonamenti",
    "tab_reports": "Segnalazioni",
    "tab_moderation": "Moderazione",
    "tab_audit": "Registro",
    "statUsers": "Utenti",
    "statActive7d": "attivi (7g)",
    "statPendingOnboarding": "senza onboarding",
    "statLogsToday": "Log oggi",
    "todayLogsTitle": "Log di oggi",
    "openProfile": "Apri profilo",
    "todayLogsEmpty": "Nessuna voce oggi",
    "activeUsersTitle": "Attivi negli ultimi 7 giorni",
    "activeUsersEmpty": "Nessun utente attivo",
    "lastActive": "ultima attività",
    "logs7d": "log (7 gg)",
    "justNow": "adesso",
    "inactiveChip": "Inattivi 7g+",
    "inactiveTitle": "Utenti inattivi",
    "inactiveHint": "Nessuna voce nel diario da 7+ giorni. Il promemoria invia una notifica push 🔔 (se attiva) e un'e-mail ✉️.",
    "inactiveEmpty": "Sono tutti attivi 🎉",
    "nudge": "Ricorda",
    "nudgeAll": "Ricorda a tutti",
    "nudgeAllConfirm": "Inviare un promemoria a {n} utenti (push + e-mail)?",
    "nudgeAllDone": "{n} utenti avvisati",
    "nudgeSent": "Promemoria inviato",
    "nudgeNoChannel": "nessun canale (né push né e-mail)",
    "nudgedOn": "avvisato il",
    "neverLogged": "mai registrato",
    "daysInactive": "giorni inattivo",
    "statSubs": "Abbonamenti",
    "statBlocked": "Bloccati",
    "statReports": "segnalazioni",
    "searchUsers": "Cerca utenti (nome o email)…",
    "last7days": "Ultimi 7 giorni",
    "allLetters": "Tutti",
    "country": "Paese",
    "countryAll": "Tutti i paesi",
    "countryUnknown": "Sconosciuto",
    "signupsByCountry": "Iscrizioni per paese e settimana",
    "signupsByCountryHint": "ultime 8 settimane",
    "countryOther": "Altri",
    "signupsNone": "Ancora nessuna iscrizione",
    "proByCountry": "Abbonamenti Pro per paese",
    "proByCountryHint": "tutti gli utenti · conversione = Pro a pagamento / utenti",
    "proGifted": "Regalati",
    "proConversion": "Conv.",
    "filterActive": "Attivi",
    "filterBlocked": "Bloccati",
    "noUsers": "Nessun utente trovato.",
    "role": "Ruolo",
    "registered": "Registrato",
    "plan": "Piano",
    "blocked": "Bloccato",
    "linkedClients": "Clienti collegati",
    "weights": "Pesi",
    "payments": "Pagamenti",
    "block": "Blocca",
    "unblock": "Sblocca",
    "delete": "Elimina",
    "deleteConfirm": "Eliminare davvero?",
    "blockReasonPrompt": "Motivo del blocco (opzionale):",
    "blockedOk": "Utente bloccato",
    "unblockedOk": "Utente sbloccato",
    "deletedOk": "Utente e tutti i dati eliminati",
    "noSubs": "Ancora nessun abbonato.",
    "recentTx": "Transazioni recenti",
    "noReports": "Nessuna segnalazione.",
    "noAudit": "Nessuna azione admin registrata.",
    "viewTracking": "Vedi tracking e dettagli",
    "resetApple": "Reimposta abbonamento Apple",
    "resetAppleConfirm": "Rimuovere l'abbonamento Apple dal database? (Solo per test sandbox — un abbonamento reale attivo si riattiva da solo)",
    "resetAppleOk": "Abbonamento Apple reimpostato",
    "aiFeat": {
      "food_photo": "Foto pasto",
      "food_photo_hint": "Ri-analisi (suggerimento)",
      "fridge_photo": "Foto dispensa",
      "workout_photo": "Import allenamento",
      "coach_chat": "Coach AI",
      "pantry_recipe": "Ricette dalla dispensa",
      "weekly_menu": "Menu settimanali",
      "social_caption": "Testi social"
    }
  },
  "notifBell": {
    "achievements": "Traguardi",
    "levelUp": "Livello {level} raggiunto — “{name}”",
    "streak": "Serie di {days} giorni! +{points} SP",
    "badge": "Nuovo badge: {name}",
    "goals": {
      "water_goal": "Obiettivo acqua raggiunto",
      "steps_goal": "Obiettivo passi raggiunto",
      "sleep_7h": "7 ore di sonno raggiunte",
      "diary_complete": "Diario completo (3+ pasti)",
      "plate_check_80": "Piatto equilibrato riuscito"
    },
    "title": "Notifiche",
    "empty": "Nessuna nuova notifica",
    "openFriends": "Apri amici"
  },
  "offline": {
    "savedOffline": "Nessuna rete – pasto salvato sul dispositivo, verrà inviato automaticamente",
    "synced": "{count} pasto/i inviato/i",
    "syncFailed": "{count} pasto/i non inviato/i",
    "pendingTitle": "{count} pasto/i in attesa di connessione",
    "pendingHint": "Verranno aggiunti al diario automaticamente appena torna la rete.",
    "sendNow": "Invia ora",
    "stillOffline": "Ancora nessuna connessione – continuiamo a provare",
    "waiting": "In attesa di connessione"
  },
  "voicePrivacy": {
    "title": "Che fine fa la mia voce?",
    "pillNotStored": "La voce non viene salvata",
    "pillStored": "Il messaggio vocale viene salvato",
    "introDictation": "La dettatura trasforma la tua voce soltanto in testo.",
    "dict1": "La registrazione viene trasmessa cifrata e usata solo per produrre testo. Viene salvato soltanto quel testo – come se lo avessi digitato. Puoi controllarlo e modificarlo prima di salvare.",
    "dict2": "Il file audio viene eliminato subito dopo la trascrizione. Non arriva né nel database né nei backup.",
    "dict3": "Il microfono è attivo solo mentre registri volontariamente. Nessun ascolto in background.",
    "introStored": "Questo messaggio vocale è destinato al tuo nutrizionista.",
    "msg1": "La registrazione viene salvata con la voce del diario – come un messaggio in chat – così il tuo nutrizionista può ascoltarla.",
    "msg2": "Solo tu e il nutrizionista collegato potete riprodurla. Non viene inviata a un'IA né trascritta.",
    "msg3": "La elimini in qualsiasi momento sostituendo la risposta, eliminando la voce o il tuo account.",
    "never": "Voce, foto e chat non vengono mai usate per addestrare IA né condivise con reti pubblicitarie.",
  },
  "dailySummary": {
    "sourceManual": "Manuale",
    "pickTheme": "Scegli lo stile",
    "waterQuickTitle": "Aggiungi acqua",
    "waterCustomPlaceholder": "Inserisci ml…",
    "title": "La tua giornata",
    "today": "Oggi",
    "sleep": "Sonno",
    "steps": "Passi",
    "water": "Acqua",
    "kcal": "Kcal",
    "workout": "Allen.",
    "goals": "Obiettivi",
    "missionsAllDone": "Missioni completate! 🎉",
    "missionsAllDoneSub": "+{n} SP bonus di giornata",
    "download": "Scarica giornata",
    "downloaded": "Immagine scaricata",
    "shareTitle": "La mia giornata Solano",
    "share": "Condividi",
    "longPressToSave": "Tieni premuta l'immagine per salvarla in Foto",
    "previewHint": "Salva l'immagine o condividila direttamente",
    "shareFailedHint": "Condivisione non riuscita – tieni premuta l'immagine per salvarla",
    "mealsToday": "Pasti di oggi",
    "noMeals": "Nessun pasto registrato oggi",
    "pointsToday": "Punti oggi",
    "coachMessage": "Il tuo coach dice",
    "brand": "La tua giornata in salute",
    "defaultMotivation": "Un giorno alla volta. Piccoli passi, grandi risultati. 💪",
    "themeLabel": "Tema",
    "themes": {
      "bright_morning": "Mattina luminosa",
      "golden_hour": "Ora dorata",
      "deep_teal": "Teal profondo",
      "berry_night": "Notte di bacche"
    }
  },
  "coach": {
    "title": "Coach di oggi",
    "today": "Solano AI",
    "refresh": "Aggiorna"
  },
  "mascots": {
    "section": "Momenti mascotte",
    "title": "La tua collezione",
    "steps": "Obiettivo passi",
    "stepsHint": "Raggiungi il tuo obiettivo passi",
    "training": "Allenamento",
    "trainingHint": "Completa un allenamento",
    "water": "2L d'acqua",
    "waterHint": "Bevi 2 litri in un giorno",
    "sleep": "Obiettivo sonno",
    "sleepHint": "Raggiungi il tuo obiettivo di sonno",
    "unlockedCount": "{n} di {total} sbloccati"
  },
  "nutriscore": {
    "info": {
      "title": "Che cos'è il Nutri-Score?",
      "body": "Il Nutri-Score è un'indicazione orientativa: confronta prodotti simili tra loro. Non dice da solo se un alimento è sano o non sano.",
      "hint": "A = valori nutrizionali più equilibrati per 100 g. E = ingredienti intensi come zucchero, sale o grassi saturi."
    }
  },
  "solano": {
    "label": "Valutazione Solano",
    "tier": {
      "very_good": "Ottima scelta",
      "good": "Buona scelta",
      "ok": "Ok",
      "mindful": "Da consumare con consapevolezza"
    },
    "hint": {
      "bio": "Qualità biologica",
      "wholegrain": "Integrale",
      "no_added_sugar": "Senza zuccheri aggiunti",
      "less_fat": "Meno grassi del classico",
      "fried": "Fritto — usare con parsimonia",
      "processed_meat": "Carne lavorata — con consapevolezza",
      "whole_food": "Alimento intero",
      "mindful": "Solo occasionalmente",
      "watch_salt": "Attenzione a sale e grassi saturi",
      "hydrating": "Ideale per idratarsi"
    }
  },
  "common": {
    "edit": "Modifica",
    "networkError": "Server non raggiungibile. Controlla la connessione e riprova.",
    "save": "Salva",
    "saved": "Salvato ✓",
    "cancel": "Annulla",
    "back": "Indietro",
    "loading": "Caricamento…",
    "daysAgoShort": "{n}g fa",
    "error": "Errore",
    "saving": "Salvo…",
    "none": "—",
    "delete": "Elimina",
    "add": "Aggiungi",
    "ok": "OK",
    "done": "Fatto",
    "clear": "Cancella",
    "close": "Chiudi",
    "search": "Cerca",
    "all": "Tutti",
    "kg": "kg",
    "kcal": "kcal",
    "protein": "Proteine",
    "carbs": "Carboidrati",
    "fat": "Grassi",
    "calories": "Calorie",
    "date": "Data",
    "time": "Ora",
    "notes": "Note",
    "logout": "Esci",
    "select": "Seleziona",
    "confirm": "Conferma",
    "reject": "Rifiuta",
    "completed": "Completato",
    "welcomeBack": "Bentornato",
    "retry": "Riprova",
    "gotIt": "Ho capito",
    "refresh": "Aggiorna",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mer",
    "thu": "Gio",
    "fri": "Ven",
    "sat": "Sab",
    "sun": "Dom",
    "copied": "copiato",
    "copy": "Copia",
    "dismiss": "Ignora",
    "errorGeneric": "Qualcosa è andato storto.",
    "micDenied": "Permesso microfono negato",
    "micUnsupported": "Microfono non supportato su questo dispositivo",
    "more": "Altro",
    "next": "Avanti",
    "prev": "Indietro",
    "recipe": "Ricetta",
    "remove": "Rimuovi",
    "stop": "Stop",
    "undo": "Annulla"
  },
  "appStats": {
    "title": "Statistiche app",
    "subtitle": "Panoramica del tuo studio",
    "scopeNote": "Questi numeri riguardano SOLO i tuoi clienti e il tuo studio.",
    "orphanNote": "Nota: nel sistema esistono {n} account cliente non collegati (test / inviti aperti).",
    "myClients": "I miei clienti",
    "coaches": "Coach nello studio",
    "users": "Utenti",
    "engagement": "Engagement",
    "aiUsage": "Uso AI",
    "notifSocial": "Push & community",
    "growthTrend": "Trend di crescita",
    "totalClients": "Clienti",
    "nutritionists": "Nutrizionisti",
    "activeToday": "Attivi oggi",
    "newUsersWeek": "Nuovi · 7 giorni",
    "thisWeek": "questa settimana",
    "pastWeek": "ultimi 7 giorni",
    "total": "totale",
    "mealsToday": "Pasti oggi",
    "workoutsToday": "Workout oggi",
    "waterToday": "Log acqua oggi",
    "sharedMealsWeek": "Pasti condivisi · 7g",
    "coachMsgsToday": "Coach-AI oggi",
    "weeklyMenusWeek": "Menu settimanali · 7g",
    "recipeImagesCached": "Cache immagini ricette",
    "foodsAiCached": "Cache food AI",
    "pushSubs": "Push subscribers",
    "notifToday": "Push oggi",
    "chatWeek": "Chat msgs · 7g",
    "upcomingAppts": "Appuntamenti prossimi"
  },
  "quickSteps": {
    "title": "Passi di oggi",
    "subtitle": "Inseriscili dall'app che li conta",
    "saved": "Passi salvati",
    "invalid": "Numero non valido"
  },
  "wearable": {
    "directIntegrations": "Integrazioni wearable dirette",
    "appleBridgeHint": "Sincronizza i dati supportati da Apple Watch e da app e dispositivi collegati come Garmin, Fitbit, Polar e bilance smart.",
    "directSoonTitle": "Connessioni dirette – in arrivo",
    "directSoonHint": "I dati di base di questi provider possono già arrivare tramite Apple Health. Le connessioni dirette aggiungeranno in seguito metriche specifiche del produttore.",
    "connected": "Connesso",
    "notConnected": "Non connesso",
    "paused": "In pausa",
    "comingSoon": "In arrivo",
    "manualOnly": "Solo import manuale",
    "connectCta": "Collega",
    "needsCreds": "Credenziali server ancora mancanti — presto disponibili",
    "applePlaceholder": "WHOOP non fornisce i passi tramite API. Per Passi, Peso e Calorie accurate: collega Apple Health tramite l'app iOS \"Health Auto Export\" — genera un token qui sotto, incollalo nell'app.",
    "healthkitCta": "Sincronizza direttamente da HealthKit",
    "healthkitSyncing": "Lettura HealthKit…",
    "healthkitDone": "Sync HealthKit completata: {days} giorni",
    "healthkitDenied": "Accesso HealthKit non riuscito. Controlla i permessi in Impostazioni → Salute → Accesso ai dati.",
    "healthkitServerError": "Errore del server durante il salvataggio dei dati Salute. Riprova più tardi.",
    "healthkitNetworkError": "Nessuna connessione al server. Controlla la tua connessione Internet.",
    "healthkitHint": "Questa app può leggere i dati Salute direttamente dall'iPhone — senza app aggiuntive.",
    "healthConnectSoon": "L'integrazione con Health Connect per Android arriverà presto. Nel frattempo puoi collegare direttamente WHOOP, Garmin & co.",
    "healthConnectBridgeHint": "Legge passi, calorie, sonno, frequenza cardiaca a riposo, HRV, peso e allenamenti da Health Connect – quindi da Samsung Health, Fitbit, Garmin, Google Fit & co.",
    "healthConnectDone": "Sincronizzazione Health Connect completata: {days} giorni",
    "healthConnectCta": "Sincronizza direttamente da Health Connect",
    "healthConnectSyncing": "Lettura di Health Connect…",
    "healthConnectDenied": "Accesso a Health Connect non possibile. Apri l'app Health Connect → Autorizzazioni app → Solano Essence e consenti la lettura.",
    "healthConnectMissing": "Health Connect non è installato o è obsoleto su questo dispositivo. Installalo/aggiornalo dal Play Store.",
    "healthConnectEmpty": "Permesso ok, ma Health Connect non contiene dati degli ultimi 7 giorni. Attiva la sincronizzazione con Health Connect nella tua app fitness (Samsung Health → Impostazioni → Health Connect, Fitbit, Garmin Connect, Google Fit …) e riprova.",
    "healthConnectNoPermission": "Nessun permesso Health Connect concesso. Apri Health Connect → Autorizzazioni app → Solano Essence e consenti la lettura di passi, calorie, sonno, frequenza cardiaca e peso.",
    "healthConnectOpen": "Apri Health Connect",
    "healthConnectSoonShort": "Presto via Health Connect",
    "myDevices": "I miei dispositivi",
    "addDevice": "Aggiungi dispositivo",
    "noDevices": "Nessun dispositivo collegato.",
    "active": "Attivo",
    "available": "Disponibili",
    "iosOnly": "Nell'app Solano (iPhone/Android)",
    "pause": "Pausa",
    "resume": "Riprendi",
    "syncNow": "Sincronizza ora",
    "syncing": "Sync…",
    "disconnect": "Disconnetti",
    "disconnectedOk": "Connessione rimossa",
    "lastSync": "Ultima sync",
    "priorityRule": "Priorità dati in caso di duplicati",
    "whoopConnectedOk": "WHOOP collegato — avvio prima sync…",
    "syncedOk": "Sync completo: {days} giorni",
    "resumedOk": "Sync riattivo",
    "pausedOk": "Sync in pausa",
    "manualTag": "Senza wearable",
    "manualTitle": "Inserisci valori manualmente",
    "manualDate": "Data",
    "manualSleepMin": "Sonno (min)",
    "manualRestingHr": "Freq. riposo (bpm)",
    "manualHrv": "HRV (ms)",
    "manualSteps": "Passi",
    "manualActiveKcal": "Kcal attive",
    "manualRecovery": "Recovery (0-100)",
    "manualSaveCta": "Salva valori",
    "manualSavedOk": "Valori salvati",
    "manualEmpty": "Inserisci almeno un valore",
    "manualRecent": "Ultimi inserimenti",
    "whoopNoSteps": "WHOOP non passa i passi tramite API. Collega Apple Health qui sotto per avere Passi, Peso e Calorie automatici e corretti.",
    "appleSyncHint": "Apple Health invia i dati in automatico dall'iPhone. Apri l'app \"Health Auto Export\" → tocca \"Run Now\" — Passi, Peso e Calorie arrivano in ~20 secondi.",
    "appleWaiting": "In attesa dell'iPhone",
    "appleTestWebhook": "Test invio",
    "appleTestOk": "Test invio ok ✓",
    "appleTestFail": "Test invio fallito",
    "appleSetupOpen": "Setup / Import automatico",
    "appleSetupClose": "Chiudi setup",
    "appleResetToday": "Reset di oggi",
    "appleResetConfirm": "Cancellare i valori Apple di oggi? Se poi Health Auto Export invia qualcosa, verranno riscritti.",
    "appleResetOk": "Valori di oggi resettati",
    "appleAutoHint": "Sincronizza in automatico dall'iPhone in background. Per un aggiornamento immediato: apri \"Health Auto Export\" → Run Now.",
    "appleHeaderAlt": "Alternativa: Header invece dell'URL con token",
    "appleHeaderAltHint": "Usa O l'URL con ?token qui sopra O i tre campi qui sotto (URL + Key + Value) in \"Überschriften hinzufügen\" — non tutti e due.",
    "appleBridgeTag": "Health Auto Export Bridge",
    "appleBridgeSetup": "Attiva l'import automatico",
    "appleBridgeConnected": "Apple Health collegato",
    "appleStep1": "Installa sull'iPhone l'app \"Health Auto Export\" (Gratis)",
    "appleStep2": "Apri l'app → \"Automations\" → \"+ Add Automation\" → \"REST API\"",
    "appleStep3": "Incolla l'URL qui sotto → seleziona: Steps, Weight, Active Energy, Resting HR, Sleep, HRV, Workouts",
    "appleStep4": "Salva e tocca \"Run Now\" — i dati arrivano in ~20 secondi",
    "appleGenerateToken": "Genera token",
    "appleWebhookUrl": "Webhook URL (da incollare in Health Auto Export)",
    "appleTokenCreated": "Nuovo token generato",
    "appleTokenRevoked": "Token eliminato",
    "appleTokenCreatedAt": "Creato",
    "appleLastPayload": "Ultimo import",
    "appleRotateToken": "Rigenera",
    "appleRevokeToken": "Elimina",
    "appleRevokeConfirm": "Eliminare il token? L'app iPhone smetterà di inviare dati.",
    "metric": {
      "steps": "Passi",
      "weight_kg": "Peso",
      "active_calories": "Kcal attive",
      "hr": "Freq. cardiaca",
      "resting_hr": "Freq. riposo",
      "sleep": "Sonno",
      "workouts": "Workout",
      "recovery": "Recovery",
      "hrv": "HRV",
      "strain": "Strain"
    }
  },
  "health": {
    "title": "Health Score",
    "chipLabel": "Health",
    "chipEmpty": "Nessun pasto",
    "excellent": "Eccellente",
    "veryGood": "Molto buono",
    "good": "Buono",
    "fair": "Da migliorare",
    "poor": "Richiede attenzione",
    "noMeals": "Registra i pasti per ricevere il tuo punteggio",
    "hint": "Basato su proteine, fibre, frutta/verdura, grassi saturi, zuccheri, sale e acqua.",
    "muscleTitle": "Muscle",
    "heartTitle": "Heart",
    "energyTitle": "Energy",
    "saltPinch": "un pizzico di sale",
    "saltHalfTsp": "½ cucchiaino di sale",
    "saltTsp": "cucchiaino di sale",
    "saltTspPl": "cucchiaini di sale",
    "infoAria": "Come funziona l'Health Score",
    "infoTag": "Come funziona",
    "infoTitle": "Il tuo Health Score",
    "infoBody": "Il punteggio si calcola sui pasti registrati oggi. Somma i punti positivi di ciò che fa bene e sottrae penalità sui componenti da limitare. Massimo 100.",
    "infoPositiveTitle": "Bonus (max 70)",
    "infoProtein": "Proteine (~1,4 g/kg peso)",
    "infoFiber": "Fibre (30 g/giorno)",
    "infoFV": "Frutta e verdura (4 porzioni)",
    "infoWater": "Acqua (2 L)",
    "infoNegativeTitle": "Penalità (max 30)",
    "infoSatFat": "Grassi saturi (<10% kcal)",
    "infoSugar": "Zuccheri (<40 g)",
    "infoSalt": "Sale (<5 g)",
    "infoNegativeHint": "Pieni se ben sotto soglia, zero se ampiamente sopra.",
    "infoTip": "Tocca la ring HEALTH nella barra sopra per vedere il breakdown live di oggi.",
    "infoSource": "Riferimenti: WHO, EFSA, ISS/CREA linee guida italiane 2018.",
    "infoSubTitle": "I 3 cerchi spiegati",
    "infoMuscleDesc": "60 % proteine (quota del tuo target giornaliero) + 25 % allenamento (20 min = 100 %) + 15 % adeguatezza calorica (vicino al target = punteggio pieno, troppo o troppo poco lo abbassa).",
    "infoHeartDesc": "30 % fibre + 30 % frutta & verdura (4 porzioni = 100 %) + 20 % sale + 20 % grassi saturi. Per sale e grassi: sotto il limite = 100 %, oltre il valore scende.",
    "infoEnergyDesc": "40 % acqua + 30 % carboidrati + 30 % attività. Attività = il migliore tra passi (quota del tuo obiettivo passi) O allenamento (30 min = 100 %) — un workout conta pieno anche con pochi passi."
  },
  "streak": {
    "dayOne": "giorno",
    "dayMany": "giorni",
    "tooltip": "Giorni consecutivi ≥ {target} passi · Record: {best}"
  },
  "nutAdvice": {
    "title": "Coach Nutrizionale",
    "chipLabel": "Nutrizione",
    "subtitle": "{count} suggerimenti concreti per il resto della giornata",
    "noData": "Registra i pasti per ricevere i consigli"
  },
  "challenges": {
    "title": "Sfide di oggi",
    "chipLabel": "Sfide",
    "subtitle": "{done}/{total} completate oggi",
    "allDone": "Tutte le sfide completate oggi! 🎉",
    "startCta": "Inizia a tracciare per accendere le sfide",
    "hint": "Ogni giorno si azzera. Motivati e mantieni la striscia!",
    "completed": "Completata",
    "remaining": "ancora",
    "edit": "Personalizza",
    "editTitle": "Personalizza le tue sfide",
    "editDesc": "Imposta i target giornalieri e disattiva quelle che non ti interessano.",
    "steps": "Passi",
    "fiber": "Fibre",
    "protein": "Proteine",
    "water": "Acqua",
    "saveBtn": "Salva sfide",
    "saved": "Sfide aggiornate!",
    "resetDefaults": "Ripristina predefinite",
    "atLeastOne": "Almeno una sfida deve rimanere attiva"
  },
  "learn": {
    "title": "Impara",
    "chipLabel": "Impara",
    "chipNew": "Nuovo articolo",
    "subtitle": "Pillola del giorno",
    "next": "Prossima pillola",
    "loading": "Sto scegliendo una pillola per te…",
    "empty": "Nessuna pillola disponibile",
    "catNutrition": "Nutrizione",
    "catBasics": "Fondamentali",
    "basicsProgress": "Percorso base · Lezione {n} di {total}",
    "quizTitle": "Mini quiz",
    "quizCorrect": "Esatto!",
    "quizCorrectSp": "Esatto! +{points} Solano Points",
    "quizWrong": "Non proprio — la risposta giusta è evidenziata.",
    "catHealth": "Salute",
    "catRecipes": "Ricette",
    "catMyths": "Miti da sfatare",
    "pickCategory": "Cambia argomento",
    "limitReached": "Hai visto tutte le pillole di oggi — torna domani!",
    "statsTitle": "La tua settimana di studio",
    "weekCorrect": "{correct}/{answered} corrette",
    "streak": "Serie di {n} giorni",
    "streakNone": "Inizia oggi la tua serie di studio",
    "streakNext": "Bonus da {n} giorni",
    "streakBonusToday": "+{points} bonus oggi",
    "streakBonus": "Serie di {n} giorni: +{points} Solano Points bonus!",
    "reviewTitle": "Ripasso",
    "reviewDue": "{n} da ripassare",
    "reviewStart": "Verifica: ripassa una vecchia card",
    "reviewHint": "Card di {days} giorni fa — te la ricordi ancora?",
    "reviewNone": "Nessun ripasso in sospeso — continua così!",
    "reviewCorrect": "Memorizzato! +{points} Solano Points",
    "reviewWrong": "Non proprio — ricorda la risposta evidenziata.",
    "reviewNext": "Prossimo ripasso ({n})"
  },
  "med": {
    "title": "Mediterranean Score",
    "chipLabel": "Med",
    "chipDays": "Ultimi {days}g",
    "chipEmpty": "Registra pasti",
    "subtitle": "Ultimi {days} giorni",
    "hint": "Aderenza alla dieta mediterranea: più olio d'oliva, pesce, verdure, legumi, cereali integrali e frutta secca; meno carne rossa.",
    "noData": "Registra i pasti degli ultimi 7 giorni",
    "infoAria": "Come funziona il punteggio",
    "infoTag": "Come funziona",
    "infoTitle": "Il tuo Mediterranean Score",
    "infoBody": "Analizziamo gli ultimi 7 giorni del tuo diario alimentare e cerchiamo 8 gruppi tipici della dieta mediterranea (più una penalità per la carne rossa). Ogni pasto viene classificato dai suoi ingredienti; se scrivi anche i grammi (es. \"80g spinaci\"), calcoliamo le porzioni reali secondo le linee guida CREA/EFSA.",
    "infoTargetsTitle": "Target settimanali · porzione",
    "infoTip": "Suggerimento: scrivi i grammi nei tuoi pasti (es. \"150g fagioli\") per un conteggio più preciso. Senza grammi, ogni pasto conta come 1 porzione.",
    "infoSource": "Fonte: MedDiet Adherence Score (Trichopoulou 2003, PREDIMED), linee guida CREA/EFSA sulle porzioni.",
    "penaltyHint": "Ogni porzione oltre 1/settimana toglie punti (max −6).",
    "tipTitle": "Consiglio di oggi",
    "tipCta": "Vedi ricette adatte",
    "genEmpty": "Nessuna ricetta adatta nella tua libreria",
    "genBtn": "Genera una nuova ricetta con l'AI",
    "tips": {
      "olive_oil": "Aggiungi oggi un cucchiaio di olio d'oliva – ad es. sulle verdure o nell'insalata.",
      "fish": "Pianifica una porzione di pesce oggi o domani – ad es. salmone, trota o tonno.",
      "vegetables": "Ancora una porzione extra di verdure oggi – ad es. insalata, broccoli o verdure al forno.",
      "fruits": "Prendi ancora un frutto oggi – ad es. mela, frutti di bosco o una banana.",
      "legumes": "Ancora una porzione di legumi oggi – ad es. lenticchie, ceci o fagioli.",
      "whole_grains": "Scegli integrale oggi – ad es. fiocchi d'avena, pane o riso integrale.",
      "nuts_seeds": "Una piccola manciata di noci o semi come snack – ad es. mandorle o noci.",
      "dairy_fermented": "Ancora uno yogurt, skyr o kefir oggi – ideale come snack o a colazione.",
      "red_meat": "Questa settimana molta carne rossa – oggi sostituisci con pesce, pollame o legumi.",
      "processed_meat": "Riduci salumi e affettati – prova oggi hummus, formaggio o avocado."
    }
  },
  "moderation": {
    "newReportToast": "Nuova segnalazione ({reason}) su {name}",
    "openReports": "{n} segnalazioni aperte",
    "report": "Segnala",
    "block": "Blocca",
    "unblock": "Sblocca",
    "reportTitle": "Segnala {name}",
    "reason_harassment": "Molestie",
    "reason_spam": "Spam",
    "reason_inappropriate": "Contenuto inappropriato",
    "reason_other": "Altro",
    "reportTextPh": "Facoltativo: cosa è successo?",
    "reportHint": "La segnalazione arriva in modo riservato al team Solano e viene esaminata entro 24 h.",
    "reportSubmit": "Invia segnalazione",
    "reportSent": "Grazie – la tua segnalazione è stata inviata.",
    "blockConfirm": "Bloccare {name}? Non vi vedrete più; messaggi e richieste di amicizia (anche via codice) non saranno più possibili.",
    "blockedOk": "{name} è stato bloccato.",
    "unblockedOk": "Blocco rimosso.",
    "sendBlocked": "Messaggio non possibile – questo contatto è bloccato.",
    "blockedTitle": "Utenti bloccati",
    "blockedHint": "Le persone bloccate non possono inviarti messaggi o richieste.",
    "blockedEmpty": "Non hai bloccato nessuno.",
    "filter_open": "Aperte",
    "filter_resolved": "Risolte",
    "filter_all": "Tutte",
    "noReports": "Nessuna segnalazione.",
    "reportedUser": "Segnalato",
    "reporter": "Segnalato da",
    "userBlocked": "bloccato",
    "messageDeleted": "messaggio eliminato",
    "deleteMessage": "Elimina messaggio",
    "blockUser": "Blocca utente",
    "blockConfirmAdmin": "Bloccare questo utente? Tutte le sessioni verranno chiuse.",
    "resolve": "Risolta",
    "deletedOk": "Messaggio eliminato.",
    "userBlockedOk": "Utente bloccato.",
    "resolvedOk": "Segnalazione risolta."
  },
  "friends": {
    "remove": "Rimuovi amico",
    "photoCamera": "Scatta una foto",
    "photoFile": "Invia immagine da galleria/file",
    "shareTitle": "Condividi",
    "shareTabMeals": "Pasti",
    "shareTabRecipes": "Ricette",
    "shareRecipeHint": "Scegli una ricetta salvata – verrà inviata in chat come scheda con i valori nutrizionali.",
    "shareRecipeEmpty": "Nessuna ricetta trovata.",
    "searchRecipes": "Cerca ricetta…",
    "recipeShared": "Ricetta",
    "openRecipe": "Apri ricetta",
    "perServing": "a porzione",
    "shareMeal": "Condividi un pasto",
    "shareMealTitle": "Condividi un pasto",
    "shareMealHint": "Scegli un pasto registrato – verrà inviato in chat con foto e valori nutrizionali.",
    "shareMealEmpty": "Nessun pasto registrato finora.",
    "mealShared": "Pasto",
    "removeConfirm": "Rimuovere questo amico? La chat resta nascosta finché non vi ricollegate.",
    "openChat": "Apri",
    "toastGoToChat": "Tocca per andare alla chat",
    "chatEmpty": "…",
    "pageTitle": "Amici",
    "pageSubtitle": "Trova amici, motivatevi insieme",
    "requestsInbox": "Richieste in arrivo",
    "addSection": "Aggiungi amici",
    "yourFriends": "I tuoi amici",
    "leaderboardTitle": "Classifica settimanale",
    "leaderboardHint": "Media Health Score negli ultimi 7 giorni",
    "computingBoard": "Calcolo classifica…",
    "boardEmpty": "Nessun amico ancora in classifica.",
    "boardEmptyHint": "Aggiungi amici per confrontarvi ogni settimana.",
    "daysActive": "{n} giorni attivi",
    "noDayTracked": "Nessun giorno tracciato",
    "you": "Tu",
    "yourCode": "Il tuo codice",
    "copy": "Copia",
    "regenerate": "Rigenera",
    "shareHint": "Condividi questo codice con un amico via WhatsApp. Lui lo inserisce nella sua app e diventate amici.",
    "shareWa": "Condividi su WhatsApp",
    "hasCodeQ": "Hai il codice di un amico?",
    "redeemBtn": "Aggiungi",
    "codeInvalid": "Il codice deve avere 6 caratteri",
    "alreadyFriends": "Siete già amici",
    "codeNotValid": "Codice non valido",
    "copyOk": "Codice copiato",
    "copyErr": "Impossibile copiare",
    "newCodeGen": "Nuovo codice generato",
    "genericError": "Errore",
    "waMessage": "Ciao! Aggiungimi come amico su Solano Essence con il mio codice: {code}\nScarica l'app: https://solano-essence.com",
    "chatMsgPlaceholder": "Scrivi un messaggio…",
    "removeFriend": "Rimuovi amico",
    "confirmRemove": "Sicuro di voler rimuovere questo amico?",
    "removedOk": "Amico rimosso",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "noChange": "Nessun cambio",
    "pushBannerTitle": "Attiva le notifiche",
    "pushBannerHint": "Ricevi un avviso anche con l'app chiusa quando un amico ti scrive",
    "pushBannerCta": "Attiva",
    "pushToastOk": "Notifiche attivate!",
    "emptyList": "Nessun amico ancora. Cerca qualcuno qui sopra.",
    "confirmRegen": "Rigenerando il codice, il vecchio non funzionerà più. Continuare?"
  },
  "mealType": {
    "colazione": "Colazione",
    "spuntino": "Spuntino",
    "pranzo": "Pranzo",
    "merenda": "Merenda",
    "cena": "Cena",
    "altro": "Altro"
  },
  "exlib": {
    "ctaBtn": "Componi allenamento",
    "ctaHint": "Scegli esercizi dalla libreria, carica un modello o allenati dal vivo",
    "title": "Libreria esercizi",
    "subtitle": "Oltre 870 esercizi con immagini – forza, cardio, stretching",
    "tabSearch": "Esercizi",
    "tabTemplates": "Modelli",
    "tabPlan": "Il mio piano",
    "searchPlaceholder": "Cerca esercizio o muscolo…",
    "all": "Tutti",
    "results": "{n} esercizi",
    "exercises": "esercizi",
    "loadingInstructions": "Traduzione istruzioni…",
    "addToPlan": "Aggiungi all'allenamento",
    "inPlan": "Nel piano",
    "planEmpty": "Nessun esercizio – scegline dalla ricerca o carica un modello.",
    "sets": "Serie",
    "reps": "Rip.",
    "repsShort": "rip.",
    "seconds": "Sec",
    "useTime": "A tempo",
    "useReps": "A ripetizioni",
    "saveDone": "Salva come fatto",
    "startLive": "Inizia ora",
    "customWorkout": "Il mio allenamento",
    "setsDone": "{done} di {total} serie",
    "rest": "Pausa",
    "finish": "Termina allenamento",
    "abortConfirm": "Interrompere? Le serie spuntate andranno perse.",
    "saved": "Allenamento salvato – {min} min, grande!",
    "liveNote": "Allenamento live: {done}/{total} serie",
    "savedPlan": "Allenamento salvato",
    "lastTime": "Ultima volta: {w} kg × {r} ({d})",
    "lastTimeReps": "Ultima volta: {r} rip. ({d})",
    "best": "Record {w} kg",
    "newRecord": "Nuovo record!",
    "saveTemplate": "Salva come modello",
    "templateName": "Nome del modello",
    "templateSaved": "Modello salvato",
    "myTemplates": "I miei modelli",
    "fromCoach": "Dal coach",
    "deleteTemplateConfirm": "Eliminare questo piano?",
    "myPlansTitle": "I miei piani di allenamento",
    "myPlansHint": "Tocca per iniziare subito",
    "assignToClient": "Assegna al cliente",
    "assigned": "Piano assegnato",
    "coachPlansTitle": "Piani di allenamento",
    "coachPlansEmpty": "Nessun piano assegnato – componine uno dalla libreria esercizi.",
    "assignBtn": "Assegna piano",
    "editPlan": "Modifica piano",
    "saveChanges": "Salva modifiche",
    "changesSaved": "Piano aggiornato",
    "daysLabel": "Giorni",
    "todayDue": "Oggi",
    "todaySuggest": "In programma oggi: {name}",
    "historyTitle": "Allenamenti live & record",
    "historyEmpty": "Nessun allenamento con esercizi registrato.",
    "curveTitle": "Peso massimo – ultime {weeks} settimane",
    "curveEmpty": "Ancora pochi dati per una curva – dal secondo allenamento con peso.",
    "suggestWeight": "Tutte le serie completate l'ultima volta – suggerito {w} kg (+2,5)",
    "keepLast": "Tieni {w} kg",
    "weekTitle": "Il tuo riepilogo settimanale",
    "weekWorkouts": "Allenamenti",
    "weekMinutes": "Minuti",
    "weekVolume": "Volume",
    "weekRecords": "Record",
    "weekVolumeHint": "Questa settimana hai sollevato {kg} kg – serie × rip. × peso. Forte!",
    "weekHint": "Registra i pesi al prossimo allenamento per vedere qui il tuo volume.",
    "weekShare": "Condividi riepilogo",
    "weekNewRecords": "Nuovi record",
    "weekShareNoRecords": "Continua così – la prossima settimana cade un record!",
    "weekShareFooter": "Allenato con Solano Essence",
    "weekShareDownloaded": "Immagine salvata",
    "deloadHint": "{n} settimane di aumento di fila – più leggero questa settimana: {w} kg (−10 %)",
    "deloadApply": "Applica",
    "deloadTitle": "Settimana di scarico consigliata",
    "deloadBody": "{names}: {n} settimane di aumento di fila. Questa settimana allenati al −10 % – il corpo recupera e torni più forte.",
    "swapTitle": "Attrezzo occupato? Alternativa stesso muscolo",
    "swapEmpty": "Nessuna alternativa adatta.",
    "swapped": "Sostituito con {name}",
    "photoStart": "Inizio",
    "photoEnd": "Fine",
    "openDetail": "Vedi esercizio",
    "placeGym": "Palestra",
    "placeHome": "Casa",
    "showAll": "Mostra tutti",
    "showCore": "Solo classici",
    "pickGroup": "Cosa vuoi allenare?",
    "coreCount": "{n} classici",
    "resultsCore": "{n} classici · {all} in totale",
    "moreAll": "Mostra altri {n} esercizi",
    "empty": "Nessun risultato – prova un altro termine.",
    "coreBadge": "Classico",
    "guideLoading": "Carico i consigli del coach…",
    "steps": "Esecuzione",
    "tips": "Consigli tecnici",
    "mistakes": "Errori comuni",
    "breathing": "Respirazione",
    "feel": "Dove lo senti",
    "easier": "Più facile",
    "harder": "Più difficile",
    "showPhotos": "Mostra foto originali",
    "hidePhotos": "Nascondi foto",
    "regenImage": "Posa sbagliata? Ridisegna",
    "regenDone": "Mascotte ridisegnata",
    "regenRecent": "Già ridisegnata nelle ultime 24 h",
    "regenBudget": "Budget IA di oggi esaurito – riprova più tardi",
    "group": {
      "chest": "Petto",
      "back": "Schiena",
      "legs": "Gambe & glutei",
      "shoulders": "Spalle",
      "arms": "Braccia",
      "core": "Addome & core",
      "cardio": "Cardio & total body",
      "stretch": "Mobilità & stretching"
    }
  },
  "recipePhoto": {
    "title": "Cambia immagine ricetta",
    "menu": "Cambia foto",
    "takePhoto": "Scatta foto",
    "fromGallery": "Scegli dalla galleria",
    "aiHint": "L'IA crea una foto del piatto da nome e ingredienti",
    "remove": "Rimuovi foto",
    "updated": "Immagine ricetta aggiornata",
    "removed": "Immagine ricetta rimossa",
    "cropTitle": "Ritaglia immagine",
    "cropHint": "Trascina per spostare, pizzica per zoomare, frecce per ruotare",
    "cropApply": "Ritaglia e salva",
    "styleTitle": "Stile della foto IA",
    "styleRustic": "Rustico",
    "styleBright": "Chiaro e moderno",
    "styleTopdown": "Vista dall'alto",
    "generateNow": "Genera ora",
    "variantsBtn": "Genera 2 proposte",
    "variantsGenerating": "Creo due proposte…",
    "pickTitle": "Quale ti piace di più?",
    "pickHint": "Tocca la foto migliore e applicala.",
    "variantsRetry": "Riprova",
    "variantApply": "Usa questa"
  },
  "recipeScan": {
    "addPage": "Aggiungi pagina / retro",
    "photosCount": "{n} foto selezionate",
    "readBtn": "Leggi ricetta",
    "removePhoto": "Rimuovi foto",
    "or": "oppure",
    "urlLabel": "Incolla un link di ricetta",
    "urlPlaceholder": "https://…/ricetta",
    "urlBtn": "Importa",
    "urlReading": "Lettura della pagina…",
    "urlError": "Impossibile caricare la pagina – controlla il link o fotografa uno screenshot.",
    "invalidUrl": "Inserisci un link valido.",
    "ctaBtn": "Fotografa una ricetta",
    "title": "Ricetta da foto",
    "subtitle": "Fotografa una pagina di libro di cucina o una scheda ricetta – l'IA la trasforma in una ricetta Solano.",
    "takePhoto": "Scatta foto",
    "fromGallery": "Dalla galleria",
    "tip": "Consiglio: pagina piatta e ben illuminata; ingredienti e procedimento devono essere leggibili.",
    "scanning": "Lettura della ricetta…",
    "scanningHint": "Riconoscimento di ingredienti, quantità e passaggi, poi calcolo dei valori nutrizionali.",
    "reviewTitle": "Controlla la ricetta",
    "reviewDesc": "Controlla nome, quantità e passaggi – poi salva.",
    "nameLabel": "Nome",
    "servingsLabel": "Porzioni",
    "ingredientsLabel": "Ingredienti (uno per riga)",
    "stepsLabel": "Procedimento (un passaggio per riga)",
    "filledNote": "{n} ingrediente/i senza quantità completato/i con quantità tipiche – controlla.",
    "usePhoto": "Usa la foto come immagine della ricetta",
    "fromSource": "Fonte: {title}",
    "lowConfidence": "La pagina era difficile da leggere – controlla bene ingredienti e quantità.",
    "save": "Salva come ricetta",
    "saved": "Ricetta “{name}” salvata",
    "retake": "Altra foto",
    "noRecipe": "Nessuna ricetta trovata nella foto – fotografa una pagina con ingredienti e procedimento.",
    "error": "Impossibile leggere la ricetta – riprova."
  },
  "fridge": {
    "ctaBtn": "Genera dal frigo",
    "title": "Cosa hai nel frigo?",
    "subtitle": "Elenca gli ingredienti che hai e l'AI ti crea una ricetta con macro e nutrienti.",
    "ingredientsLabel": "I tuoi ingredienti",
    "ingredientsPlaceholder": "Es. 2 uova, 200g pomodori, mozzarella, riso, basilico, olio evo",
    "ingredientsHint": "Separa con virgole. Sale, pepe, acqua e olio si assumono già disponibili.",
    "photoBtn": "Foto frigo",
    "recognizing": "Riconosco…",
    "photoDetected": "Aggiunti {count} ingredienti dalla foto",
    "photoRecogError": "Non sono riuscito a riconoscere gli ingredienti, riprova",
    "mealTypeLabel": "Tipo di pasto (opzionale)",
    "maxTimeLabel": "Tempo max (min)",
    "servingsLabel": "Porzioni",
    "goalLabel": "Per quale obiettivo?",
    "goalAny": "Nessuno",
    "goalHint.weight_loss": "≈ 350-500 kcal · ≥ 20 g proteine per porzione",
    "goalHint.maintenance": "≈ 450-650 kcal · macro bilanciati",
    "goalHint.muscle_gain": "≈ 600-800 kcal · ≥ 35 g proteine per porzione",
    "dietaryLabel": "Preferenze (opzionali)",
    "dietVeg": "Vegetariano",
    "dietVegan": "Vegano",
    "dietGlutenFree": "Senza glutine",
    "dietLactoseFree": "Senza lattosio",
    "dietLowCarb": "Low carb",
    "dietHighProtein": "Iperproteico",
    "generateBtn": "Genera ricetta",
    "generating": "Sto pensando alla tua ricetta…",
    "generatingHint": "GPT-5.2 sta creando ingredienti dosati, passi e macro.",
    "needIngredients": "Aggiungi almeno 2 ingredienti.",
    "errorGen": "Errore nella generazione. Riprova.",
    "recipeReady": "Ricetta pronta!",
    "reviewDesc": "Salvata nel tuo ricettario. Puoi generare la foto AI.",
    "ingredientsSection": "Ingredienti",
    "stepsSection": "Procedimento",
    "servingsShort": "porz.",
    "macrosAccurate": "Macro accurate",
    "matchedTip": "Calcolati dal database Solano.",
    "missingLabel": "Ingredienti opzionali che migliorerebbero la ricetta:",
    "newRecipe": "Nuova",
    "generatePhoto": "Genera foto AI",
    "photoDone": "Foto generata!",
    "photoError": "Errore nella foto AI.",
    "done": "Fatto",
    "goalHint": {
      "weight_loss": "≈ 350–500 kcal · ≥ 20 g proteine a porzione",
      "maintenance": "≈ 450–650 kcal · macro bilanciati",
      "muscle_gain": "≈ 600–800 kcal · ≥ 35 g proteine a porzione"
    }
  },
  "login": {
    "portalTag": "Portale Clienti",
    "title": "Bentornato.",
    "subtitle": "Accedi con Google per continuare il tuo percorso con il tuo nutrizionista.",
    "googleBtn": "Continua con Google",
    "appleBtn": "Accedi con Apple",
    "hint": "Sei nuovo? Al primo accesso ti verrà chiesto se sei",
    "hintNut": "nutrizionista",
    "hintOr": "o",
    "hintCli": "cliente",
    "tagline": "La tua essenza, il tuo equilibrio.",
    "taglineDesc": "Il portale dedicato ai clienti dello studio Solano Essence. Nutrizione, sport e progresso in un unico spazio.",
    "discipline": "Nutrizione clinica · Nutrizione sportiva",
    "tabGoogle": "Google",
    "tabEmail": "Email",
    "emailLabel": "Indirizzo e-mail",
    "emailPlaceholder": "nome@esempio.ch",
    "welcomeSub": "Accedi per continuare il tuo percorso di salute.",
    "passwordLabel": "Password",
    "loginBtn": "Accedi",
    "noAccount": "Non hai un account?",
    "registerLink": "Registrati",
    "registerTitle": "Crea il tuo account",
    "registerSubtitle": "Registrati con email e password per iniziare.",
    "inviteLabel": "Codice invito beta",
    "inviteHint": "Ricevuto con il tuo invito beta",
    "invite": {
      "required": "Serve un codice invito. Chiedi al tuo nutrizionista.",
      "invalid": "Codice non valido. Ricontrolla oppure chiedine uno nuovo.",
      "used": "Questo codice è già stato usato.",
      "revoked": "Questo codice è stato revocato.",
      "emailMismatch": "Il codice è collegato a un'altra email. Usa l'email indicata dal nutrizionista."
    },
    "nameLabel": "Nome completo",
    "confirmPasswordLabel": "Conferma password",
    "registerBtn": "Crea account",
    "haveAccount": "Hai già un account?",
    "loginLink": "Accedi",
    "passwordsDontMatch": "Le password non coincidono",
    "passwordTooShort": "La password deve avere almeno 6 caratteri",
    "forgotPassword": "Password dimenticata?",
    "or": "oppure",
    "invalidCredentials": "Email o password errati."
  },
  "forgot": {
    "tag": "Recupero password",
    "title": "Reimposta la password",
    "subtitle": "Inserisci la tua email: se il tuo account esiste, riceverai un link per creare una nuova password.",
    "tagline": "Ti aiutiamo a rientrare, in sicurezza.",
    "taglineDesc": "Riceverai un link sicuro via email. Il link è valido per 60 minuti.",
    "submitBtn": "Invia link di reset",
    "sentTitle": "Controlla la tua email",
    "sentBody": "Se l'indirizzo che hai inserito corrisponde a un account Solano Essence, riceverai un'email con un link per reimpostare la password.",
    "sentHint": "Non trovi l'email? Controlla spam e cartelle promozionali.",
    "backToLogin": "Torna al login"
  },
  "reset": {
    "tag": "Nuova password",
    "title": "Scegli la tua nuova password",
    "subtitle": "Deve essere di almeno 6 caratteri. Ti connetteremo automaticamente dopo il cambio.",
    "tagline": "Un nuovo inizio, in sicurezza.",
    "taglineDesc": "Dopo aver confermato la nuova password verrai reindirizzato nel tuo spazio personale.",
    "newPasswordLabel": "Nuova password",
    "confirmPasswordLabel": "Conferma nuova password",
    "submitBtn": "Conferma nuova password",
    "success": "Password aggiornata!",
    "invalidTitle": "Link non valido",
    "invalidBody": "Il link è mancante o non è valido. Richiedine uno nuovo dalla schermata Password dimenticata."
  },
  "profileSetup": {
    "hint": "Ultimo passo",
    "title": "Il tuo profilo",
    "subtitle": "Ci servono pochi dati per calcolare automaticamente le tue calorie e i macronutrienti giornalieri.",
    "goalLabel": "Il tuo obiettivo",
    "activityLabel": "Livello di attività",
    "submit": "Calcola e continua",
    "skip": "Salta per ora",
    "savedOk": "Profilo salvato — calorie calcolate!",
    "privacyNote": "Potrai modificare questi valori in qualsiasi momento dal Profilo.",
    "errAge": "Età non valida (10-120)",
    "errHeight": "Altezza non valida (100-250 cm)",
    "errWeight": "Peso non valido (30-300 kg)"
  },
  "onboarding": {
    "welcome": "Benvenuto",
    "title": "Come vuoi usare l'app?",
    "subtitle": "Scegli il tuo ruolo per continuare. Potrai sempre contattare il supporto per modificarlo.",
    "nutTitle": "Sono il Nutrizionista",
    "nutDesc": "Gestisci clienti, crea piani alimentari con AI, monitora progressi e appuntamenti.",
    "cliTitle": "Sono un Cliente",
    "cliDesc": "Segui il piano assegnato, traccia peso e misure, registra i pasti, prenota consulti.",
    "inviteTitle": "Codice invito",
    "inviteDesc": "Inserisci il codice fornito dal tuo nutrizionista per collegare il tuo profilo.",
    "inviteLabel": "Codice invito",
    "invitePlaceholder": "ES. A1B2C3D4",
    "linkMe": "Collegami",
    "inviteRequired": "Inserisci il codice invito",
    "inviteInvalid": "Codice non valido",
    "linkedOk": "Collegato al tuo nutrizionista!",
    "yourCode": "Il tuo codice invito",
    "shareCodeDesc": "Condividi questo codice con i tuoi clienti: lo useranno per collegarsi al tuo studio.",
    "goToDash": "Vai al pannello →",
    "clientOptionsTitle": "Come vuoi iniziare?",
    "clientOptionsDesc": "Puoi collegarti subito a un nutrizionista con un codice invito, oppure iniziare da solo. Potrai collegare un nutrizionista in qualsiasi momento dal tuo profilo.",
    "recommended": "Consigliato",
    "withInviteTitle": "Ho un codice invito",
    "withInviteDesc": "Il tuo nutrizionista ti ha fornito un codice — collegati al suo studio.",
    "orNoCode": "Oppure",
    "soloTitle": "Uso l'app in autonomia",
    "soloDesc": "Traccia i tuoi progressi da solo. Puoi collegare un nutrizionista quando vuoi.",
    "soloFeat1": "Traccia peso, misure e obiettivi",
    "soloFeat2": "Diario alimentare giornaliero",
    "soloFeat3": "Collega WHOOP, Apple Health e altri wearable",
    "startSolo": "Inizia da solo",
    "canLinkLater": "Potrai collegare un nutrizionista più tardi dal profilo.",
    "soloOk": "Benvenuto! Puoi iniziare a tracciare i tuoi progressi."
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Clienti",
    "appointments": "Appuntamenti",
    "myPlan": "Il mio piano",
    "weeklyMenu": "Menu settimanale",
    "diary": "Diario alimentare",
    "progress": "Progressi",
    "profile": "Profilo",
    "chat": "Chat",
    "recipes": "Ricette",
    "workouts": "Allenamenti",
    "pantry": "Dispensa",
    "friends": "Amici",
    "restaurant": "Al ristorante",
    "plate": "Piatto",
    "menu": "Menu",
    "openMenu": "Apri il menu"
  },
  "plate": {
    "title": "Il Principio del Piatto Solano Essence",
    "builder": {
      "title": "Componi il tuo piatto equilibrato",
      "subtitle": "Crea il tuo pasto – semplice e senza contare le calorie.",
      "chooseVeg": "Scegli prima le tue verdure.",
      "addProtein": "Ottimo! Ora manca una fonte di proteine.",
      "addCarbs": "Aggiungi ancora carboidrati complessi.",
      "moreVeg": "Quasi fatto – ancora un po' di verdure!",
      "balanced": "Il tuo piatto è equilibrato!",
      "fatsExtra": "piccolo extra",
      "actPhoto": "Fotografa il piatto",
      "actPantry": "Dalla dispensa",
      "actSuggest": "Suggerisci un piatto",
      "actSave": "Salva come pasto",
      "actGenerate": "Genera ricetta",
      "genBusy": "Creo la tua ricetta…",
      "genDone": "Ricetta creata! Sto generando la foto…",
      "saved": "Pasto salvato! Lo trovi nel diario.",
      "reset": "Svuota il piatto",
      "ruleTip1": "Le proteine saziano e proteggono i muscoli – es. pollo, pesce, uova, tofu o legumi.",
      "ruleTip2": "Le verdure danno volume, vitamine e fibre con poche calorie.",
      "ruleTip3": "Le bevande zuccherate sono calorie nascoste – acqua o tè non zuccherato sono la scelta migliore."
    },
    "check": {
      "btn": "Controllo foto del piatto",
      "busy": "Analizzo il tuo piatto…",
      "hint": "Fotografa il tuo piatto – l'AI verifica la distribuzione 50/25/25.",
      "resultTitle": "Il tuo controllo piatto",
      "detected": "Rilevato",
      "missing": "Manca ancora",
      "fatsSeen": "Grassi sani rilevati",
      "noFood": "Nessun cibo rilevato – fotografa il tuo piatto.",
      "reward": "+15 punti Solano per il tuo piatto equilibrato!"
    },
    "subtitle": "Pasti equilibrati senza contare ogni caloria",
    "intro": "Mangiare sano non deve essere complicato. Con il Principio del Piatto Solano Essence puoi creare pasti equilibrati semplicemente guardando le proporzioni nel tuo piatto, senza contare ogni caloria.",
    "centerLabel": "Il tuo piatto",
    "ofYourPlate": "del tuo piatto",
    "slice": {
      "veg": "Verdure",
      "protein": "Proteine",
      "carbs": "Carboidrati complessi"
    },
    "items": {
      "veg": [
        "Insalata",
        "Broccoli",
        "Zucchine",
        "Peperoni",
        "Pomodori",
        "Cavolfiore",
        "Verdure di stagione",
        "Spinaci",
        "Carote",
        "Cetriolo",
        "Melanzane",
        "Zucca",
        "Funghi",
        "Finocchio",
        "Rucola"
      ],
      "protein": [
        "Pollo",
        "Tacchino",
        "Pesce",
        "Uova",
        "Skyr",
        "Quark magro",
        "Tofu",
        "Legumi",
        "Salmone",
        "Tonno",
        "Gamberi",
        "Tempeh",
        "Fiocchi di latte",
        "Manzo magro"
      ],
      "carbs": [
        "Riso",
        "Pasta integrale",
        "Patate",
        "Avena",
        "Quinoa",
        "Pane integrale",
        "Patate dolci",
        "Bulgur",
        "Miglio",
        "Cuscus integrale"
      ],
      "fats": [
        "Olio extravergine d'oliva",
        "Avocado",
        "Frutta secca",
        "Semi",
        "Mandorle",
        "Noci",
        "Semi di lino",
        "Semi di chia"
      ]
    },
    "fats": {
      "title": "Grassi sani con moderazione",
      "subtitle": "Non hanno una fetta dedicata: aggiungili in piccole quantità a ogni pasto."
    },
    "rules": {
      "title": "Le 3 regole Solano Essence",
      "r1": "Inserisci una fonte di proteine in ogni pasto.",
      "r2": "Riempi metà del piatto con verdure.",
      "r3": "Bevi principalmente acqua e limita le bevande zuccherate."
    }
  },
  "plateCheck": {
    "title": "Piatto Solano",
    "tipPrefix": "Suggerimento:",
    "slice": {
      "veg": "Verdure",
      "protein": "Proteine",
      "carbs": "Carbo",
      "fats": "Grassi buoni"
    },
    "assigned": "Assegnazione",
    "extras": "Extra",
    "unknown": "Non riconosciuto",
    "notDetected": "non riconosciuto – da verificare",
    "fatsMissing": "assenti – es. olio d'oliva, avocado, noci",
    "fatsHint": "Elemento a lato del piatto, non parte della ripartizione 50/25/25.",
    "satFatTitle": "Parecchi grassi saturi oggi:",
    "satFatHint": "nessun problema ogni tanto – domani preferisci olio d'oliva, noci o pesce.",
    "editAssign": "Modifica",
    "verdict": {
      "excellent": "Ottimo equilibrio 50/25/25",
      "good": "Buon equilibrio",
      "adjust": "Da riequilibrare"
    },
    "tip": {
      "more_veg": "aumenta le verdure — dovrebbero coprire metà del piatto.",
      "more_protein": "aggiungi una fonte di proteine (pollo, pesce, uova, legumi).",
      "less_carbs": "riduci un po' i carboidrati e sposta lo spazio sulle verdure.",
      "less_protein": "le proteine sono in eccesso — bilancia con verdure e cereali integrali.",
      "rebalance": "prova a distribuire meglio le porzioni verso il 50/25/25.",
      "add_fats": "aggiungi una fonte di grassi buoni: 1 cucchiaio d'olio d'oliva, ½ avocado o una manciata di noci.",
      "swap_fats": "sostituisci parte dei grassi saturi (burro, panna, salumi) con olio d'oliva, avocado o pesce."
    }
  },
  "plateHistory": {
    "title": "Andamento Piatto",
    "subtitle": "Ultimi {days} giorni",
    "average": "Media 7gg",
    "empty": "Ancora nessun dato",
    "dataDays": "{n} giorni con dati",
    "targetShort": "target 50/25/25"
  },
  "plateToday": {
    "target": "Obiettivo",
    "tomorrow": "Migliora domani",
    "keepUp": "Continua così — oggi il tuo piatto era equilibrato!",
    "shareTitle": "Condividi il piatto Solano",
    "storyKicker": "Il mio piatto oggi",
    "detailsLink": "Apri Piatto Solano",
    "summary": {
      "excellent": "oggi il tuo piatto era quasi perfettamente bilanciato.",
      "good": "oggi il tuo piatto era buono — piccoli ritocchi aiutano.",
      "adjust": "La distribuzione si discosta dal principio del piatto. Verifica gli alimenti riconosciuti e le porzioni."
    },
    "title": "Piatto di oggi",
    "plateOn": "Piatto del",
    "empty": "Non hai loggato pranzo o cena",
    "emptyHint": "Il Piatto Solano si calcola sui pasti principali."
  },
  "workouts": {
    "last30": "Ultimi 30 giorni",
    "title": "Allenamenti",
    "subtitle": "Traccia cardio, palestra e stretching",
    "newBtn": "Nuovo allenamento",
    "dialogTitle": "Registra allenamento",
    "typeLabel": "Tipo",
    "typeCardio": "Cardio",
    "typeStrength": "Palestra",
    "typeFlexibility": "Stretching",
    "typeSport": "Sport",
    "typeOther": "Altro",
    "nameLabel": "Nome",
    "namePlaceholder": "Es. Corsa parco, Push day…",
    "dateLabel": "Data",
    "durationLabel": "Durata (min)",
    "intensityLabel": "Intensità",
    "intensity_low": "Bassa",
    "intensity_medium": "Media",
    "intensity_high": "Alta",
    "kcalLabel": "Kcal bruciate",
    "kcalAuto": "auto",
    "kcalHint": "Lascia vuoto per stima automatica in base al peso e all'intensità.",
    "exercisesLabel": "Esercizi",
    "addExercise": "Aggiungi esercizio",
    "addSet": "Aggiungi serie",
    "exercisePh": "Es. Panca piana, Squat…",
    "reps": "rip",
    "notesLabel": "Note",
    "notesPh": "Come è andato l'allenamento?",
    "save": "Salva",
    "saved": "Allenamento salvato",
    "needName": "Inserisci un nome",
    "deleted": "Allenamento eliminato",
    "confirmDelete": "Eliminare questo allenamento?",
    "planned": "Pianificato",
    "emptyState": "Nessun allenamento ancora. Registra il tuo primo!",
    "weekCount": "Sessioni 7gg",
    "weekMin": "Minuti 7gg",
    "weekKcal": "Kcal 7gg",
    "workout": "allenamento",
    "workoutsShort": "allenamenti",
    "markDone": "Ho fatto training",
    "markSkip": "Non oggi",
    "markSkipOk": "Registrato — nessun training oggi",
    "markSkipError": "Non ho salvato, riprova?",
    "markRestDay": "Riposo",
    "planTrainingCta": "Pianifica allenamento",
    "addAnotherCta": "Aggiungi un altro allenamento",
    "dayIsRestDay": "Giorno di riposo",
    "dayIsPlanned": "Allenamento pianificato oggi",
    "dayIsPlannedFuture": "Giorno di allenamento pianificato",
    "dayIsFuture": "Giorno futuro",
    "dayIsFree": "Giorno libero",
    "unskipCta": "Ho comunque allenato?",
    "unskipOk": "Giorno di riposo rimosso",
    "changeReasonCta": "Cambia motivo",
    "pickReasonTitle": "Cosa è successo oggi?",
    "reasonRestDay": "Riposo",
    "reasonSick": "Malato",
    "reasonNoTime": "Poco tempo",
    "reasonPain": "Dolori",
    "reasonOther": "Altro",
    "skipNoReason": "Senza motivo",
    "skipNoReasonCta": "Salva senza motivo",
    "calLegendSkip": "Riposo",
    "calLegendRecovery": "Recovery",
    "dayIsRecovery": "Riposo consapevole",
    "recoveryQuote": "Il recupero fa parte del progresso. Il tuo corpo diventa più forte nelle pause.",
    "recoveryDoneTitle": "Il recupero è progresso",
    "recoveryStreakStrip": "Recovery Streak: {n} settimana",
    "recoveryNextBadge": "Prossimo livello",
    "recoveryWeeksUnit": "settimane",
    "badge_recovery_starter": "🌿 Recovery Starter",
    "badge_recovery_balance": "🌙 Recovery Balance",
    "badge_regeneration_pro": "🧘 Pro del recupero",
    "trainingPlanTag": "Il mio piano di allenamento",
    "trainingPlanEmpty": "Nessun giorno ancora impostato",
    "trainingPlanQ": "In quali giorni ti alleni di solito?",
    "trainingPlanHint": "I giorni non selezionati non vengono conteggiati automaticamente come giorni di riposo.",
    "trainingPlanApply": "Applica",
    "trainingPlanSaved": "Piano salvato",
    "trainingPlanTypeTitle": "Tipo di allenamento per giorno",
    "skipNudgeTag": "Va tutto bene",
    "skipNudgeTitle": "{n} giorni di riposo di fila — vuoi riorganizzare?",
    "skipNudgeBody": "Nessuno stress. Scegli altri giorni che si adattano meglio alla tua settimana. Ti seguiamo lo stesso.",
    "skipNudgeCta": "Cambia i miei giorni",
    "skipNudgeLater": "Magari più tardi",
    "calLegendDone": "Allenamento",
    "calLegendToday": "Oggi",
    "calLegendSelected": "Selezionato",
    "calLegendPlanned": "In programma",
    "todayCount": "oggi",
    "kcalEstimatedTip": "Stima kcal (basata sul peso e MET)",
    "totalSets": "Serie totali",
    "totalVolume": "Volume totale",
    "noExtraDetails": "Nessun dettaglio aggiuntivo.",
    "settingKcalInBudgetLabel": "Predefinito per i nuovi giorni: aggiungi kcal bruciate al budget",
    "settingKcalInBudgetHelp": "Es. 2000 kcal + 300 bruciate = 2300 disponibili. Puoi cambiarlo giorno per giorno dalla dashboard.",
    "kcalBudgetShort": "Kcal-budget con workout",
    "kcalBudgetOn": "Kcal workout ora nel budget",
    "kcalBudgetOff": "Kcal workout separate dal budget",
    "wearableReadOnly": "Sincronizzato dal wearable — non modificabile qui"
  },
  "workoutPhoto": {
    "openBtn": "Da foto",
    "title": "Aggiungi da foto",
    "subtitle": "Scatta o carica lo screenshot di riepilogo Speediance (o Apple Fitness, Garmin, ecc.). L'AI estrae durata, kcal e tipo.",
    "pickPhoto": "Scatta o scegli foto",
    "hint": "Il riepilogo di fine allenamento funziona meglio",
    "batchHint": "Puoi selezionare più foto insieme (fino a tutta la settimana)",
    "analyzing": "Analisi in corso…",
    "analyzingBatch": "Analisi {done}/{total}…",
    "notRecognized": "Nessuna foto è un riepilogo allenamento riconoscibile.",
    "itemNotRecognized": "Non riconosciuto",
    "extracted": "Dati estratti — verifica prima di salvare",
    "extractedBatch": "{ok} allenamenti riconosciuti · {err} non riconosciuti",
    "name": "Nome",
    "type": "Tipo",
    "date": "Data",
    "dateAutoTooltip": "Data estratta automaticamente dall'immagine",
    "duration": "Durata (min)",
    "durationShort": "min",
    "kcal": "Kcal",
    "intensity": "Intensità",
    "notes": "Note",
    "low": "Bassa",
    "medium": "Media",
    "high": "Alta",
    "types": {
      "strength": "Palestra",
      "cardio": "Cardio",
      "flexibility": "Stretching",
      "sport": "Sport",
      "other": "Altro"
    },
    "retake": "Riprova",
    "save": "Salva allenamento",
    "saveAll": "Salva tutti ({n})",
    "savedToast": "Allenamento salvato dalla foto",
    "batchSavedToast": "{n} allenamenti salvati dalle foto",
    "batchFailedToast": "{n} allenamenti non salvati"
  },
  "nutDash": {
    "hello": "Ciao,",
    "subtitle": "Ecco una panoramica del tuo studio.",
    "appStatsTag": "Owner",
    "appStatsTitle": "Statistiche app",
    "appStatsSub": "Tutte le attività dell'app in un colpo d'occhio",
    "inviteCodeTag": "Codice invito studio",
    "inviteShare": "Condividilo con i nuovi clienti per collegarli al tuo studio.",
    "copyCode": "Copia codice",
    "copied": "Copiato!",
    "shareCode": "Condividi",
    "shareMessage": "Ciao! Per collegarti a me sull'app Solano Essence usa questo codice invito:",
    "activeClients": "Clienti attivi",
    "totalClients": "Clienti totali",
    "subtitleToday": "Ecco il tuo riepilogo per oggi.",
    "todayImportant": "Oggi importante",
    "todayImportantEmpty": "Tutto sotto controllo. Niente da fare adesso.",
    "inviteTitle": "Invita un cliente",
    "alertNeverActive": "Mai attivo",
    "alertInactiveSince": "Da",
    "alertDays": "giorni inattivo",
    "alertFading": "Attività in calo",
    "alertContact": "Contatta",
    "alertOpen": "Apri",
    "alertNewLogs": "Nuovi pasti nel diario",
    "alertLogOne": "voce oggi",
    "alertLogMany": "voci oggi",
    "alertOpenFeed": "Vai al feed",
    "alertDaysShort": "giorni",
    "alertKcalOverfix": "(target superato)",
    "alertProteinTarget": "target proteine",
    "pendingRequests": "Richieste in attesa",
    "recentClients": "Ultimi clienti",
    "seeAll": "Tutti",
    "noClients": "Nessun cliente ancora",
    "noClientsDesc": "Condividi il codice invito per iniziare.",
    "thresholdsTag": "Impostazioni",
    "thresholdsTitle": "Regola soglie di alert",
    "thresholdsKcalOver": "Alert kcal sopra target",
    "thresholdsKcalOverHint": "Avvisa quando il cliente supera il target kcal per almeno N giorni",
    "thresholdsProteinLow": "Alert proteine sotto target",
    "thresholdsProteinLowHint": "Avvisa quando il cliente resta sotto il target proteine per almeno N giorni",
    "thresholdsDays": "Giorni",
    "thresholdsThreshold": "Soglia %",
    "thresholdsSave": "Salva",
    "upcomingAppts": "Prossimi appuntamenti",
    "noAppts": "Nessun appuntamento",
    "noApptsDesc": "Le prenotazioni confermate appariranno qui.",
    "open": "Apri",
    "goalToDefine": "obiettivo da definire"
  },
  "clientsList": {
    "filterAll": "Tutti",
    "filterAction": "Da agire",
    "filterCheckin": "Check-in dovuto",
    "filterNew": "Nuovi",
    "msg": "Messaggio",
    "more": "Altro",
    "adherence": "Aderenza",
    "noGoal": "Nessun obiettivo",
    "empty": "Nessun cliente",
    "title": "Clienti",
    "subtitle": "Gestisci il tuo elenco clienti e i loro piani.",
    "searchPh": "Cerca cliente…",
    "emptyDesc": "Condividi il tuo codice invito dalla dashboard per aggiungere clienti.",
    "newBadge": "Nuovo",
    "statusGreen": "In carreggiata",
    "statusAmber": "Attenzione",
    "statusRed": "Azione richiesta"
  },
  "betaInvites": {
    "title": "Inviti Beta",
    "subtitle": "Codici monouso per invitare i tuoi clienti",
    "active": "attivi",
    "newInvite": "Nuovo invito",
    "labelPh": "Nome cliente (facoltativo)",
    "emailPh": "Email cliente (facoltativa)",
    "emailHint": "Aggiungi l'email per assicurarti che solo quel cliente possa usare il codice.",
    "generate": "Genera",
    "created": "Codice creato",
    "empty": "Nessun invito ancora. Genera il primo qui sopra.",
    "usedBy": "usato da",
    "copyCode": "Copia codice",
    "shareLink": "Condividi link",
    "revoke": "Revoca",
    "linkCopied": "Link copiato",
    "shareText": "Ciao {name}! Ecco il tuo invito per Solano Essence:",
    "waTemplate": "Ciao {name}! 👋\n\nBenvenut* in Solano Essence — la tua app di nutrizione personalizzata che ti sto preparando.\n\nRegistrati qui con il tuo codice invito:\n{url}\n\nSe la registrazione ti chiede il codice a mano, usa quello nel link.\n\nA presto! 🥗",
    "sendWhatsApp": "Invia via WhatsApp",
    "showQr": "Mostra QR code",
    "qrTag": "Codice QR",
    "qrTitle": "Invita cliente",
    "qrHint": "Fai scansionare al cliente per aprire la registrazione con il codice già inserito.",
    "defaultName": "cliente",
    "status": {
      "active": "Attivo",
      "used": "Usato",
      "revoked": "Revocato"
    }
  },
  "nutJournal": {
    "title": "Diario del cliente",
    "lastNDays": "Ultimi {n} giorni",
    "empty": "Il cliente non ha ancora scritto note nel diario.",
    "noContent": "Nessuna nota — solo repliche.",
    "replyPlaceholder": "Scrivi una risposta al cliente…",
    "replySent": "Risposta inviata"
  },
  "providerPrefs": {
    "title": "Preferenze dati",
    "subtitle": "Scegli quale dispositivo usare per ogni tipo di dato",
    "noDevices": "Collega prima un dispositivo per impostare le preferenze",
    "auto": "Automatico (max)",
    "saved": "Preferenze salvate",
    "resetBtn": "Reset dati",
    "resetConfirm": "Cancellare tutti i dati wearable degli ultimi 7 giorni? Al prossimo sync verranno ripresi dai provider collegati.",
    "lastEntry": "Ultimo pasto",
    "mWeight": "Peso",
    "mScore": "Score",
    "mAdherence": "Aderenza",
    "mStatus": "Stato",
    "ctaMessage": "Messaggio",
    "ctaCoachAi": "Coach AI",
    "ctaPlan": "Modifica piano",
    "attentionTitle": "Attenzione",
    "checkinTitle": "Check-in cliente",
    "lastCheckin": "Ultimo check-in",
    "nextCheckin": "Prossimo check-in",
    "cadence": "Cadenza",
    "cadWeekly": "Settimanale",
    "cadBiweekly": "Ogni 2 settimane",
    "cadMonthly": "Mensile",
    "lastNote": "Ultima nota",
    "addNote": "Aggiungi nota",
    "notePh": "Cosa è andato bene questa settimana? Cosa manca?",
    "completeCheckin": "Concludi check-in",
    "checkinDone": "Check-in salvato",
    "cadenceSaved": "Cadenza aggiornata",
    "resetDone": "Cancellati {n} giorni. Tocca ora Jetzt synchronisieren.",
    "metric": {
      "sleep": "Sonno",
      "sleepHint": "Ore dormite mostrate nella card SCHLAF",
      "steps": "Passi",
      "stepsHint": "Conteggio passi giornaliero",
      "hrv": "HRV",
      "hrvHint": "Variabilità cardiaca (ms)",
      "resting_hr": "Ruhepuls",
      "resting_hrHint": "Frequenza cardiaca a riposo (bpm)"
    }
  },
  "clientDetail": {
    "heroSection": "Metriche & Coach AI",
    "tabOverview": "Panoramica",
    "tabNutrition": "Nutrizione",
    "tabProgress": "Progresso",
    "tabProfile": "Profilo",
    "tapForDetails": "Tocca per i dettagli",
    "hasComment": "Con commento",
    "noLogsForBadge": "Nessun log",
    "lastEntry": "Ultimo pasto",
    "mWeight": "Peso",
    "mScore": "Score",
    "mAdherence": "Aderenza",
    "mStatus": "Stato",
    "ctaMessage": "Messaggio",
    "ctaCoachAi": "Coach AI",
    "ctaPlan": "Modifica piano",
    "attentionTitle": "Attenzione",
    "checkinTitle": "Check-in cliente",
    "lastCheckin": "Ultimo check-in",
    "nextCheckin": "Prossimo check-in",
    "cadence": "Cadenza",
    "cadWeekly": "Settimanale",
    "cadBiweekly": "Ogni 2 settimane",
    "cadMonthly": "Mensile",
    "lastNote": "Ultima nota",
    "addNote": "Aggiungi nota",
    "notePh": "Cosa e' andato bene questa settimana? Cosa manca?",
    "completeCheckin": "Concludi check-in",
    "checkinDone": "Check-in salvato",
    "cadenceSaved": "Cadenza aggiornata",
    "tileAdherence": "Aderenza",
    "tileAdherenceSub": "14 giorni",
    "tileJournal": "Diario cliente",
    "tileJournalSub": "30 giorni",
    "tileProfile": "Profilo",
    "tileProfileSub": "Obiettivo, età, altezza",
    "tileTrends": "Trends",
    "tileTrendsSub": "Peso e aderenza",
    "tileWearable": "Wearable",
    "tileWearableSub": "HRV, sonno, passi",
    "tileDiary": "Diario alimentare",
    "tileDiarySub": "Pasti e commenti",
    "profile": "Profilo",
    "goal": "Obiettivo",
    "activity": "Attività",
    "sport": "Sport",
    "height": "Altezza",
    "startingWeight": "Peso iniziale",
    "kcalTarget": "Target kcal",
    "allergies": "Allergie",
    "weightTrend": "Andamento peso",
    "needMoreWeights": "Il cliente non ha ancora registrato pesate sufficienti.",
    "currentPlan": "Piano attuale",
    "noPlan": "Nessun piano assegnato.",
    "planTargetsTitle": "Obiettivi del piano",
    "avgIntakeTitle": "Consumo medio (ultimi 7 giorni)",
    "avgIntakeEmpty": "Nessun pasto registrato negli ultimi 7 giorni.",
    "microsTitle": "Micronutrienti medi",
    "dailyAverage": "media giornaliera",
    "recentLogs": "Diario alimentare cliente",
    "noLogs": "Nessun log registrato.",
    "noLogsForDay": "Nessun log per questo giorno.",
    "jumpToDay": "Vai al giorno",
    "today": "Oggi",
    "yesterday": "Ieri",
    "quickNotes": "Note rapide",
    "clientReplyLabel": "Risposta del cliente",
    "qn_great": "Ottimo pasto",
    "qn_portion": "Attenzione alla porzione",
    "qn_veggies": "Aggiungi verdure",
    "qn_protein": "Più proteine",
    "qn_water": "Bevi di più",
    "qn_carbs": "Riduci carboidrati",
    "qn_timing": "Rivedi orari pasti",
    "qn_sugar": "Attenzione agli zuccheri",
    "commentTitle": "Commenta il pasto",
    "commentLabel": "Il tuo commento (visibile al cliente)",
    "commentPlaceholder": "Scrivi un feedback breve al cliente…",
    "commentSaved": "Commento inviato al cliente",
    "commentCleared": "Commento rimosso",
    "createPlan": "Crea piano",
    "updatePlan": "Aggiorna piano",
    "weeklyPreview": "PDF settimanale",
    "weeklySend": "Invia ora",
    "weeklyLoading": "Generazione PDF…",
    "weeklySending": "Invio in corso…",
    "weeklySent": "Report inviato via email",
    "backClients": "Clienti",
    "monthlyReport": "Report mensile",
    "printPdf": "Stampa / PDF",
    "period": "Periodo",
    "client": "Cliente",
    "startWeight": "Peso inizio",
    "endWeight": "Peso fine",
    "delta": "Delta",
    "diaryDays": "Giorni diario",
    "avgKcalDay": "Kcal medie/gg",
    "avgWaterDay": "Acqua media/gg",
    "glasses": "bic.",
    "avgSleep": "Sonno medio",
    "avgHrv": "HRV media",
    "progressPhotosTitle": "Foto progresso",
    "reportFooter": "Pasti totali: {meals} · Foto progresso: {photos} · FC riposo media: {rhr}"
  },
  "builder": {
    "title": "Costruttore piano alimentare",
    "for": "Per",
    "aiTitle": "Generatore AI (GPT-5.2)",
    "aiDesc": "Precompila un piano basato sul profilo del cliente. Poi modifica liberamente.",
    "caloriesTarget": "Calorie target",
    "preferences": "Preferenze / note",
    "preferencesPh": "es. no lattosio, tanto pesce, colazione dolce",
    "generate": "Genera con AI",
    "generating": "Genero…",
    "titleField": "Titolo",
    "clientNotes": "Note per il cliente",
    "addMeal": "Aggiungi pasto",
    "addDay": "Aggiungi giornata (es. allenamento)",
    "savePlan": "Salva piano",
    "mealName": "Nome pasto",
    "mealTime": "Ora",
    "mealDesc": "Descrizione (alimenti, quantità)",
    "generatedOk": "Piano generato con AI. Puoi modificarlo e salvarlo.",
    "savedOk": "Piano salvato e assegnato al cliente",
    "defaultDayLabel": "Giorno tipo",
    "trainingDayLabel": "Giorno allenamento",
    "dayTypeGeneric": "generico",
    "dayTypeTraining": "allenamento",
    "dayTypeRest": "riposo",
    "aiErrorPrefix": "Errore AI"
  },
  "apptsNut": {
    "title": "Appuntamenti",
    "subtitle": "Gestisci le richieste di prenotazione dei tuoi clienti.",
    "pendingSection": "Richieste in attesa",
    "confirmedSection": "Confermati",
    "archiveSection": "Archivio",
    "markDone": "Segna come svolto",
    "empty": "Nessun elemento",
    "confirmed": "Confermato",
    "cancelled": "Annullato",
    "updated": "Aggiornato"
  },
  "shop": {
    "unknown": {
      "title": "Prodotto sconosciuto – aiuta Solano a impararlo",
      "subtitle": "Fotografa la tabella nutrizionale. L’IA legge i valori, tu confermi – e alla prossima scansione Solano riconosce subito il prodotto.",
      "photoLabel": "Fotografa la tabella nutrizionale",
      "analyzing": "L’IA sta leggendo la tabella …",
      "manual": "Inserisci manualmente",
      "analyzeFailed": "Tabella illeggibile – rifai la foto o inserisci manualmente.",
      "aiRead": "Letto dall’IA – controlla rapidamente",
      "name": "Nome prodotto",
      "brand": "Marca",
      "serving": "Porzione (es. 30 g)",
      "ingredients": "Ingredienti (facoltativo, per il bonus mediterraneo)",
      "save": "Salva e valuta",
      "saved": "Prodotto salvato – grazie!",
      "nameRequired": "Inserisci un nome prodotto.",
      "shared": "I prodotti appresi sono disponibili per tutti gli utenti Solano.",
      "f": {
        "kcal": "kcal",
        "protein": "Proteine g",
        "carbs": "Carboidrati g",
        "sugar": "Zuccheri g",
        "fat": "Grassi g",
        "satfat": "Grassi sat. g",
        "fiber": "Fibre g",
        "salt": "Sale g"
      }
    },
    "logToDiary": "Nel diario",
    "perServing": "Valori per porzione ({s})",
    "show100": "mostra per 100 g",
    "showServing": "mostra per porzione",
    "clearConfirm": "Svuotare davvero la cronologia?",
    "yes": "Sì",
    "no": "No",
    "disclaimer": "Il punteggio Solano è un orientamento e non sostituisce una consulenza nutrizionale o medica.",
    "info": {
      "scores": "Nutri-Score: valutazione ufficiale del prodotto (A–E). Punteggio Solano: la nostra valutazione 0–100, su misura per il tuo obiettivo.",
      "thresholds": "Livelli: da 70 «Compralo» · 40–69 «Ok con moderazione» · sotto 40 «Meglio di no».",
      "how": "Come nasce il punteggio: base dal Nutri-Score, poi più/meno per zuccheri, grassi saturi, sale, fibre, proteine, grado di lavorazione, additivi e ingredienti mediterranei – pesati sul tuo obiettivo."
    },
    "med": {
      "med_good_ingredients": "Adatto alla dieta mediterranea: buoni ingredienti",
      "med_good_natural": "Adatto alla dieta mediterranea: poco lavorato",
      "med_neutral": "Mediterraneo neutro – ok con moderazione",
      "med_poor_processed": "Poco mediterraneo: ultra-processato",
      "med_poor_sugar": "Poco mediterraneo: molto zucchero o dolcificanti"
    },
    "altTip": {
      "food": "Consiglio del coach: scegli basi non lavorate – yogurt bianco, skyr, frutta secca, frutta o integrale battono qualsiasi prodotto pronto.",
      "beverage": "Consiglio del coach: acqua, tè o caffè non zuccherato – con limone o menta se vuoi più gusto."
    },
    "addToList": "Aggiungi alla lista della spesa",
    "onList": "In lista",
    "addedToList": "Aggiunto alla lista della spesa",
    "alreadyOnList": "È già nella tua lista della spesa",
    "listTicked": "Spuntato e messo in dispensa: {name}",
    "listTickedTitle": "Spuntato dalla lista – ora in dispensa",
    "verifiedSeal": "Verificato da Solano",
    "verifiedHint": "I valori nutrizionali di questo prodotto sono stati controllati dal team Solano.",
    "miniList": {
      "title": "La tua lista della spesa",
      "open": "{n} da comprare",
      "more": "+{n} altri"
    },
    "openList": "Apri lista",
    "per100g": "Valori per 100 g",
    "per100ml": "Bevanda – valori per 100 ml",
    "stats": {
      "title": "Il tuo bilancio spesa",
      "smartRate": "Quante volte hai scelto «Compralo» invece di «Meglio di no» negli ultimi {days} giorni",
      "summary": "{total} scansioni · punteggio medio {avg}"
    },
    "altTitle": "Alternativa migliore",
    "altLoading": "Cerco un’alternativa più sana …",
    "altTap": "Tocca per i dettagli",
    "title": "Check spesa",
    "subtitle": "Scansiona un prodotto al supermercato – Solano ti dice se merita il carrello.",
    "hint": "Inquadra il codice a barre (EAN)",
    "enterManually": "Inserisci il codice manualmente",
    "checking": "Controllo del prodotto …",
    "notFound": "Prodotto non trovato – prova un altro codice.",
    "error": "Controllo non riuscito. Riprova.",
    "solanoScore": "Solano Score",
    "verdict": {
      "buy": "Compralo",
      "moderate": "Ok con moderazione",
      "avoid": "Meglio di no"
    },
    "goal": {
      "lose": "Pesato per il tuo obiettivo: dimagrire",
      "gain": "Pesato per il tuo obiettivo: massa muscolare",
      "maintain": "Valutazione equilibrata"
    },
    "reason": {
      "sugar_high": "Molto zucchero: {v} g/100 g",
      "sugar_mid": "Tanto zucchero: {v} g/100 g",
      "sugar_low": "Poco zucchero: {v} g/100 g",
      "satfat_high": "Molti grassi saturi: {v} g/100 g",
      "satfat_mid": "Un po’ di grassi saturi: {v} g/100 g",
      "salt_high": "Molto sale: {v} g/100 g",
      "salt_mid": "Un po’ di sale: {v} g/100 g",
      "fiber_high": "Ricco di fibre: {v} g/100 g",
      "fiber_mid": "Buone fibre: {v} g/100 g",
      "protein_high": "Ricco di proteine: {v} g/100 g",
      "protein_mid": "Buona fonte proteica: {v} g/100 g",
      "kcal_high": "Molto calorico: {v} kcal/100 g",
      "nova_4": "Ultra-processato (NOVA 4)",
      "nova_3": "Processato (NOVA 3)",
      "nova_1": "Non processato (NOVA 1)",
      "additives": "{v} additivi",
      "med_olive": "Mediterraneo: olio d’oliva / olive",
      "med_nuts": "Mediterraneo: frutta secca / mandorle",
      "med_wholegrain": "Mediterraneo: integrale",
      "med_legumes": "Mediterraneo: legumi",
      "med_fish": "Mediterraneo: pesce",
      "palm_oil": "Contiene olio di palma",
      "few_ingredients": "Lista ingredienti corta – poco lavorato",
      "bev_water": "Acqua – la scelta migliore",
      "bev_unsweetened": "Non zuccherato, quasi senza calorie",
      "bev_sugar_high": "Bevanda zuccherata: {v} g di zucchero/100 ml",
      "bev_sugar_mid": "Molto zucchero: {v} g/100 ml",
      "bev_sugar_some": "Un po’ di zucchero: {v} g/100 ml",
      "bev_sugar_low": "Poco zucchero: {v} g/100 ml",
      "bev_kcal_high": "Calorie liquide: {v} kcal/100 ml",
      "sweeteners": "Contiene dolcificanti",
      "fruit_juice": "Succo 100 % frutta (zucchero naturale)",
      "alcohol": "Bevanda alcolica"
    },
    "coach": "Coach",
    "coachThinking": "Il tuo coach ci sta dando un’occhiata …",
    "coachUnavailable": "Commento del coach non disponibile al momento.",
    "n": {
      "kcal": "kcal",
      "protein": "Proteine",
      "sugar": "Zuccheri",
      "salt": "Sale"
    },
    "next": "Scansiona il prossimo",
    "logAnyway": "Registra comunque",
    "history": "Scansionati di recente",
    "clear": "Svuota",
    "emptyHistory": "I prodotti scansionati appariranno qui per confrontarli.",
    "cameraStarting": "Avvio fotocamera …",
    "retry": "Riprova",
    "fromPhoto": "Da foto",
    "err": {
      "permission": "Accesso alla fotocamera negato. Consentilo nelle Impostazioni o usa una foto.",
      "nodevice": "Nessuna fotocamera trovata.",
      "generic": "Impossibile avviare la fotocamera.",
      "notfound": "Nessun codice a barre rilevato nella foto."
    }
  },
  "quickTrack": {
    "title": "Traccia rapidamente",
    "qrScan": "Scansiona QR ricetta",
    "addMeal": "Aggiungi pasto",
    "photo": "Foto AI",
    "voice": "Voce",
    "barcode": "Scanner EAN",
    "shop": "Check spesa",
    "fridge": "Dal frigorifero",
    "search": "Cerca alimento",
    "manual": "Inserimento manuale"
  },
  "cliDash": {
    "weightSaved": "Peso salvato",
    "hi": "Ciao,",
    "waterUndo": "Annulla",
    "waterCustom": "Custom",
    "waterCustomPh": "es. 330",
    "waterSettings": "Impostazioni acqua",
    "waterTargetLabel": "Obiettivo giornaliero (litri)",
    "foodWater": "+ Acqua dagli alimenti: ~{ml} ml",
    "waterContainers": "I tuoi contenitori",
    "waterAddContainer": "+ Contenitore",
    "waterContainerNamePh": "Nome (es. borraccia)",
    "checkinTitle": "Check-in del giorno",
    "checkinOutTitle": "Check-in / Check-out",
    "checkinSection": "Check-in · Mattina",
    "checkoutSection": "Check-out · Sera",
    "checkoutMoodQ": "Come finisce la tua giornata?",
    "checkoutSave": "Completa il check-out",
    "checkoutSaved": "Check-out salvato ✓",
    "checkinMoodQ": "Com'è andata la giornata?",
    "checkinEnergyQ": "Com'è la tua energia?",
    "checkinNotePh": "Nota opzionale …",
    "checkinSave": "Completa il check-in",
    "checkinSaved": "Check-in salvato ✓",
    "checkinDone": "Fatto",
    "of": "di",
    "kcalBurnedShort": "Bruciate",
    "changePhoto": "Cambia foto",
    "removePhoto": "Rimuovi foto",
    "avatarUpdated": "Foto profilo aggiornata",
    "avatarRemoved": "Foto profilo rimossa",
    "avatarFrame": "Cornice",
    "avatarFrameUpdated": "Cornice aggiornata",
    "avatarZoom": "Zoom",
    "editAvatar": "Centra la foto",
    "journey": "Il tuo percorso inizia da qui.",
    "currentWeight": "Peso attuale",
    "logWeightLabel": "Registra pesata (kg)",
    "logWeightBtn": "Salva",
    "weightLogged": "Peso registrato",
    "sinceStart": "dall'inizio",
    "nextAppt": "Prossimo appuntamento",
    "noneProgrammed": "Nessuno programmato.",
    "book": "Prenota",
    "yourPlan": "Il tuo piano",
    "seeDetail": "Vedi dettaglio →",
    "noPlanAssigned": "Il nutrizionista non ha ancora assegnato un piano.",
    "otherMeals": "altri pasti",
    "goals": "I tuoi obiettivi",
    "today": "Oggi",
    "yesterday": "Ieri",
    "tomorrow": "Domani",
    "calories": "Calorie",
    "kcalLeft": "rimaste",
    "kcalOver": "in eccesso",
    "kcalTooLow": "troppo poche",
    "kcalBurned": "kcal attività quotidiana",
    "aiQuotaLeft": "Ancora {n} di {total} azioni AI gratuite questo mese",
    "aiQuotaTitle": "Analisi foto gratuite",
    "aiQuotaUsed": "{used} di {total} usate",
    "aiQuotaLeftShort": "Ancora {n} questo mese",
    "aiQuotaNoneLeft": "Tutte esaurite — si azzera il mese prossimo",
    "aiQuotaPro": "Illimitate con Pro",
    "kcalInfoTitle": "Come si calcolano le kcal?",
    "kcalInfoTotalHint": "movimento quotidiano di oggi (totale Apple Health meno kcal dei workout) — senza allenamenti.",
    "kcalInfoWorkoutHint": "in più dai workout loggati (WHOOP + manuali, dedup ±5 min).",
    "kcalInfoFallback": "Senza sync Apple Health l'attività quotidiana è stimata dai passi (~0,04 kcal a passo).",
    "kcalConsumed": "assunte",
    "kcalTarget": "obiettivo",
    "workoutBonus": "workout",
    "nextMealSuggest": "Prossimo: {meal} ~{kcal} kcal",
    "nextMealDone": "Ottimo lavoro oggi!",
    "steps": "passi",
    "hydration": "acqua",
    "goal": "obiettivo",
    "setKcalTarget": "Imposta obiettivo kcal",
    "editKcalTitle": "Obiettivo calorico giornaliero",
    "editKcalHint": "Definisci quante calorie vuoi consumare in un giorno.",
    "saveTarget": "Salva obiettivo",
    "planCtaTitle": "Obiettivi giornalieri & ripartizione macro",
    "planCtaHint": "Preset (Bilanciato, Low Carb, High Protein) e tutti gli obiettivi in autonomia",
    "targetSaved": "Obiettivo aggiornato",
    "kcalRange": "Inserisci un valore tra 500 e 6000",
    "macros": "Macronutrienti",
    "carbs": "Carboidrati",
    "protein": "Proteine",
    "fat": "Grassi",
    "sugar": "Zuccheri",
    "fiber": "Fibre",
    "satFat": "Sat.",
    "salt": "Sale",
    "microsInfo": "Zuccheri (max 50g OMS), Fibre (30g/giorno), Grassi saturi (max 10% kcal), Sale (max 5g OMS)",
    "showDetails": "Mostra zuccheri · fibre · sale",
    "hideDetails": "Nascondi dettagli",
    "mealsToday": "Pasti di oggi",
    "tapToAddMeal": "Tocca + per aggiungere un pasto",
    "mealEmpty": "Nessun pasto aggiunto",
    "oneMeal": "1 alimento",
    "manyMeals": "alimenti",
    "addMeal": "Aggiungi pasto",
    "aiScan": "Scansiona con AI",
    "openDiary": "Apri diario",
    "openPlan": "Vedi il piano",
    "activities": "Attività",
    "connectDevice": "Collega dispositivo",
    "noPlanShort": "Nessun piano ancora"
  },
  "myPlan": {
    "title": "Il mio piano",
    "subtitle": "Il piano alimentare personalizzato del tuo nutrizionista.",
    "empty": "Nessun piano assegnato",
    "emptyDesc": "Il tuo nutrizionista te lo assegnerà a breve.",
    "notLinkedTitle": "Collegati al tuo nutrizionista",
    "notLinkedDesc": "Inserisci il codice invito che ti ha fornito il tuo nutrizionista per ricevere il piano personalizzato.",
    "notLinkedHint": "Il codice è composto da 6 caratteri (es. ABC123). Se non ce l'hai, chiedilo al tuo nutrizionista.",
    "translateBtn": "Traduci in italiano",
    "translateOriginal": "Vedi originale",
    "translating": "Traduco…",
    "translatedBadge": "Tradotto",
    "translateError": "Errore nella traduzione"
  },
  "feed": {
    "title": "Feed clienti",
    "subtitle": "Tutte le attività dei tuoi clienti in ordine cronologico. Tocca una card per aprire il cliente.",
    "emptyTitle": "Nessuna attività recente",
    "emptyDesc": "Foto pasti, pesate, misure e messaggi dei tuoi clienti appariranno qui.",
    "viewByClient": "Per cliente",
    "viewChrono": "Cronologico",
    "oneActivity": "attività",
    "manyActivities": "attività",
    "today": "Oggi",
    "yesterday": "Ieri",
    "itemOne": "voce",
    "itemMany": "voci",
    "thumbsUp": "Bravo",
    "thumbsSent": "Inviato",
    "commentLabel": "Commenta",
    "commentedLabel": "Commentato",
    "commentPlaceholder": "Scrivi un feedback rapido…",
    "commentSent": "Feedback inviato al cliente",
    "mealLogged": "Pasto registrato",
    "weightLogged": "Peso registrato",
    "measurementUpdated": "Misure aggiornate",
    "progressPhoto": "Foto progresso",
    "chatMessage": "Nuovo messaggio",
    "angle_front": "fronte",
    "angle_side": "lato",
    "angle_back": "retro"
  },
  "progress": {
    "title": "Progressi",
    "subtitle": "Visualizza i tuoi cambiamenti nel tempo.",
    "navOverview": "Riepilogo",
    "navBody": "Corpo",
    "navNutrition": "Alimentazione",
    "navHealth": "Dispositivi & app",
    "navPhotos": "Foto",
    "bmiTitle": "Indice massa corporea",
    "bmiUnder": "Sottopeso",
    "bmiNormal": "Peso ideale",
    "bmiOver": "Sovrappeso",
    "bmiObese": "Obesità",
    "thisWeek": "Ultimi 7 giorni",
    "noDataConnect": "Nessun dato · Collega wearable",
    "monthlyTitle": "Progressi",
    "days": "giorni",
    "weightLabel": "Peso",
    "waistLabel": "Girovita",
    "recapNow": "attuale",
    "recapUnchanged": "invariato in 30 giorni",
    "recapNeedTwo": "servono 2 misure per la variazione",
    "recapNoWaist": "Nessun girovita ancora – inseriscilo in “Corpo”",
    "recapNoWeight": "Nessun peso registrato",
    "workoutsLabel": "Allenamenti",
    "diaryLabel": "Diario",
    "waterLabel": "Acqua",
    "hitTarget": "media giornaliera",
    "streakLabel": "giorni consecutivi",
    "streakToast7Title": "7 giorni di idratazione! 💧",
    "streakToast7Desc": "Una settimana intera al target. Il tuo corpo ti ringrazia!",
    "streakToast14Title": "2 settimane di fila! 🔥",
    "streakToast14Desc": "L'idratazione è ormai una tua abitudine. Continua così!",
    "streakToast30Title": "30 giorni consecutivi! 🏆",
    "streakToast30Desc": "Un mese intero al target. Sei una macchina!",
    "aiInsightTitle": "AI Coach",
    "aiInsightEmpty": "Registra più dati per ricevere un consiglio AI personalizzato.",
    "refreshInsight": "Aggiorna",
    "weightTrend": "Andamento peso",
    "goalShort": "Obiettivo",
    "prevPeriod": "Periodo precedente",
    "kcalTrend": "Andamento calorie · 30 giorni",
    "kcalAvg": "media al giorno",
    "kcalVsGoal": "kcal vs obiettivo",
    "kcalBand": "Fascia obiettivo",
    "macroTrend": "Andamento macro · 30 giorni",
    "macroProtein": "Proteine",
    "macroCarbs": "Carboidrati",
    "macroCarbsShort": "Carboidr.",
    "macroTipCta": "Vedi ricette adatte",
    "macroRecipesHigh": "Ricette ricche di {macro}",
    "macroRecipesLow": "Ricette povere di {macro}",
    "macroRecipesHint": "Ordinate per quota di calorie per porzione – tocca per aprire la ricetta.",
    "macroRecipesEmpty": "Ancora nessuna ricetta adatta nella tua raccolta.",
    "macroFat": "Grassi",
    "macroOfGoal": "{pct}% di {goal} g",
    "kcalInBand": "{n} giorni su {total} registrati nella fascia obiettivo (±10%)",
    "needMore": "Registra almeno 2 pesate per vedere il grafico.",
    "now": "Attuale",
    "rangeW": "Settimana",
    "rangeM": "Mese",
    "range3M": "3 mesi",
    "rangeY": "Anno",
    "rangeAll": "Tutto",
    "logMeasurements": "Registra misure",
    "measChartTitle": "Andamento misure",
    "saveMeasurements": "Salva misure",
    "measurementsLogged": "Misure registrate",
    "waist": "Vita (cm)",
    "hips": "Fianchi (cm)",
    "chest": "Torace (cm)",
    "arm": "Braccio (cm)",
    "thigh": "Coscia (cm)",
    "armGroup": "Braccio",
    "thighGroup": "Coscia",
    "armLeft": "Braccio sx",
    "armRight": "Braccio dx",
    "thighLeft": "Coscia sx",
    "thighRight": "Coscia dx",
    "calf": "Polpaccio (cm)",
    "calfGroup": "Polpaccio",
    "calfLeft": "Polpaccio sx",
    "calfRight": "Polpaccio dx",
    "leftShort": "Sinistro",
    "rightShort": "Destro",
    "history": "Cronologia misure",
    "trend": "Andamento misure",
    "needMoreData": "Servono almeno 2 misurazioni per mostrare l'andamento.",
    "needAtLeastOne": "Compila almeno una misura",
    "latest": "Più recente",
    "measure": "misura",
    "measures": "misure"
  },
  "weightGoal": {
    "title": "Peso obiettivo",
    "setPrompt": "Imposta il tuo peso obiettivo →",
    "currentToTarget": "Attuale → Obiettivo",
    "startCurrentTarget": "Iniziale → Attuale → Obiettivo",
    "remaining": "Mancano",
    "reached": "Obiettivo raggiunto! 🎯",
    "etaLine": "Al ritmo attuale ({rate} kg/settimana) ci arrivi tra ~{weeks} settimane",
    "etaTooFast": "Ritmo elevato ({rate} kg/settimana). Consulta il nutrizionista per un piano sostenibile.",
    "etaProjection": "Proiezione",
    "weeks": "settimane",
    "wrongDirection": "Il peso si sta muovendo nella direzione opposta all'obiettivo.",
    "wrongDirectionHint": "Prova a rivedere calorie e allenamenti con il tuo nutrizionista.",
    "needMore": "Registra il peso per almeno 2 settimane consecutive per vedere la proiezione.",
    "logFirst": "Registra il tuo peso attuale per iniziare.",
    "invalid": "Inserisci un peso valido tra 30 e 250 kg",
    "saved": "Peso obiettivo salvato",
    "cleared": "Obiettivo rimosso",
    "clearBtn": "Rimuovi obiettivo",
    "editBtn": "Modifica",
    "milestones": "Sotto-obiettivi",
    "milestoneTitle": "Mini-obiettivo raggiunto! 🎉",
    "milestoneDesc": "Sei arrivato a {kg} kg. Ogni 2 kg è un passo grande.",
    "milestoneFinalTitle": "Peso obiettivo raggiunto! 🎯",
    "milestoneFinalDesc": "Bravo! Hai raggiunto il tuo peso ideale."
  },
  "diary": {
    "title": "Diario di oggi",
    "mealVerdictGood": "Ottimo",
    "today": "Oggi",
    "yesterday": "Ieri",
    "pctOfDay": "{n}% del giorno",
    "verdictExplainGood": "Ottimo: pasto ben bilanciato.",
    "verdictExplainWarn": "Ok — piccoli miglioramenti possibili:",
    "verdictExplainBad": "Da migliorare — oltre i limiti su:",
    "verdictReason": {
      "sugar": "Troppi zuccheri (> 25 g)",
      "salt": "Troppo sale (> 2,5 g)",
      "satFat": "Troppi grassi saturi (> 8 g)",
      "heavySnack": "Snack troppo calorico (> 350 kcal)",
      "balancedMain": "Bilanciato: proteine + fibre + kcal ok",
      "lightSnack": "Snack leggero ed equilibrato",
      "goodBreakfast": "Colazione con fibre/proteine",
      "lowProtein": "Poche proteine — aggiungi proteine magre",
      "lowFiber": "Poche fibre — aggiungi verdure o cereali integrali",
      "tooLight": "Un po' leggero per un pasto principale",
      "tooHeavy": "Un po' abbondante — riduci le porzioni",
      "emptyCarbs": "Solo carboidrati — aggiungi proteine o fibre",
      "lowProteinOrFiber": "Poche proteine o fibre",
      "heavyBreakfast": "Colazione un po' abbondante",
      "neutral": "Valutazione neutra"
    },
    "verdictAdvice": {
      "sugar": "Sostituisci bibite/dolci con frutta fresca. Prova ricette a basso contenuto di zuccheri (< 8 g).",
      "salt": "Riduci alimenti processati (salumi, salse, snack salati). Cerca ricette con < 1 g di sale.",
      "satFat": "Usa olio d'oliva al posto di burro o grassi animali. Cerca ricette con grassi saturi < 3 g.",
      "heavySnack": "Prova snack sotto le 200 kcal (frutta, yogurt greco, frutta secca porzionata).",
      "lowProtein": "Aggiungi 100–150 g di pollo, pesce, uova o legumi. Cerca ricette con proteine ≥ 25 g.",
      "lowFiber": "Aggiungi verdure crude/cotte, legumi o cereali integrali. Ricette con fibre ≥ 8 g.",
      "tooLight": "Ricette da 400–700 kcal ti terranno sazio fino al pasto successivo.",
      "tooHeavy": "Riduci porzioni di carboidrati e grassi. Ricette bilanciate ≤ 550 kcal.",
      "emptyCarbs": "Bilancia con proteine (yogurt, uova) o fibre (verdure, frutta).",
      "lowProteinOrFiber": "Aggiungi proteine magre O fibre per rendere il pasto più bilanciato.",
      "heavyBreakfast": "Colazione ≤ 450 kcal: frutta + yogurt greco + fiocchi integrali."
    },
    "verdictSheetPraise": "Ottimo lavoro — questo pasto è ben bilanciato per i tuoi obiettivi.",
    "verdictRecipesSuggest": "Ricette che possono aiutare",
    "verdictNoRecipes": "Nessuna ricetta corrispondente nel tuo ricettario. Provane una nuova dal Frigo!",
    "mealVerdictWarn": "Buono",
    "mealVerdictBad": "Da migliorare",
    "subtitle": "Registra ciò che mangi.",
    "newCommentOne": "1 nuovo commento",
    "newCommentMany": "{count} nuovi commenti",
    "newCommentTap": "Tocca per vedere il feedback",
    "logAsMeal": "Aggiungi al pasto di oggi",
    "addToDiary": "Aggiungi al diario",
    "totalEst": "Totale del giorno:",
    "addMeal": "Aggiungi pasto",
    "addMealHint": "Scegli come tracciare il tuo pasto",
    "quickManual": "Manuale",
    "quickPhoto": "Foto AI",
    "quickFood": "Alimento",
    "quickVoice": "Voce",
    "quickSearch": "Cerca alimento",
    "typeLabel": "Tipo",
    "descLabel": "Descrizione",
    "kcalOpt": "Kcal (opz.)",
    "descPh": "es. 80g pasta integrale, pomodoro, olio evo",
    "notesPh": "Note (fame, umore, sport…)",
    "logMealBtn": "Registra pasto",
    "mealLogged": "Pasto registrato",
    "sharedToLibrary": "Condiviso nella libreria ricette",
    "describe": "Descrivi cosa hai mangiato",
    "noneForDate": "Nessun pasto registrato in questa data.",
    "saveAsRecipe": "Salva come ricetta",
    "saveAsRecipeHint": "{n} voci · {kcal} kcal in totale. Salva questo piatto come tua ricetta — la prossima volta registri semplicemente una porzione.",
    "recipeNamePh": "Nome della ricetta (es. Lasagne della nonna)",
    "recipeNameRequired": "Inserisci un nome per la ricetta.",
    "recipeServings": "Porzioni ottenute",
    "recipePerServing": "≈ {kcal} kcal a porzione",
    "recipeNotePh": "Preparazione / note (facoltativo)",
    "recipeUsePhoto": "Usa la foto della voce",
    "recipePhotoAuto": "Questa foto diventa automaticamente l'immagine della ricetta",
    "recipeSaveBtn": "Salva ricetta",
    "recipeSaved": "Ricetta salvata! La trovi nella scheda \"Ricette\" quando registri 📖",
    "autoSortedInto": "Aggiunta a:",
    "recipeKeepMyPortion": "Nel diario tieni solo la mia porzione",
    "recipeMyPortions": "Le mie porzioni",
    "recipeMyPortionHint": "Le voci vengono sostituite da 1 voce con ≈ {kcal} kcal",
    "recipeSavedPortion": "Ricetta salvata — nel diario ora c'è solo la tua porzione 📖",
    "breakfast": "colazione",
    "snack": "spuntino",
    "lunch": "pranzo",
    "afternoon": "merenda",
    "dinner": "cena",
    "aiPhoto": "Analizza con AI",
    "aiPhotoDesc": "Scatta una foto del tuo piatto: l'AI riconoscerà gli alimenti e calcolerà kcal, macro e micronutrienti.",
    "openCamera": "Apri fotocamera",
    "uploadPhoto": "Carica foto",
    "portionTipTitle": "Consiglio per stimare la porzione",
    "portionTipBody": "Includi una mano, una forchetta o una moneta nella foto: aiuta l'AI a stimare i grammi con maggior precisione.",
    "portionUncertain": "L'AI non è sicura delle porzioni — controlla e correggi i grammi prima di salvare.",
    "portionTipDismiss": "Ho capito",
    "aiAnalyzing": "Analizzo…",
    "aiOk": "Pasto riconosciuto! Correggi se serve, poi registra.",
    "aiError": "Non riesco ad analizzare la foto. Riprova o inserisci manualmente.",
    "wrongMatch": "Match errato?",
    "wrongMatchAria": "Segnala match errato",
    "wrongMatchPrompt": "Qual è il nome corretto dell'alimento?",
    "wrongMatchOk": "Grazie! Correzione registrata – impareremo.",
    "wrongMatchError": "Non ho potuto inviare la correzione. Riprovi?",
    "recognizedFoods": "Alimenti riconosciuti",
    "addFood": "Aggiungi alimento",
    "foodNamePh": "Es. Zucchine grigliate",
    "recompute": "Ricalcola macro",
    "recomputing": "Ricalcolo…",
    "recomputeOk": "Macro ricalcolati",
    "foodNotRecognized": "Non riconosciuto (0 kcal)",
    "foodPickFromDb": "scegli dal database",
    "recomputeError": "Impossibile ricalcolare — controlla nomi/pesi",
    "confirmDelete": "Eliminare questo pasto?",
    "deleted": "Pasto eliminato",
    "undo": "Annulla",
    "restored": "Eliminazione annullata",
    "duplicateFromYesterday": "Duplica da ieri",
    "yourMeals": "I tuoi pasti",
    "yourMealsSubtitle": "Pasti e ingredienti degli ultimi 7 giorni – tocca per copiare",
    "favorites": "Preferiti",
    "favoriteAdd": "Segna come preferito",
    "favoriteRemove": "Rimuovi preferito",
    "favoriteAdded": "Aggiunto ai preferiti",
    "favoriteRemoved": "Rimosso dai preferiti",
    "favLongPressHint": "Tieni premuto = registra subito",
    "favQuickLogged": "Preferito registrato subito",
    "noMealsYesterday": "Nessun pasto registrato ieri",
    "mealDuplicated": "Pasto duplicato in oggi",
    "mealUpdated": "Pasto aggiornato",
    "editMeal": "Modifica pasto",
    "hintLabel": "Aiuta l'AI",
    "hintOptional": "(opzionale)",
    "hintPlaceholder": "Es. 35g farina, 80g uovo, 80g banana",
    "hintCompute": "Calcola valori nutrizionali",
    "photoAttached": "Foto aggiunta",
    "quickEntryLabel": "Inserimento rapido",
    "hintComputed": "Valori calcolati dalla tua lista",
    "hintComputedPartial": "{matched} di {total} ingredienti riconosciuti — valori forse incompleti",
    "splitIngredients": "Dividi in ingredienti",
    "splitIngredientsHint": "Ogni ingrediente modificabile – macro stimati per quota in grammi (≈), totale invariato",
    "splitDone": "{n} ingredienti creati",
    "lookupIngredients": "Usa i valori dal database",
    "lookupIngredientsHint": "Sostituisce i valori stimati (≈) con valori reali per 100 g",
    "lookupRow": "Dal database",
    "lookupDone": "{n} ingredienti presi dal database",
    "lookupPartial": "{found} ingredienti su {total} trovati – il resto resta stimato",
    "hintReanalyze": "Riprova con suggerimento",
    "hintReanalyzed": "Analisi aggiornata con il tuo suggerimento",
    "aiRetryTitle": "Analisi foto non riuscita",
    "aiRetryHelp": "Aggiungi un suggerimento qui sotto per aiutare l'AI, oppure riprova subito.",
    "aiRetryBtn": "Riprova",
    "aiChefStep1": "Analizzo il tuo pasto…",
    "aiChefStep2": "Riconosco gli alimenti…",
    "aiChefStep3": "Calcolo calorie e macro…",
    "aiChefStep4": "Quasi pronto…",
    "aiChefStep5": "Il tuo pasto è quasi pronto…",
    "aiChefDone": "Il tuo pasto è pronto.",
    "barcodeNudgeTitle": "Prodotto confezionato rilevato",
    "barcodeNudgeBody": "Scansiona il codice a barre per valori esatti dell'etichetta",
    "barcodeNudgeCta": "Scansiona →",
    "journalTitle": "Diario del giorno",
    "journalSubtitle": "Come ti senti oggi? Com'è andata?",
    "journalPlaceholder": "Note libere sulla giornata, allenamento, energia, cravings…",
    "journalSaving": "Salvo…",
    "journalSaved": "Salvato",
    "journalVoiceRec": "Registrazione",
    "journalVoiceTranscribing": "Trascrizione…",
    "journalVoiceEmpty": "Nessun parlato rilevato",
    "journalVoicePermDenied": "Permesso microfono negato",
    "journalReplies": "Risposte del nutrizionista",
    "journalSaveEntry": "Salva voce",
    "journalTodayEntries": "Voci di oggi",
    "journalMorning": "Mattina",
    "journalAfternoon": "Pomeriggio",
    "journalEvening": "Sera",
    "journalPickSomething": "Scegli un mood o scrivi qualcosa",
    "duplicateAll": "Duplica tutti",
    "swipeEdit": "Modifica",
    "swipeDuplicate": "Duplica",
    "swipeDelete": "Elimina",
    "allDuplicated": "{n} pasti duplicati",
    "meal": "Pasto",
    "portionLabel": "Porzione",
    "portionHint": "Modifica i grammi: i macro si adattano",
    "notesTitle": "Istruzioni e note",
    "save": "Salva",
    "voiceTap": "Tocca per parlare",
    "voiceListening": "Ti ascolto…",
    "voiceAnalyzing": "Analizzo cosa hai detto…",
    "voiceListeningHint": "Descrivi il pasto ad alta voce. Tocca «Stop» quando hai finito.",
    "voiceAnalyzingHint": "Un attimo, sto trascrivendo…",
    "voiceStop": "Stop",
    "voiceOk": "Fatto! Correggi se serve, poi salva.",
    "voiceError": "Non ho capito, riprova",
    "voicePermDenied": "Serve il permesso microfono",
    "transcript": "Trascrizione",
    "selectMealType": "Tipo pasto",
    "chooseDateTime": "Data e ora",
    "summaryTitle": "Riepilogo pasto",
    "kcalShort": "kcal",
    "proteinShort": "Prot.",
    "carbsShort": "Carbo",
    "fatShort": "Grassi",
    "fiberShort": "Fibre",
    "voiceNoteMax": "Registra nota vocale (max 15 s)"
  },
  "food": {
    "gramsTab": "Grammi",
    "pieces": "Pezzi",
    "sizeSmall": "piccolo",
    "sizeMedium": "medio",
    "sizeLarge": "grande",
    "barcodeNotFoundAddManually": "Prodotto non trovato — aggiungi manualmente le info",
    "torch": "Torcia",
    "pinchZoomHint": "Pizzica con due dita per ingrandire.",
    "title": "Cerca alimento",
    "description": "Cerca per nome o scansiona il codice a barre di un prodotto",
    "recipeIngredients": "Ingredienti",
    "recipeSteps": "Preparazione",
    "portion": "porzione",
    "servings": "porzioni",
    "servingsN": "{n} porzioni",
    "byName": "Nome",
    "byBarcode": "Codice a barre",
    "searchPh": "banana, pasta integrale, yogurt greco…",
    "scanWithCamera": "Scansiona con fotocamera",
    "or": "oppure",
    "aimAtBarcode": "Inquadra il codice a barre del prodotto",
    "scannerFocusHint": "Se non legge, tocca il codice per mettere a fuoco.",
    "zoom": "Zoom",
    "labelOcrTitle": "Barcode illeggibile?",
    "labelOcrBody": "Fotografa la tabella nutrizionale — l'AI legge i valori",
    "labelOcrCameraCta": "Scatta",
    "labelOcrGalleryCta": "Galleria",
    "labelUnreadable": "Etichetta illeggibile, riprova con più luce",
    "labelError": "Errore lettura etichetta",
    "labelProduct": "Prodotto da etichetta",
    "pointBarcode": "Inquadra il codice a barre del prodotto",
    "startingCamera": "Avvio fotocamera…",
    "orEnterManually": "Oppure inserisci il codice manualmente:",
    "enterCode": "Inserisci il codice",
    "rescan": "Scansiona di nuovo",
    "camPermission": "Serve il permesso della fotocamera",
    "camError": "Impossibile aprire la fotocamera",
    "camNoStream": "La fotocamera non parte. Usa Foto dalla galleria o inserisci il codice.",
    "camNodevice": "Nessuna fotocamera trovata",
    "camGeneric": "Fotocamera non disponibile",
    "pickPhoto": "Scatta o scegli foto",
    "noBarcodeInImage": "Nessun codice a barre rilevato nella foto",
    "camNoDevice": "Nessuna fotocamera rilevata",
    "camBusy": "La fotocamera è già in uso da un'altra app",
    "camIframe": "La fotocamera è bloccata dall'anteprima. Apri l'app in una nuova scheda ↗",
    "camTip": "Suggerimento: tocca l'icona ↗ in alto per aprire l'app fuori dall'anteprima e concedi il permesso.",
    "camTipNative": "Suggerimento: consenti l'accesso alla fotocamera in Impostazioni → App → Solano Essence → Autorizzazioni → Fotocamera, poi riprova.",
    "notFound": "Prodotto non trovato",
    "manualAdd": {
      "title": "Aggiungi manualmente questo prodotto",
      "subtitle": "Il codice non è ancora nel database — salvalo qui una volta e sarà pronto per la prossima scansione.",
      "barcode": "Codice EAN",
      "name": "Nome prodotto",
      "namePlaceholder": "Es. Yogurt greco naturale",
      "brand": "Marca (opzionale)",
      "brandPlaceholder": "Es. FAGE",
      "per100g": "Valori per 100 g",
      "kcal": "Calorie",
      "protein": "Proteine",
      "carbs": "Carboidrati",
      "fat": "Grassi",
      "sugar": "Zuccheri",
      "fiber": "Fibre",
      "satFat": "Grassi sat.",
      "salt": "Sale",
      "hint": "Copia i valori dall'etichetta nutrizionale. Puoi lasciare vuoti i campi che non ti servono.",
      "saveAndUse": "Salva e usa",
      "saved": "Prodotto salvato ✓",
      "needBasics": "Nome e codice sono obbligatori",
      "labelAiTitle": "Compila con l'AI ✨",
      "labelAiSubtitle": "Fotografa l'etichetta nutrizionale del prodotto — l'AI legge kcal e macro e riempie il form.",
      "labelCamera": "Fotografa",
      "labelUpload": "Carica foto",
      "labelAnalyzing": "L'AI sta leggendo l'etichetta…",
      "labelAnalyzed": "Etichetta letta ✓ — verifica i valori",
      "labelError": "Non sono riuscita a leggere l'etichetta. Riprova con una foto più nitida.",
      "productPhoto": "Foto del prodotto",
      "productPhotoAdd": "Aggiungi foto",
      "productPhotoRetake": "Rifai foto"
    },
    "searchError": "Errore ricerca",
    "backToResults": "Indietro",
    "nameSaved": "Nome prodotto salvato — le prossime scansioni lo mostreranno",
    "quantityConsumed": "Quantità consumata",
    "yourPortion": "La tua porzione",
    "sugar": "Zuccheri",
    "fiber": "Fibre",
    "satFat": "Grassi sat.",
    "salt": "Sale",
    "ofCarbs": "di cui",
    "ofFat": "di cui",
    "lightSugarShort": "Z",
    "lightFatShort": "G",
    "lightSaltShort": "Sa",
    "altTitle": "Alternativa più sana?",
    "altCta": "3 proposte",
    "altEmpty": "Nessuna alternativa verde adatta trovata.",
    "lightLow": "poco",
    "lightMid": "medio",
    "lightHigh": "molto",
    "lightBasis": "per 100 g",
    "noDetails": "Nessun dato su zuccheri, fibre, grassi saturi e sale per questo prodotto.",
    "addToMeal": "Aggiungi al pasto",
    "tabDb": "Database Solano",
    "tabFav": "Preferiti",
    "tabCustom": "I miei dati",
    "tabRecipes": "Ricette",
    "tabRecent": "Cronologia",
    "noRecentYet": "Nessun alimento tracciato di recente. Aggiungi il primo pasto!",
    "per100g": "per 100 g",
    "perPortion": "per porzione",
    "addToFav": "Aggiungi ai preferiti",
    "removeFav": "Rimuovi dai preferiti",
    "favAdded": "Aggiunto ai preferiti",
    "favRemoved": "Rimosso dai preferiti",
    "noFavYet": "Nessun preferito ancora. Tocca il cuore su un alimento per aggiungerlo.",
    "noCustomYet": "Nessun alimento personale. Crea il tuo primo.",
    "noRecipesYet": "Nessuna ricetta trovata.",
    "createCustom": "Nuovo alimento",
    "editCustom": "Modifica alimento",
    "customName": "Nome",
    "customBrand": "Marca (opz.)",
    "customNotes": "Note (opz.)",
    "customKcal": "Kcal / 100 g",
    "customProtein": "Proteine / 100 g",
    "customCarbs": "Carboidrati / 100 g",
    "customFat": "Grassi / 100 g",
    "customSugar": "Zuccheri / 100 g",
    "customFiber": "Fibre / 100 g",
    "customSat": "Grassi saturi / 100 g",
    "customSalt": "Sale / 100 g",
    "save": "Salva",
    "cancel": "Annulla",
    "customCreated": "Alimento creato",
    "customDeleted": "Alimento eliminato",
    "deleteConfirm": "Sicuro di voler eliminare?",
    "detailBadge": "DETTAGLIO",
    "minLettersHint": "Digita almeno 2 lettere per cercare nel database.",
    "aiBadge": "STIMA AI",
    "aiEstimateTip": "Valori nutrizionali stimati dall'AI: verifica sempre prima di salvare.",
    "searchInDbCta": "Cerca \"{q}\" nel database Solano"
  },
  "calc": {
    "title": "Calcolatore calorie e macro",
    "subtitle": "In base ai tuoi dati stimo il fabbisogno giornaliero.",
    "ctaTitle": "Non sai quante kcal ti servono?",
    "ctaHint": "Calcolo automatico su misura per te",
    "gender": "Sesso",
    "genderM": "Uomo",
    "genderF": "Donna",
    "age": "Età",
    "height": "Altezza",
    "weight": "Peso",
    "targetWeight": "Peso obiettivo",
    "targetWeightHint": "Facoltativo · appare in Progressi con proiezione ETA",
    "activity": "Livello di attività",
    "actSedentary": "Sedentario",
    "actLight": "Leggero",
    "actModerate": "Moderato",
    "actIntense": "Intenso",
    "actAthlete": "Atleta",
    "goal": "Obiettivo",
    "goalCut": "Dimagrire",
    "goalMaintain": "Mantenere",
    "goalPerf": "Performance",
    "goalBulk": "Aumentare",
    "calculate": "Calcola",
    "recalculate": "Ricalcola",
    "applyToProfile": "Applica",
    "applied": "Obiettivi salvati sul tuo profilo",
    "missing": "Compila tutti i campi",
    "customAdj": "Regola deficit/surplus individualmente",
    "customAdjHint": "Trascina per modificare la percentuale rispetto al tuo mantenimento (-30% deficit ↔ +30% surplus).",
    "manualLink": "Conosci già il tuo obiettivo calorico? Inseriscilo manualmente",
    "maintenance": "Fabbisogno di mantenimento",
    "goalLabel": "Obiettivo",
    "recommended": "Obiettivo giornaliero consigliato",
    "applyComputed": "Applica obiettivo calcolato",
    "adjustManually": "Regola manualmente",
    "macrosSum": "Totale macro: {sum}%",
    "sumHint": "Totale: {sum}% — porta la somma al 100%",
    "jobTitle": "Lavoro e vita quotidiana",
    "jobSitting": "Prevalentemente seduto (ufficio, smart working)",
    "jobStanding": "In piedi / misto (negozio, insegnamento)",
    "jobPhysical": "Fisicamente attivo (artigianato, assistenza)",
    "stepsTitle": "Passi al giorno",
    "trainTitle": "Allenamenti a settimana",
    "factorLabel": "Fattore di attività",
    "deficitTitle": "Ritmo di dimagrimento",
    "deficitSoft": "Dolce",
    "deficitModerate": "Moderato",
    "deficitFast": "Veloce",
    "deficitCustom": "Personalizzato",
    "goalCustom": "Personalizzato",
    "etaWeeks": "≈ {weeks} settimane fino a {target} kg",
    "etaNote": "Solo una stima — il peso obiettivo non influisce sul calcolo delle calorie.",
    "dblCountHint": "Il tuo allenamento è già incluso nel fattore di attività — le calorie degli allenamenti non vengono aggiunte al budget giornaliero.",
    "reviewTitle": "Verifica obiettivo",
    "reviewBody": "Negli ultimi {days} giorni: {actual} kg/settimana (previsto: {expected} kg/settimana).",
    "reviewSuggestDown": "Suggerimento: riduci l'obiettivo giornaliero di 100 kcal a {kcal} kcal.",
    "reviewSuggestUp": "Suggerimento: aumenta l'obiettivo giornaliero di 100 kcal a {kcal} kcal.",
    "reviewApply": "Applica",
    "reviewLater": "Più tardi",
    "reviewApplied": "Nuovo obiettivo giornaliero salvato",
    "recompute": "Ricalcola con i nuovi valori",
    "yourNeeds": "Il tuo fabbisogno",
    "day": "giorno",
    "adjustment": "Aggiustamento"
  },
  "nutriPlan": {
    "buttonShort": "Piano",
    "title": "Piano nutrizionale",
    "subtitle": "Imposta gli obiettivi giornalieri per",
    "client": "Cliente",
    "selfLabel": "te",
    "historyTitle": "Storico obiettivi",
    "byCoach": "Coach",
    "bySelf": "Tu",
    "modeAuto": "Calcolo automatico",
    "modeManual": "Manuale",
    "autoTitle": "Calcola con Mifflin-St Jeor",
    "formulaTitle": "Formula BMR",
    "fMifflin": "Mifflin-St Jeor",
    "fMifflinHint": "Consigliata · pop. generale",
    "fHarris": "Harris-Benedict",
    "fHarrisHint": "Rev. 1984 · classica",
    "fKatch": "Katch-McArdle",
    "fKatchHint": "Richiede % massa grassa",
    "fCunningham": "Cunningham",
    "fCunninghamHint": "Atleti · % massa grassa",
    "bodyFat": "% Massa grassa",
    "bodyFatHint": "3–60% · richiesto per Katch/Cunningham",
    "needBodyFat": "Inserisci la % di massa grassa (3–60)",
    "fallbackToMifflin": "Manca la % grassa → uso Mifflin-St Jeor",
    "customAdj": "Regola kcal manualmente",
    "customAdjHint": "Sovrascrivi il preset (-30% deficit ↔ +30% surplus)",
    "calculate": "Calcola macro",
    "calcDone": "Calcolo aggiornato — modifica se necessario",
    "presetTitle": "Distribuzione macro",
    "presetBalanced": "Bilanciata",
    "presetLowCarb": "Low Carb",
    "presetHighProt": "High Protein",
    "presetCustom": "Custom",
    "needKcalForPreset": "Inserisci prima le kcal",
    "targetsTitle": "Obiettivi giornalieri",
    "fiber": "Fibre",
    "water": "Acqua",
    "microsTitle": "Micronutrienti",
    "optional": "opzionale",
    "sodium": "Sodio",
    "calcium": "Calcio",
    "iron": "Ferro",
    "vitD": "Vitamina D",
    "notifyLabel": "Notifica il cliente",
    "notifyHint": "Riceverà un push con i nuovi valori",
    "saveAndActivate": "Salva e attiva",
    "saved": "Piano salvato",
    "savedPushed": "Piano salvato · notifica inviata",
    "invalidKcal": "Kcal deve essere tra 800 e 6000",
    "macroSumWarn": "Somma macro: {sum}% (verifica i valori)"
  },
  "supplements": {
    "title": "Promemoria supplementi",
    "atTime": "alle {time}",
    "moreCount": "altri {n}",
    "subtitleEmpty": "Tocca per aggiungere",
    "addBtn": "Aggiungi supplemento",
    "newTitle": "Nuovo supplemento",
    "editTitle": "Modifica",
    "presetsLabel": "Preset",
    "nameLabel": "Nome",
    "namePlaceholder": "Es. Magnesio 400mg",
    "timeLabel": "Orario",
    "daysLabel": "Giorni",
    "everyDay": "Ogni giorno",
    "weekdays": "Lun-Ven",
    "weekend": "Weekend",
    "active": "attivi",
    "needName": "Manca il nome",
    "needDay": "Scegli almeno un giorno",
    "saved": "Salvato",
    "confirmDelete": "Rimuovere questo promemoria?",
    "emptyState": "Ancora nessun supplemento. Aggiungi il primo!",
    "streakDays": "giorni",
    "takenToday": "Assunto oggi",
    "markTakenToday": "Segna come assunto oggi",
    "d": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Gio",
      "fri": "Ven",
      "sat": "Sab",
      "sun": "Dom"
    }
  },
  "apptsCli": {
    "title": "Appuntamenti",
    "subtitle": "Richiedi un consulto con il tuo nutrizionista.",
    "newRequest": "Nuova richiesta",
    "typeLabel": "Tipo",
    "modalityLabel": "Modalità",
    "firstVisit": "Prima visita",
    "checkup": "Controllo",
    "sportsConsult": "Consulenza sportiva",
    "inOffice": "In studio",
    "video": "Videoconsulto",
    "notesPh": "Note per il nutrizionista (opzionale)",
    "sendRequest": "Invia richiesta",
    "sentOk": "Richiesta inviata! Il nutrizionista confermerà.",
    "yourBookings": "Le tue prenotazioni",
    "empty": "Nessun appuntamento.",
    "noNutTitle": "Collega prima un nutrizionista",
    "noNutDesc": "Per richiedere un consulto, inserisci il codice invito del tuo nutrizionista nel profilo.",
    "goLinkNut": "Vai al profilo"
  },
  "profile": {
    "title": "Il mio profilo",
    "subtitle": "Aggiorna i dati per un piano più preciso.",
    "notifTitle": "Notifiche push",
    "notifTapToOpen": "Tocca per gestire i promemoria",
    "devicesTapToOpen": "Tocca per collegare i dispositivi",
    "sectionSettings": "Impostazioni",
    "sectionConnections": "Collegamenti",
    "sectionAccount": "Account",
    "proActiveHint": "Pro è attivo — gestisci abbonamento",
    "proUpsellHint": "Sblocca più possibilità per la tua quotidianità",
    "proQuotaLeft": "rimasti",
    "personalDataTitle": "Dati personali",
    "languageTitle": "Lingua",
    "languageHint": "Lingua dell'app — indipendente dalle impostazioni del dispositivo",
    "widgetSyncTitle": "Aggiorna widget ora",
    "widgetSyncHelp": "Invia i valori di oggi ai widget della schermata Home",
    "widgetSyncOk": "Widget aggiornato ✓ {kcal} kcal · {water} · {steps} passi",
    "widgetSyncFail": "Sincronizzazione widget non riuscita",
    "linkNutTitle": "Il tuo nutrizionista",
    "linkNutNone": "Non sei ancora collegato a un nutrizionista. Inserisci il suo codice invito quando lo hai.",
    "linkNutLabel": "Codice invito nutrizionista",
    "linkNutBtn": "Collega",
    "linkNutOk": "Nutrizionista collegato!",
    "linkedTo": "Sei collegato a:",
    "fullName": "Nome completo",
    "birthdate": "Data di nascita",
    "gender": "Sesso",
    "height": "Altezza (cm)",
    "startingWeight": "Peso iniziale (kg)",
    "kcalTarget": "Kcal target",
    "goal": "Obiettivo",
    "activity": "Livello attività",
    "sport": "Sport praticato",
    "sportPh": "es. corsa, calcio, palestra...",
    "allergies": "Allergie / intolleranze",
    "medical": "Note mediche",
    "saveBtn": "Salva profilo",
    "updated": "Profilo aggiornato",
    "trainingDays": "Giorni di allenamento",
    "trainingDaysHelp": "In quali giorni della settimana ti alleni di solito? Adatta la missione movimento giornaliera.",
    "notifEnableCta": "Attiva le notifiche push sul dispositivo",
    "notifTz": "Fuso orario",
    "notifMeals": "Reminder pasti",
    "notifWater": "Reminder acqua",
    "notifEveryMin": "Ogni (min)",
    "notifHelper": "Attiva i promemoria per pasti e acqua. Riceverai una notifica sul telefono agli orari indicati.",
    "notifActive": "attive",
    "notifDenied": "Permessi bloccati: abilitali dalle impostazioni del browser.",
    "notifUnsupported": "Push non disponibili su questo dispositivo.",
    "notifOk": "Push attivate ✓",
    "notifTestCta": "Invia notifica di prova",
    "notifTestSent": "Notifica di prova inviata ✓",
    "notifTestFail": "Nessuna notifica inviata. Riprova ad attivare le push.",
    "notifResetCta": "Reset e riattiva sottoscrizione",
    "notifResetOk": "Sottoscrizione rigenerata ✓",
    "notifResetFail": "Rigenerazione fallita. Rimuovi e reinstalla la PWA dalla Home.",
    "notifWaterFrom": "Dalle",
    "notifWaterTo": "Alle",
    "notifWaterFreq": "Frequenza",
    "notifEvening": "Riepilogo serale",
    "notifTraining": "Promemoria allenamento",
    "notifPlan": "Promemoria piano al mattino",
    "notifPlanHint": "Nei giorni in cui è previsto un piano: «Oggi: Gambe – pronto?» – un tocco avvia l'allenamento.",
    "notifTrainingAt": "Alle",
    "notifTrainingHint": "Inviato solo nei giorni di allenamento pianificati — se non hai ancora registrato un training quel giorno.",
    "notifEveningAt": "Alle",
    "notifEveningPreview": "Anteprima",
    "notifEveningSendNow": "Invia adesso",
    "mealBreakfast": "Colazione",
    "mealSnack": "Spuntino",
    "mealLunch": "Pranzo",
    "mealAfternoon": "Merenda",
    "mealDinner": "Cena",
    "female": "Femminile",
    "male": "Maschile",
    "other": "Altro",
    "weightLoss": "Dimagrimento",
    "maintenance": "Mantenimento",
    "muscle": "Aumento massa",
    "performance": "Performance sportiva",
    "sedentary": "Sedentario",
    "light": "Leggero",
    "moderate": "Moderato",
    "intense": "Intenso",
    "athlete": "Atleta"
  },
  "language": {
    "label": "Lingua",
    "it": "Italiano",
    "en": "English",
    "de": "Deutsch"
  },
  "eveningTip": {
    "pageTitle": "Il tuo consiglio della sera",
    "pageSubtitle": "Un piccolo gesto adesso, un grande passo domani",
    "hero": {
      "suggestion": "Il suggerimento di stasera",
      "fallback": "Continua a curare la tua alimentazione"
    },
    "stats": {
      "today": "Oggi",
      "kcal": "kcal",
      "dayStreak": "giorni di fila"
    },
    "howto": "Come farlo, in modo semplice",
    "ctaSeeProgress": "Vedi i tuoi progressi",
    "ctaLogMeal": "Registra un pasto",
    "ctaLogWater": "Registra l'acqua",
    "ctaFindRecipe": "Trova una ricetta proteica",
    "ctaAddSnack": "Aggiungi uno spuntino",
    "ctaSeeSteps": "Vedi passi e attività",
    "backHome": "Torna alla home",
    "bullets": {
      "long_streak": "Guarda la tua curva settimanale nei Progressi|Concediti una piccola ricompensa – te la sei meritata|Fissa il prossimo obiettivo di 7 giorni",
      "no_dinner": "Apri il diario e registra la cena|Anche un piatto leggero conta|Solo i pasti registrati contano per bilancio e streak",
      "water_low": "Bevi 1 bicchiere adesso e 1 prima di dormire|Tieni la borraccia sul comodino|Al mattino inizia con 1 bicchiere prima del caffè",
      "protein_gap": "Yogurt greco o skyr a colazione|Uova sode come spuntino|Aggiungi 1 fetta di bresaola o tonno a pranzo",
      "kcal_deficit_large": "Uno yogurt greco con miele e frutta secca|Un toast integrale con avocado|Frutta + una manciata di mandorle",
      "steps_low": "Fai una passeggiata di 20 minuti dopo cena|Scendi una fermata prima|Fai le scale invece dell'ascensore",
      "great_day": "Continua così anche domani|Prepara la colazione già stasera|Fissa un nuovo obiettivo settimanale",
      "day_recap": "Dai un'occhiata al bilancio di oggi nei Progressi|Prepara una bottiglia d'acqua per domattina|Pianifica la colazione in anticipo"
    }
  },
  "theme": {
    "title": "Aspetto",
    "subtitle": "Scegli come vuoi vedere l'app.",
    "light": "Chiaro",
    "dark": "Scuro",
    "system": "Sistema",
    "systemHint": "Segue le impostazioni del dispositivo"
  },
  "nutProfile": {
    "title": "Profilo",
    "subtitle": "Gestisci account e aspetto.",
    "accountTitle": "Account",
    "fullName": "Nome completo",
    "email": "Email",
    "emailReadOnly": "L'email non può essere modificata",
    "inviteTitle": "Codice invito studio",
    "inviteHelp": "Condividi questo codice con i nuovi clienti per collegarli al tuo studio."
  },
  "trend": {
    "last7days": "Ultimi 7 giorni"
  },
  "aiCoach": {
    "title": "Coach AI",
    "chipLabel": "Coach",
    "chipSub": "{n} nuovi consigli",
    "chipReady": "Pronto",
    "subtitle": "I suggerimenti di oggi per te",
    "refresh": "Aggiorna",
    "refreshed": "Suggerimenti aggiornati",
    "stripHint": "Tocca per vedere i {count} suggerimenti di oggi",
    "askBtn": "Chiedi al Coach",
    "chatTitle": "Chiedi al Coach AI",
    "voiceOn": "Attiva voce – le risposte vengono lette",
    "voiceOff": "Disattiva voce",
    "chatHint": "Il coach conosce i tuoi dati: macro, punteggi, piatto, sonno, peso, streak. Puoi allegare foto o screenshot.",
    "suggestionsLabel": "Prova a chiedere:",
    "inputPlaceholder": "Scrivi una domanda…",
    "thinking": "Il coach sta pensando…",
    "send": "Invia",
    "attachPhoto": "Allega una foto",
    "takePhoto": "Scatta una foto",
    "fromGallery": "Foto/screenshot dalla galleria",
    "photoReady": "Foto pronta da inviare",
    "startRec": "Registra un messaggio vocale",
    "stopRec": "Ferma la registrazione",
    "recording": "Registrazione in corso… tocca il microfono per fermare",
    "transcribing": "Trascrivo la voce…",
    "transcribeError": "Non ho capito, riprova a parlare più chiaramente",
    "micUnsupported": "Il microfono non è supportato su questo dispositivo",
    "micDenied": "Permesso microfono negato"
  },
  "restaurant": {
    "title": "Al ristorante",
    "subtitle": "Fai analizzare il menù e scegli il piatto giusto per te",
    "badgeNew": "NUOVO",
    "tabPhoto": "Foto menù",
    "tabText": "Scrivi il menù",
    "captureBtn": "Scatta foto",
    "chooseFileBtn": "Dal telefono",
    "captureHint": "Apri fotocamera",
    "chooseFileHint": "Dalla tua galleria",
    "imageSelected": "Immagine selezionata",
    "analyzeBtnNow": "Analizza ora",
    "infoTitle": "L'AI analizza per te:",
    "infoProtein": "Proteine",
    "infoVeg": "Verdura",
    "infoKcal": "Calorie",
    "infoCarbs": "Carboidrati",
    "infoFat": "Grassi",
    "infoBest": "Migliore",
    "step1": "Foto o upload",
    "step2": "AI analizza",
    "step3": "Ricevi consiglio",
    "photoHint": "Inquadra il menù del ristorante, poi tocca Analizza",
    "textPlaceholder": "Scrivi il nome del ristorante O i piatti (es. «Hooters Interlaken» o «pasta, sogliola, tiramisù»)…",
    "recentSearches": "Ricerche recenti",
    "removeRecent": "Rimuovi",
    "analyzeBtn": "Analizza il menù",
    "analyzing": "Analisi in corso…",
    "retakeBtn": "Nuova foto",
    "changeMenuBtn": "Cambia menù",
    "mealLabel": "Pasto",
    "meals": {
      "colazione": "Colazione",
      "pranzo": "Pranzo",
      "merenda": "Merenda",
      "cena": "Cena",
      "spuntino": "Spuntino"
    },
    "budgetTitle": "Ti restano oggi",
    "budgetKcal": "kcal",
    "budgetProtein": "Proteine",
    "budgetCarbs": "Carbo",
    "budgetFat": "Grassi",
    "medScore": "Med score",
    "noBudget": "Nessun target impostato — attivalo nel profilo per consigli più precisi",
    "resultsTitle": "I miei consigli",
    "chooseBtn": "Ho scelto questo",
    "choosingIn": "Aggiungo al diario…",
    "addedToDiary": "Piatto aggiunto al diario 🍽️",
    "addError": "Impossibile aggiungere al diario",
    "analyzeError": "Impossibile analizzare il menù. Riprova.",
    "needInput": "Fornisci una foto del menù o scrivi i piatti",
    "tipsTitle": "Suggerimenti extra",
    "verdictGreen": "Ottima scelta",
    "verdictYellow": "Buona con cautela",
    "verdictRed": "Meglio evitare",
    "medImpact": {
      "positive": "↑ Med",
      "neutral": "= Med",
      "negative": "↓ Med"
    },
    "backBtn": "Torna alla dashboard",
    "historyTitle": "I tuoi preferiti al ristorante",
    "removeFavorite": "Rimuovi dai preferiti",
    "favoriteRemoved": "Rimosso dai preferiti",
    "reorderBtn": "Riordina"
  },
  "pantry": {
    "title": "Dispensa",
    "subtitle": "Cosa ho in casa",
    "empty": "La tua dispensa è vuota. Aggiungi ingredienti o scansiona uno scontrino.",
    "addManual": "Aggiungi manualmente",
    "namePlaceholder": "Es. Uova, pomodori, yogurt greco…",
    "qtyPlaceholder": "Q.tà",
    "added": "Aggiunto alla dispensa",
    "deducted": {
      "some": "-{g} di {name} · resta {after}",
      "depleted": "{name} finito — rimuovilo dalla dispensa",
      "restored": "Ripristinato {name}"
    },
    "scanReceipt": "Scansiona scontrino",
    "scanReceiptHint": "L'AI legge gli alimenti",
    "scanEan": "Scansiona EAN",
    "scanEanHint": "Un prodotto alla volta",
    "itemAdded": "Aggiunto in dispensa",
    "needName": "Nome richiesto",
    "scanError": "Non sono riuscito a leggere lo scontrino",
    "scanning": "Analizzo lo scontrino…",
    "whatToCook": "Cosa cucino?",
    "whatToCookHint": "Ricetta con quello che hai",
    "needMore": "Aggiungi almeno 2 ingredienti",
    "recipeCreated": "Ricetta creata!",
    "receiptTitle": "Rivedi gli alimenti dello scontrino",
    "receiptDesc": "Deseleziona ciò che non vuoi salvare e correggi nomi/quantità se serve.",
    "receiptAdded": "{count} alimenti aggiunti dalla dispensa",
    "receiptEmpty": "Nessun alimento riconosciuto",
    "addAll": "Aggiungi tutti",
    "emptyShort": "Vuota — tocca per riempire",
    "countShort": "{count} ingredienti in casa",
    "expiryLabel": "Scadenza",
    "autoSuggested": "AUTO",
    "useSoonTitle": "Zuerst verbrauchen",
    "rest": "Weitere Vorräte",
    "allItems": "Tutti i prodotti",
    "mergedToast": "{name}: {qty}",
    "storageLabel": "Dove tenerlo",
    "storage": {
      "fridge": "Frigo",
      "pantry": "Dispensa",
      "freezer": "Freezer"
    },
    "expired": "Scaduto {days}g fa",
    "today": "Scade oggi",
    "inDays": "Tra {days}g",
    "notifTitle": "Attenzione scadenze",
    "notifBodyOne": "{name} scade domani. Consumalo o mettilo nel piatto oggi.",
    "notifBodyMany": "{count} ingredienti stanno per scadere (es. {name}).",
    "categoryLabel": "Categoria",
    "categoryHint": "Cambia categoria",
    "cat_fruit": "Frutta",
    "cat_vegetables": "Verdura",
    "cat_dairy": "Latticini",
    "cat_meat": "Carne",
    "cat_fish": "Pesce",
    "cat_eggs": "Uova",
    "cat_grains": "Cereali & Pasta",
    "cat_legumes": "Legumi",
    "cat_oils_fats": "Oli & Grassi",
    "cat_spices_condiments": "Spezie & Condimenti",
    "cat_sweets": "Dolci",
    "cat_beverages": "Bevande",
    "cat_frozen": "Surgelati",
    "cat_supplements": "Proteine & Integratori",
    "cat_other": "Altro",
    "searchPlaceholder": "Cerca nella dispensa…",
    "stats": {
      "products": "Prodotti",
      "categories": "Categorie",
      "expiring": "In scadenza",
      "shopping": "Lista spesa"
    },
    "shoppingEmptyHappy": "🎉 Tutto comprato!",
    "shoppingEmptyHint": "Tempo per nuove ricette.",
    "expiryChip": {
      "fresh": "Fresco",
      "soon": "In scadenza",
      "today": "Oggi",
      "expired": "Scaduto"
    },
    "filter": {
      "expiringOnly": "Solo prodotti in scadenza",
      "all": "Tutti",
      "fresh": "Freschi",
      "soon": "In scadenza",
      "expired": "Scaduti",
      "favorites": "Preferiti",
      "healthy": "Solo A/B"
    },
    "swap": {
      "title": "Alternative più sane",
      "subtitle": "{n} prodotti con Nutri-Score basso",
      "added": "{name} aggiunto alla lista",
      "dismiss": "Per me va bene",
      "dismissed": "Suggerimento nascosto",
      "showHidden": "Mostra nascosti ({n})",
      "hideHidden": "Nascondi",
      "restore": "Ripristina",
      "restored": "Suggerimento ripristinato",
      "allDismissed": "Tutti i suggerimenti sono nascosti"
    },
    "searchExtendedPlaceholder": "Cerca per nome, categoria o note…",
    "addToShopping": "Aggiungi alla lista",
    "selectMultiple": "Seleziona",
    "selectAll": "Tutti",
    "nSelected": "{n} selezionati",
    "bulkDeleted": "{n} prodotti eliminati",
    "noResults": "Nessun risultato con i filtri attuali",
    "noExpiry": "Nessuna scadenza",
    "notes": "Note",
    "notesPlaceholder": "es. bio, aperto…",
    "foodScore": {
      "title": "Food Score",
      "subtitle": "Qualità della tua dispensa",
      "info": {
        "title": "Come si calcola il Food Score",
        "intro": "Il punteggio (0–100) valuta quanto è sana ed equilibrata la tua dispensa attuale. È composto da tre parti pesate:",
        "catBody": "Quante categorie sane copri (verdure, frutta, pesce, legumi, cereali integrali, latticini …) e quanto sono di qualità i prodotti. Obiettivo: almeno 8 categorie sane diverse.",
        "medBody": "Quanto la tua dispensa rispecchia la dieta mediterranea: verdure, pesce, legumi e olio d'oliva contano in positivo — dolci e cibi molto processati sottraggono.",
        "freshBody": "Si basa sulle date di scadenza: gli scaduti valgono 0, i prodotti in scadenza entro 3 giorni poco, quelli più duraturi al massimo. Senza date questa parte conta come neutra (50).",
        "sparsity": "Nota: con meno di 5 prodotti il punteggio viene ridotto proporzionalmente, così una dispensa quasi vuota non può risultare \"equilibrata\"."
      },
      "freshnessHint": "Consiglio: aggiungi le date di scadenza ai tuoi prodotti per rendere significativo il punteggio Freschezza — senza date conta come neutro (50).",
      "verdict": {
        "excellent": "Dispensa eccellente!",
        "balanced": "Dispensa equilibrata.",
        "improvable": "Puoi migliorare la varietà.",
        "poor": "Aggiungi più verdure e legumi.",
        "empty": "Aggiungi prodotti per calcolare il punteggio."
      },
      "sub": {
        "categories": "Varietà",
        "mediterranean": "Mediterraneità",
        "freshness": "Freschezza"
      },
      "breakdown": {
        "vegetables": "Verdure",
        "fruit": "Frutta",
        "fish": "Pesce",
        "legumes": "Legumi",
        "grains": "Cereali",
        "dairy": "Latticini",
        "meat": "Carne",
        "eggs": "Uova"
      }
    }
  },
  "household": {
    "defaultName": "Casa nostra",
    "sharedPantry": "Dispensa condivisa",
    "emptyTitle": "Siete una famiglia?",
    "emptyHint": "Condividi la dispensa con chi fa la stessa spesa. Crea un gruppo o entra con un codice.",
    "createBtn": "Crea gruppo",
    "joinBtn": "Entra",
    "inviteCode": "Codice invito:",
    "leaveBtn": "Esci dal gruppo",
    "leaveConfirmTitle": "Uscire dal gruppo?",
    "leaveConfirmText": "I prodotti condivisi restano nel gruppo. Se sei l'ultimo membro, il gruppo viene sciolto e la dispensa torna personale.",
    "leaveConfirmBtn": "Esci",
    "codePlaceholder": "AB3D4E",
    "created": "Gruppo creato — condividi il codice invito",
    "joined": "Sei entrato nel gruppo",
    "left": "Sei uscito dal gruppo",
    "invalidCode": "Codice invito non valido"
  },
  "pantryFeed": {
    "title": "Attività recenti",
    "action": {
      "add": "ha aggiunto",
      "update": "ha aggiornato",
      "delete": "ha rimosso",
      "deduct": "ha usato",
      "used_up": "ha finito",
      "consumed": "ha segnato come finito",
      "restored": "ha ripristinato",
      "undo": "ha annullato l'uso di"
    }
  },
  "clientLang": {
    "preferred": "Lingua preferita"
  },
  "clientHero": {
    "status": {
      "excellent": "Ottimo andamento",
      "good": "In progresso",
      "attention": "Attenzione",
      "unknown": "Nuovo cliente"
    },
    "coachAi": "Coach AI",
    "aiAnalysis": "Analisi AI",
    "aiError": "Errore nell'analisi AI",
    "copied": "Messaggio copiato",
    "sendAsFeedback": "Invia come feedback",
    "today": "Oggi",
    "yesterday": "Ieri",
    "weeklyAdherence": "Aderenza settimanale",
    "avg": "Media:",
    "strengths": "Punti di forza",
    "toImprove": "Da migliorare",
    "suggestedMessage": "Messaggio consigliato",
    "kpi": {
      "weight": "Peso",
      "calories": "Score",
      "protein": "Proteine",
      "sleep": "Sonno",
      "hrv": "HRV",
      "steps": "Passi",
      "water": "Acqua",
      "workouts": "Allenamenti"
    },
    "trends": {
      "title": "Andamenti",
      "subtitle": "Ultimi {days} giorni",
      "tabs": {
        "weight": "Peso",
        "sleep": "Sonno",
        "kcal": "Calorie"
      },
      "avg": "Media",
      "target": "Target",
      "empty": "Nessun dato in questo periodo",
      "units": {
        "kg": "kg",
        "hours": "h",
        "kcal": "kcal"
      },
      "ranges": {
        "d7": "7g",
        "d14": "14g",
        "d30": "30g"
      }
    },
    "week": "sett."
  },
  "mealBadges": {
    "excellent": "Ottimo pasto",
    "highProtein": "Ricco di proteine",
    "highFiber": "Molte fibre",
    "lightSnack": "Spuntino leggero",
    "lowProtein": "Poche proteine",
    "lowFiber": "Poche verdure",
    "highSugar": "Troppi zuccheri",
    "highSalt": "Troppo salato",
    "highSatFat": "Grassi saturi",
    "heavySnack": "Spuntino pesante"
  },
  "mealFilter": {
    "all": "Tutti",
    "problems": "Solo problemi",
    "warnings": "Da migliorare",
    "counter": "{n} pasti"
  },
  "adherence": {
    "title": "Timeline aderenza",
    "subtitle": "Ultimi {days} giorni",
    "avg": "Media:",
    "empty": "Nessun dato"
  },
  "quickActions": {
    "chat": "Chat",
    "updatePlan": "Aggiorna piano",
    "writeFeedback": "Scrivi feedback",
    "noMealToComment": "Nessun pasto senza feedback"
  },
  "voiceFood": {
    "tap": "Cerca con la voce",
    "listening": "Ascolto…",
    "processing": "Trascrivo…",
    "tapToStop": "Tocca per fermare",
    "notSupported": "Il tuo browser non supporta il microfono",
    "micDenied": "Microfono non autorizzato",
    "tooShort": "Audio troppo breve, riprova",
    "notRecognized": "Non ho capito, riprova",
    "error": "Errore nella trascrizione",
    "multiFound": "Trovati {n} alimenti",
    "multiHint": "Tocca una voce per cercarla e registrarla",
    "tapToSearch": "Tocca per cercare",
    "multiAllDone": "{n} alimenti registrati ✓",
    "moveTo": "Sposta a {name}",
    "moved": "Spostato a {name}"
  },
  "onboardingTutorial": {
    "skip": "Salta",
    "prev": "Indietro",
    "next": "Avanti",
    "start": "Inizia",
    "loadError": "Impossibile caricare il tutorial",
    "profileButton": "Rivedi tutorial",
    "slides": {
      "welcome": {
        "hint": "50% verdure · 25% proteine · 25% carboidrati",
        "title": "Il tuo viaggio inizia qui",
        "body": "Benvenuto in Solano Essence. Un modo elegante di prenderti cura del tuo corpo — un piatto alla volta."
      },
      "log": {
        "hint": "Voce · Foto AI · Ricerca",
        "title": "Logga in un attimo",
        "body": "Parla al microfono, scatta una foto o cerca nel database Solano di oltre 5.000 alimenti."
      },
      "gamify": {
        "hint": "Streak · Missioni · Stati di salute",
        "title": "Ogni buona abitudine conta",
        "body": "Guadagna Solano Points a ogni pasto sano, allenamento e notte di riposo. Sblocca badge e sali di livello."
      },
      "sync": {
        "hint": "Automatico, silenzioso, sempre fresco",
        "title": "Sincronizza il tuo corpo",
        "body": "Collega Google Fit, Apple Health o il tuo wearable. Passi, sonno e allenamenti sempre aggiornati."
      },
      "start": {
        "hint": "Registra il tuo primo pasto",
        "title": "Sei pronto",
        "body": "Il tuo coach AI è al tuo fianco. Ogni piccolo passo conta — iniziamo insieme."
      }
    }
  },
  "rewards": {
    "navLabel": "Premi",
    "title": "I tuoi Premi",
    "subtitle": "Costanza e benessere, un giorno alla volta",
    "totalSp": "Solano Points",
    "levelLabel": "Livello",
    "nextLevel": "Prossimo Stato",
    "spToNext": "Mancano {n} SP a {name}",
    "maxLevel": "Livello massimo raggiunto",
    "streakCurrent": "Giorni consecutivi",
    "streakLongest": "Record personale",
    "todaySp": "Guadagnati oggi",
    "dailyMissions": "Missioni di oggi",
    "dailyMissionsSub": "Completa tutte le 3 per un bonus da {n} SP",
    "allCompletedBonus": "Bonus giornaliero sbloccato! +{n} SP",
    "weeklyMissions": "Missioni della settimana",
    "weeklyMissionsSub": "Completa tutte le 5 per un bonus da {n} SP",
    "weeklyAllCompleted": "Bonus settimanale sbloccato! +{n} SP",
    "weeklyRange": "Settimana dal {start} al {end}",
    "store": "Store cosmetici",
    "storeSub": "SP disponibili: {n}",
    "buy": "Acquista",
    "purchased": "Acquistato",
    "insufficientSp": "SP insufficienti",
    "confirmPurchase": "Vuoi acquistare {name} per {cost} SP?",
    "purchaseSuccess": "🎉 Sbloccato!",
    "spGained": "SP guadagnati",
    "levelUpToast": "Nuovo livello: {name}!",
    "levelUpTitle": "Livello sbloccato",
    "levelUpContinue": "Continua",
    "personalizeTitle": "Personalizza il tuo profilo",
    "personalizeHint": "Solo cosmetici acquistati",
    "personalizeThemes": "Tema attivo",
    "personalizeBadges": "Badge in mostra (max 3)",
    "personalizeAnimations": "Animazioni",
    "themeDefault": "Petrolio (default)",
    "categoryTheme": "Tema",
    "categoryBadge": "Badge esclusivo",
    "categoryAnimation": "Animazione",
    "itemNames": {
      "theme_forest": "Tema Foresta",
      "theme_ocean": "Tema Oceano",
      "theme_sunset": "Tema Tramonto",
      "theme_bianconero": "Bianconero",
      "theme_nerazzurro": "Nerazzurro",
      "theme_rossonero": "Rossonero",
      "theme_azzurro": "Azzurro Italia",
      "theme_giallorosso": "Giallorosso",
      "theme_tricolore": "Tricolore Italia",
      "theme_neon": "Neon Cyber",
      "theme_lavender": "Lavanda Wellness",
      "theme_rosegold": "Rosa Oro",
      "theme_matcha": "Matcha",
      "theme_midnight": "Mezzanotte",
      "badge_early_bird": "Alba d'oro",
      "badge_night_owl": "Gufo Notturno",
      "badge_gourmet": "Gourmet",
      "anim_confetti_gold": "Coriandoli d'oro",
      "anim_progress_glow": "Bagliore progresso",
      "anim_sparkle_rain": "Pioggia di stelle",
      "anim_aura_pulse": "Aura pulsante",
      "anim_shimmer": "Riflesso lucente",
      "theme_summer": "Turchese estivo",
      "theme_halloween": "Zucca di Halloween",
      "theme_christmas": "Rosso natalizio"
    },
    "itemDesc": {
      "default_theme": "Applica questa palette all'hero del livello, alle barre di progresso e ai principali gradienti dell'app.",
      "default_badge": "Un badge esclusivo che appare sul tuo profilo.",
      "default_animation": "Un effetto animato che rende più vive le tue conquiste.",
      "theme_forest": "Verde bosco profondo con accento verde foglia — calmo e naturale.",
      "theme_ocean": "Toni blu oceano profondo con accento turchese.",
      "theme_sunset": "Tramonto caldo dall'arancione al rosa fino al viola.",
      "theme_bianconero": "Classico bianconero con accento argento — elegante e senza tempo.",
      "theme_nerazzurro": "Blu notte e nero con accento azzurro ghiaccio.",
      "theme_rossonero": "Rossonero potente con accento dorato.",
      "theme_azzurro": "Azzurro brillante con accento cielo chiaro.",
      "theme_giallorosso": "Giallorosso caldo in gradiente intenso con accento oro.",
      "anim_sparkle_rain": "Stelle scintillanti piovono dolcemente sulla tua card dei progressi.",
      "anim_confetti_gold": "Coriandoli dorati piovono sullo schermo a ogni salita di livello.",
      "anim_progress_glow": "La tua barra dei progressi pulsa con un bagliore delicato.",
      "anim_aura_pulse": "Un'aura pulsante circonda il simbolo del tuo livello.",
      "anim_shimmer": "Un elegante riflesso di luce attraversa la tua card dei progressi.",
      "theme_summer": "Turchese laguna con giallo sole — design estivo limitato, disponibile solo da giugno ad agosto.",
      "theme_halloween": "Arancione zucca che brilla nel cielo notturno viola — limitato, disponibile solo nel periodo di Halloween. 🎃",
      "theme_christmas": "Rosso natalizio con verde abete e oro — limitato, disponibile solo nel periodo dell'Avvento.",
      "theme_tricolore": "Bandiera italiana: verde-bianco-rosso in un gradiente pulito con accento verde smeraldo.",
      "theme_neon": "Vibrazioni cyber: viola profondo, magenta e blu elettrico. Look futuristico.",
      "theme_lavender": "Toni lavanda e prugna per un'esperienza calma e rilassante.",
      "theme_rosegold": "Elegante rosa oro con accento champagne. Chic e raffinato.",
      "theme_matcha": "Verde matcha con accento crema. Ispirato alla cerimonia del tè.",
      "theme_midnight": "Blu notte profondo con accento stellato. Perfetto per la sera."
    },
    "previewLabel": "Anteprima tema",
    "seasonalTag": "Limitato",
    "seasonalLocked": "Design stagionale — disponibile solo {window}",
    "weeklyNames": {
      "wk_workouts_5": "5 allenamenti",
      "wk_plates_5": "5 piatti eccellenti",
      "wk_sleep_6": "6 notti sopra 7h",
      "wk_fiber_5": "5 giorni con 30g di fibre",
      "wk_steps_60k": "60.000 passi"
    },
    "syncFit": "Sincronizza Google Fit",
    "syncFitHint": "Nessun passo oggi — sincronizza per aggiornare",
    "syncing": "Sincronizzo…",
    "syncOk": "Dati sincronizzati",
    "syncFailed": "Sincronizzazione fallita",
    "badges": "Badge",
    "earnedBadges": "{n} sbloccati",
    "lockedBadges": "{n} da sbloccare",
    "recentActivity": "Attività recente",
    "empty": "Ancora nessun evento",
    "widgetTitle": "Progresso",
    "widgetCta": "Vedi Premi",
    "viewAll": "Vedi tutto",
    "congratsBadge": "Nuovo badge sbloccato!",
    "levelUp": "Sei salito di stato!",
    "states": {
      "newStart": {
        "name": "Nuovo Inizio",
        "quote": "Ogni grande cambiamento inizia da un piccolo passo."
      },
      "inBalance": {
        "name": "In Equilibrio",
        "quote": "Stai costruendo abitudini sane."
      },
      "activeWellness": {
        "name": "Benessere Attivo",
        "quote": "Il tuo stile di vita sta migliorando."
      },
      "steadyShape": {
        "name": "Forma Costante",
        "quote": "La costanza è il tuo punto di forza."
      },
      "totalEnergy": {
        "name": "Energia Totale",
        "quote": "Il tuo corpo ti sta ringraziando."
      },
      "eliteHealth": {
        "name": "Salute d'Élite",
        "quote": "Hai raggiunto un livello superiore di benessere."
      },
      "ambassador": {
        "name": "Ambasciatore",
        "quote": "Sei un esempio di costanza e disciplina."
      },
      "legend": {
        "name": "Leggenda",
        "quote": "L'eccellenza è diventata il tuo stile di vita."
      },
      "master": {
        "name": "Maestro",
        "quote": "Comandi tu le tue abitudini – non il contrario."
      },
      "champion": {
        "name": "Campione",
        "quote": "Costanza al massimo livello."
      },
      "inspiration": {
        "name": "Ispirazione",
        "quote": "Il tuo percorso motiva gli altri."
      },
      "diamond": {
        "name": "Diamante",
        "quote": "Forgiato sotto pressione, indistruttibile."
      },
      "titan": {
        "name": "Titano",
        "quote": "La tua disciplina non conosce limiti."
      },
      "olymp": {
        "name": "Olimpo",
        "quote": "Giochi in un campionato tutto tuo."
      },
      "immortal": {
        "name": "Immortale",
        "quote": "Le tue abitudini sono fatte per durare per sempre."
      }
    },
    "badgeNames": {
      "meals_30": "30 piatti registrati",
      "meals_100": "100 piatti registrati",
      "water_100_days": "100 giorni idratati",
      "steps_100k": "100k passi",
      "steps_1m": "1 milione di passi",
      "workouts_50": "50 allenamenti",
      "workouts_100": "100 allenamenti",
      "sleep_30": "30 notti da 7h",
      "streak_30": "30 giorni consecutivi",
      "streak_100": "100 giorni consecutivi",
      "first_month": "Primo mese",
      "first_year": "Primo anno",
      "protein_30": "30 giorni proteine ok",
      "fiber_30": "30 giorni fibre ok",
      "learn_streak_7": "Serie di studio di 7 giorni",
      "learn_streak_30": "Serie di studio di 30 giorni",
      "learn_correct_50": "50 risposte quiz corrette"
    },
    "missionNames": {
      "protein_meal25": {
        "title": "Proteine intelligenti",
        "hint": "Almeno 25 g di proteine in un pasto principale."
      },
      "protein_daily": {
        "title": "Obiettivo proteine",
        "hint": "Raggiungi il tuo target giornaliero di proteine."
      },
      "veg_2p": {
        "title": "Verdura x2",
        "hint": "Registra due porzioni di verdura oggi."
      },
      "fruit_2p": {
        "title": "Frutta x2",
        "hint": "Registra due porzioni di frutta oggi."
      },
      "fiber_target": {
        "title": "Obiettivo fibre",
        "hint": "Raggiungi il tuo target di fibre giornaliero."
      },
      "plate_balanced": {
        "title": "Piatto Solano",
        "hint": "Un piatto bilanciato: 50% verdure, 25% proteine, 25% carboidrati."
      },
      "steps_target": {
        "title": "Obiettivo passi",
        "hint": "Raggiungi il tuo target personale di passi."
      },
      "active_min_20": {
        "title": "20 minuti attivi",
        "hint": "Almeno 20 minuti di movimento moderato."
      },
      "workout_done": {
        "title": "Allenamento",
        "hint": "Completa un allenamento pianificato oggi."
      },
      "rest_day_walk": {
        "title": "Passeggiata di recupero",
        "hint": "Giorno di riposo? Fai 3.000 passi leggeri."
      },
      "water_target": {
        "title": "Obiettivo acqua",
        "hint": "Raggiungi il tuo obiettivo idrico giornaliero."
      },
      "log_all_meals": {
        "title": "Registra i pasti",
        "hint": "Colazione, pranzo e cena: tutti e 3."
      },
      "day_checkin": {
        "title": "Check-in giornaliero",
        "hint": "Completa il check-in della giornata."
      },
      "sleep_logged": {
        "title": "Registra il sonno",
        "hint": "Inserisci la durata del sonno di questa notte."
      },
      "protein_bkfst30": {
        "title": "30g di proteine a colazione",
        "hint": "Aggiungi uova, yogurt greco o whey al primo pasto."
      },
      "water_2l": {
        "title": "Bevi 2 litri d'acqua",
        "hint": "Un bicchiere all'ora manterrai il ritmo."
      },
      "steps_8k": {
        "title": "8.000 passi",
        "hint": "Una passeggiata di 30' + salire le scale."
      },
      "fiber_30g": {
        "title": "30g di fibre",
        "hint": "Verdure a pranzo/cena + frutta e legumi."
      },
      "sleep_7h": {
        "title": "7h di sonno",
        "hint": "Spegni gli schermi 30' prima di dormire."
      }
    },
    "swap": "Cambia",
    "swapDone": "Missione cambiata",
    "swapTooltip": "Scambia questa missione con un'altra della stessa categoria",
    "swapUsedTooltip": "Hai già usato lo scambio giornaliero",
    "actions": {
      "meal_log": "Pasto registrato",
      "meal_photo_bonus": "Foto pasto",
      "plate_check_80": "Controllo piatto equilibrato (80%+)",
      "plate_balanced": "Piatto bilanciato",
      "water_goal": "Obiettivo acqua",
      "steps_goal": "Obiettivo passi",
      "workout_done": "Allenamento",
      "sleep_7h": "Notte di 7h+",
      "learn_pill": "Consiglio letto",
      "diary_complete": "Diario completo",
      "streak_bonus": "Bonus streak",
      "daily_bonus": "Bonus missioni",
      "weekly_bonus": "Bonus settimanale",
      "purchase": "Acquisto store"
    }
  },
  "cook": {
    "title": "Cosa cucino?",
    "subtitle": "{n} idee dalla tua dispensa",
    "haveAll": "Hai tutto",
    "oneMissing": "Manca 1 ingrediente",
    "manyMissing": "Mancano più ingredienti",
    "missing": "{n} manca",
    "addMissing": "Aggiungi in lista",
    "addedToList": "{n} in lista",
    "cook": "Cucina"
  },
  "shopping": {
    "title": "Lista della spesa",
    "empty": "Lista vuota",
    "emptyHint": "Aggiungi qui i prodotti che ti servono o aspetta che finiscano dalla dispensa.",
    "itemsCount": "{n} articoli da comprare",
    "section": {
      "auto": "Da ricomprare",
      "manual": "Aggiunti da te"
    },
    "reason": {
      "consumed": "Finito",
      "expired": "Scaduto",
      "weeklyMenu": "Dal menu settimanale",
      "shoppingCheck": "Dal Check spesa"
    },
    "restockHint": "Suggerito: {qty} · dura ~{days}g",
    "addPlaceholder": "Aggiungi articolo (es. Latte)…",
    "boughtBtn": "Ho comprato",
    "checkedByScan": "Spuntato",
    "movedToPantry": "{name} → messo in dispensa",
    "expiry": {
      "title": "{name} comprato",
      "body": "Scade il? Facoltativo – tiene aggiornato il punteggio freschezza.",
      "d3": "+3 giorni",
      "w1": "+1 settimana",
      "w2": "+2 settimane",
      "m1": "+1 mese",
      "until": "Da consumare entro {date}",
      "skip": "Senza data",
      "save": "In dispensa"
    },
    "uncheckBtn": "Rimetti in lista",
    "notNeededBtn": "Non serve",
    "shareBtn": "Condividi lista",
    "copied": "Lista copiata negli appunti",
    "restocked": "{name} riaggiunto alla dispensa",
    "importAll": "Trasferisci tutto in dispensa",
    "importedAdded": "{n} nuovi",
    "importedMerged": "{n} aggiornati",
    "importedRestocked": "{n} riforniti",
    "importedNothing": "Nessun articolo da trasferire",
    "addedToList": "Aggiunto alla lista della spesa"
  },
  "weekly": {
    "title": "Menu Settimanale",
    "servings": "Porz.",
    "subtitle": "7 giorni bilanciati sui tuoi obiettivi",
    "generate": "Genera menu",
    "regenerate": "Rigenera",
    "generated": "Menu generato!",
    "generatedWithList": "Menu creato! Ingredienti mancanti aggiunti alla lista della spesa.",
    "viewShoppingList": "Vedi lista",
    "autoSyncedHint": "Gli ingredienti che non hai in dispensa sono stati aggiunti automaticamente alla lista della spesa.",
    "generatedAt": "Generato",
    "emptyHint": "Non hai ancora un menu. Tocca 'Genera menu' per crearne uno bilanciato per te.",
    "shoppingList": "Lista della spesa",
    "addToPantry": "Aggiungi alla dispensa",
    "importedShopping": "Spesa aggiunta alla dispensa",
    "tapToBuy": "Tocca un articolo per marcarlo comprato e salvarlo in dispensa",
    "movedToPantry": "Spostato in dispensa",
    "print": "Stampa",
    "printMenu": "Stampa menu",
    "printMenuShort": "Menu",
    "share": "Condividi",
    "copied": "Lista copiata negli appunti",
    "allBought": "Tutto comprato!",
    "popupBlocked": "Blocco pop-up attivo — abilitalo per stampare",
    "focusMode": "Modalità spesa",
    "focusModeShort": "Spesa",
    "showDone": "Mostra fatti",
    "hideDone": "Nascondi fatti",
    "voiceStart": "Spunta con la voce",
    "voiceStop": "Interrompi ascolto",
    "voiceListening": "In ascolto…",
    "voiceNoMatch": "Non ho trovato",
    "voiceError": "Errore microfono",
    "voiceUnsupported": "Il tuo browser non supporta il riconoscimento vocale",
    "mealLoading": "Creo la ricetta completa…",
    "ingredients": "Ingredienti",
    "procedure": "Procedimento",
    "fiber": "Fibre"
  },
  "shoppingAisle": {
    "produce": "Frutta e verdura",
    "meatFish": "Carne e pesce",
    "dairyEggs": "Latticini e uova",
    "bakery": "Panetteria",
    "pantry": "Dispensa (secchi)",
    "frozen": "Surgelati",
    "supplements": "Proteine & Integratori",
    "beverages": "Bevande",
    "other": "Altro"
  },
  "wearables": {
    "empty": "Nessun dato dai wearable ancora. Collega un dispositivo per vedere Recovery, HRV, Sonno e altro.",
    "sleep": "Sonno",
    "hrv": "HRV",
    "restingHr": "FC riposo",
    "strain": "Strain",
    "sleepChart": "Sonno (ore/notte)",
    "hrvChart": "HRV (ms)",
    "syncNow": "Sincronizza ora",
    "syncing": "Sincronizzo…",
    "syncOk": "Aggiornati {n} giorni",
    "syncEmpty": "Nessun dato nuovo",
    "lastSync": "Ultima sync:",
    "neverSynced": "Non ancora sincronizzato",
    "title": "Wearable & Health",
    "connectDevice": "Collega un dispositivo",
    "deviceConnected": "{n} dispositivo collegato",
    "devicesConnected": "{n} dispositivi collegati",
    "supportedList": "WHOOP · Garmin · Fitbit · Oura · Polar · Withings · Google Fit · Peloton · Apple Health",
    "tapToConnect": "Tocca Aggiungi per collegare un wearable e sincronizzare sonno, HRV e attività",
    "connectBtn": "Collega",
    "addBtn": "Aggiungi",
    "sdkError": "SDK non caricato — verrà usata l'apertura in nuova pagina",
    "providerConnected": "{p} collegato",
    "deviceConnectedToast": "Dispositivo collegato",
    "connectWhoopDirect": "Collega WHOOP direttamente",
    "noDataYet": "Nessun dato ancora",
    "agingToast": "{p} non riceve dati da oltre 1 ora — sincronizza per aggiornare",
    "autoSyncing": "Sincronizzazione automatica…",
    "autoSyncFailed": "Sync automatica di {p} fallita",
    "rel": {
      "sec": "{n}s fa",
      "min": "{n}m fa",
      "hr": "{n}h fa",
      "day": "{n}g fa"
    }
  },
  "streaks": {
    "title": "Streak",
    "diary": "Diario",
    "weight": "Peso",
    "water": "Acqua",
    "daysShort": "g",
    "memberSince": "Con noi dal",
    "activeDays": "giorni attivi",
    "keepItUp": "Continua così!",
    "badgeUnlockOne": "Tra 1 giorno sblocchi il Badge {name}",
    "badgeUnlockMany": "Tra {n} giorni sblocchi il Badge {name}",
    "badge_seed": "Germoglio",
    "badge_bronze": "Bronzo",
    "badge_silver": "Argento",
    "badge_gold": "Oro",
    "badge_diamond": "Diamante",
    "badge_legend": "Leggenda"
  },
  "chat": {
    "title": "Chat",
    "subtitleClient": "Scrivi al tuo nutrizionista",
    "subtitleNut": "Rispondi ai tuoi clienti",
    "noClients": "Nessun cliente",
    "noMessages": "Nessun messaggio. Scrivi il primo!",
    "linkNutFirst": "Collega un nutrizionista per iniziare a chattare",
    "selectClient": "Seleziona un cliente",
    "messagePh": "Scrivi un messaggio…"
  },
  "progressPhotos": {
    "title": "Foto progresso",
    "subtitle": "Fronte, lato, dietro — confronta nel tempo",
    "front": "Fronte",
    "side": "Lato",
    "back": "Dietro",
    "photoBtn": "Foto",
    "empty": "Nessuna foto ancora.",
    "emptyHint": "Tocca per aggiungere la prima foto",
    "saved": "Foto salvata",
    "latest": "Ultime foto",
    "timeline": "Cronologia",
    "compare": "Confronta",
    "openCompare": "Confronta selezionate",
    "compareTitle": "Confronto"
  },
  "igImport": {
    "title": "Importa da Instagram",
    "subtitle": "Incolla la caption di un tuo post e l'AI crea la ricetta con macro USDA/CREA.",
    "urlLabel": "Link del post (opzionale)",
    "urlHint": "Utile per ritrovare la fonte in futuro.",
    "captionLabel": "Caption del post",
    "captionPh": "Incolla qui il testo della caption di Instagram (emoji e hashtag inclusi)…",
    "captionHint": "Facoltativa se carichi una foto (es. infografica della ricetta) – l'AI legge la ricetta direttamente dall'immagine.",
    "photoLabel": "Foto del piatto (opzionale)",
    "photoPick": "Trascina o tocca per scegliere una foto",
    "photoOptional": "Consigliata: aiuta l'AI a capire il piatto",
    "analyzeBtn": "Analizza con AI",
    "analyzing": "L'AI sta leggendo la tua ricetta…",
    "analyzingHint": "Estraiamo nome, ingredienti, procedimento e ricalcoliamo i macro dal database Solano.",
    "back": "Modifica testo",
    "cancel": "Annulla",
    "saveBtn": "Salva ricetta (pubblica)",
    "saved": "Ricetta importata e pubblicata",
    "fName": "Nome ricetta",
    "fMealType": "Tipo pasto",
    "fServings": "Porzioni",
    "fDesc": "Descrizione",
    "fIngredients": "Ingredienti",
    "fInstructions": "Procedimento",
    "ingHint": "Uno per riga, con quantità e unità (es. 80g pasta, 1 uovo)",
    "macrosPreview": "Macro per porzione",
    "macrosComputed": "Calcolati automaticamente dal database",
    "perServing": "porzione",
    "errImageOnly": "Puoi caricare solo immagini",
    "errTooBig": "Immagine troppo grande, prova con una più piccola",
    "errCaptionShort": "La caption è troppo corta",
    "errNeedInput": "Inserisci il testo OPPURE carica una foto della ricetta",
    "errAnalyze": "Errore durante l'analisi. Riprova."
  },
  "recipes": {
    "qrScanBtn": "Scansiona QR",
    "qrScanTitle": "Scansiona codice QR",
    "qrScanHint": "Inquadra il codice QR di un amico (ricetta o pasto)",
    "qrInvalid": "Codice QR Solano non valido",
    "qrCameraError": "Fotocamera non disponibile. Consenti l'accesso alla fotocamera.",
    "quickActionQr": "Codice QR",
    "qrTitle": "Condividi con codice QR",
    "qrHint": "La scansione apre direttamente la ricetta — nell’app se installata.",
    "qrCopyLink": "Copia link",
    "goalScore": {
      "title": "Punteggio obiettivo",
      "goals": {
        "dimagrimento": "Dimagrimento",
        "mantenimento": "Mantenimento",
        "massa": "Massa muscolare"
      },
      "bands": {
        "very_good": "Molto adatto",
        "good": "Adatto",
        "conditional": "Parzialmente adatto",
        "less_suited": "Poco adatto"
      },
      "reasons": {
        "protein_rich": "Ricco di proteine",
        "satiating": "Saziante con calorie moderate",
        "fiber_rich": "Ricco di fibre",
        "veg_rich": "Alta quota di verdura/frutta",
        "kcal_fits": "Calorie adatte a questo pasto",
        "good_for_muscle": "Ottimo pasto per la massa",
        "kcal_high_for_goal": "Un po' calorico per il tuo obiettivo",
        "kcal_low_for_goal": "Poche calorie per la massa",
        "salt_high": "Sale relativamente alto",
        "sugar_high": "Zuccheri relativamente alti",
        "satfat_high": "Molti grassi saturi",
        "protein_low": "Poche proteine",
        "over_budget_today": "Supera il budget rimanente di oggi",
        "balanced_ok": "Nel complesso equilibrato"
      }
    },
    "nutritionBasisLabel": "Valori nutrizionali per porzione",
    "nutritionBasisScaled": "Valori nutrizionali per {n} porzioni",
    "seasoningEstimateHint": "Spezie/sale \"q.b.\" e ingredienti opzionali non sono calcolati con esattezza",
    "partialEstimateBadge": "Valori nutrizionali parzialmente stimati",
    "highSaltWarning": "Alto contenuto di sale",
    "matchedCount": "{a} di {b} ingredienti calcolati completamente",
    "reviewNeeded": "Valori incompleti — controlla gli ingredienti",
    "reviewUnmatched": "Non riconosciuti",
    "fixBtn": "Controlla e correggi ingredienti",
    "editIngredients": "Modifica",
    "fillAmounts": "Completa quantità",
    "fillAmountsHint": "Alcuni ingredienti non hanno una quantità – completali con quantità e valori tipici dal database.",
    "fillAmountsDone": "{n} ingrediente/i completato/i con quantità tipiche – controlla",
    "fillAmountsNone": "Tutti gli ingredienti hanno già una quantità",
    "livePerServing": "a porzione",
    "liveTotal": "totale",
    "liveCalculating": "Calcolo…",
    "fixTitle": "Correggi ingredienti",
    "fixSubtitle": "Modifica gli ingredienti finché vengono tutti riconosciuti. Al salvataggio i valori nutrizionali vengono ricalcolati automaticamente.",
    "fixMatched": "Riconosciuto",
    "fixUnmatched": "Non riconosciuto — modifica il testo o scegli un alimento dal database con la lente",
    "fixNegligible": "Trascurabile (acqua/spezie)",
    "fixPickFood": "Scegli dal database",
    "fixSearchPlaceholder": "Cerca alimento…",
    "fixNoResults": "Nessun risultato",
    "fixSuggestion": "Intendevi",
    "fixAdd": "Aggiungi ingrediente",
    "fixSearchDb": "Cerca",
    "fixUnknownCount": "{n} ingrediente/i non riconosciuto/i – evidenziati, tocca per scegliere dal database",
    "fixServings": "Porzioni",
    "fixSave": "Salva e ricalcola",
    "fixSaving": "Calcolo…",
    "fixSavedOk": "Ricetta aggiornata — valori ricalcolati",
    "fixSavedStillReview": "Salvato — alcuni ingredienti non sono ancora riconosciuti",
    "fixError": "Aggiornamento non riuscito",
    "cuisineTitle": "Cucine preferite (opzionale)",
    "cuisineNames": {
      "asian": "Asiatica",
      "mediterranean": "Mediterranea",
      "oriental": "Mediorientale",
      "mexican": "Messicana",
      "indian": "Indiana",
      "japanese": "Giapponese",
      "thai": "Thailandese",
      "southamerican": "Sudamericana"
    },
    "title": "Ricette",
    "subtitle": "Salva le tue ricette preferite con calorie e macro",
    "newRecipe": "Nuova ricetta",
    "importInstagram": "Da Instagram",
    "photoGenerate": "Genera foto AI",
    "photoRegenerate": "Rigenera foto AI",
    "photoGenerating": "Genero foto…",
    "photoGenerated": "Foto generata",
    "photoBatchStart": "Genera foto AI ({n} mancanti)",
    "photoBatchRunning": "Genero {done}/{total}…",
    "photoBatchDone": "{n} foto generate 🎉",
    "trBanner": "{n} ricette non ancora nella tua lingua",
    "trBatchBtn": "Traduci tutto",
    "trBatchRunning": "Traduco {done}/{total}…",
    "trBatchDone": "{n} ricette tradotte 🎉",
    "saveRecipe": "Salva ricetta",
    "addBtn": "Aggiungi",
    "libraryBadge": "Libreria",
    "addToDiary": "Aggiungi al diario",
    "byAuthor": "da",
    "confirmDeleteOther": "Eliminare la ricetta di un altro utente? L'azione è irreversibile.",
    "deleted": "Ricetta eliminata",
    "more": "altri…",
    "microSugar": "Zuc.",
    "microFiber": "Fibra",
    "microSat": "Sat.",
    "microSalt": "Sale",
    "folderAll": "Tutte",
    "folderFavorites": "Preferite",
    "folderBreakfast": "Colazione",
    "folderSnack": "Spuntino",
    "folderLunch": "Pranzo",
    "folderAfternoon": "Merenda",
    "folderDinner": "Cena",
    "folderSauce": "Salsa / Dressing",
    "collectionsTitle": "Raccolte",
    "collectionsNew": "Nuova",
    "collectionsCreateTitle": "Nuova raccolta",
    "collectionsEditTitle": "Modifica raccolta",
    "collectionsNamePh": "Nome (es. Meal prep)",
    "collectionsEmojiLabel": "Icona",
    "collectionsColorLabel": "Colore",
    "collectionsCreateBtn": "Crea",
    "collectionsSaveBtn": "Salva",
    "collectionsDeleteConfirm": "Eliminare la raccolta? Le ricette restano nella tua libreria.",
    "collectionsAddTo": "Aggiungi a raccolta",
    "collectionsAddToTitle": "Salva nelle raccolte",
    "collectionsCreated": "Raccolta creata",
    "collectionsDeleted": "Raccolta eliminata",
    "sauceAiBtn": "Suggerisci salse con AI",
    "sauceAiHint": "Abbinate alle tue ricette e alla tua dispensa — povere di sale e con quantità esatte",
    "sauceAiDone": "3 nuove salse/dressing create",
    "recipeSingular": "ricetta",
    "recipePlural": "ricette",
    "emptyLibrary": "Nessuna ricetta ancora",
    "emptyFolder": "Ancora vuota",
    "emptyFolderHint": "Aggiungi una ricetta a questa cartella o cambia sezione.",
    "emptyFavorites": "Nessuna preferita",
    "emptyFavoritesHint": "Tocca il cuore su una ricetta per aggiungerla ai preferiti e ritrovarla in un tap.",
    "favoriteAdded": "Aggiunta ai preferiti",
    "favoriteRemoved": "Rimossa dai preferiti",
    "favoriteAdd": "Aggiungi ai preferiti",
    "favoriteRemove": "Rimuovi dai preferiti",
    "ingredients": "Ingredienti",
    "preparation": "Preparazione",
    "person": "persona",
    "people": "persone",
    "servingsHint": "Cambia le porzioni al momento di aggiungere al diario",
    "portion": "porzione",
    "logPreview": "Verrà aggiunto al tuo diario",
    "logPreviewAdapted": "Verranno aggiunte le kcal adattate al tuo diario",
    "servingsOfHint": "Su {total} porzioni della ricetta (le quantità sono già scalate)",
    "scaledForPeople": "Scalata per {n} persone",
    "visibilityTitle": "Chi può vedere questa ricetta",
    "visibilityPrivate": "Solo io",
    "visibilityNutritionist": "Il mio nutrizionista",
    "visibilityPublic": "Tutti",
    "visibilityPrivateShort": "Privata",
    "visibilityNutritionistShort": "Nutrizionista",
    "visibilityHint": "Cambia in qualunque momento. Le ricette 'Tutti' entrano nella libreria pubblica dell'app.",
    "visibilityUpdated": "Visibilità aggiornata",
    "useAdjustHint": "Modifica i grammi se hai mangiato quantità diverse",
    "useAdjustedNotice": "Le calorie verranno ricalcolate dagli ingredienti adattati",
    "aiGenerateBtn": "Genera 5 con AI",
    "aiGenerating": "Genero…",
    "aiGeneratedOk": "5 ricette generate con AI!",
    "aiError": "Errore AI",
    "aiPromptTitle": "Genera ricette con AI",
    "aiPromptDesc": "Descrivi cosa vorresti (opzionale). L'AI genererà 5 ricette in linea con la tua richiesta.",
    "aiPromptPlaceholder": "es. menu sotto 500 kcal, senza glutine, veloce da preparare…",
    "aiPromptGenerate": "Genera 5 ricette",
    "aiChipUnder500": "sotto 500 kcal",
    "aiChipHighProtein": "alto in proteine",
    "aiChipVegetarian": "vegetariano",
    "aiChipGlutenFree": "senza glutine",
    "aiChipQuick": "pronto in 15 min",
    "adaptBtn": "Adatta kcal",
    "adaptTitle": "Adatta la ricetta",
    "adaptDesc": "Ricetta attuale: {current} kcal per porzione. Scrivi quante kcal vuoi e adatterò le quantità.",
    "adaptTargetLabel": "Kcal desiderate per porzione",
    "adaptConfirm": "Adatta",
    "adapting": "Adatto…",
    "adaptedOk": "Ricetta adattata",
    "adaptError": "Impossibile adattare",
    "adaptInvalidKcal": "Inserisci un valore kcal valido",
    "restoreOriginal": "Ripristina originale",
    "verifiedBadge": "Valori nutrizionali verificati",
    "infographicBtn": "Ricetta",
    "infographicBusy": "Creo…",
    "infographicDone": "Infografica salvata!",
    "infographicServings": "porzioni",
    "infographicNutrition": "Valori per porzione",
    "infographicIngredients": "Ingredienti principali",
    "infographicSteps": "Preparazione",
    "recipeMenuShare": "Condividi",
    "recipeMenuDuplicate": "Duplica ricetta",
    "recipeMenuDelete": "Elimina",
    "showAllIngredients": "Mostra tutti gli ingredienti",
    "linkCopied": "Link copiato",
    "difficultyEasy": "Facile",
    "difficultyMedium": "Medio",
    "difficultyHard": "Difficile",
    "quickActionShare": "Condividi",
    "shareMenuLink": "Condividi link",
    "shareMenuLinkHint": "WhatsApp, Messaggi, e-mail …",
    "shareMenuSocial": "Condividi sui social",
    "shareMenuSocialShort": "Social",
    "shareMenuSocialHint": "Immagine + testo per Instagram, TikTok & co.",
    "socialShareTitle": "Condividi sui social",
    "socialFormatSquare": "Quadrato 1:1",
    "socialFormatStory": "Storia 9:16",
    "socialFormatPortrait": "Post 4:5",
    "socialFormatHintPortrait": "Post: scegli “Post” nella condivisione Instagram – il 4:5 entra senza ritaglio.",
    "socialFullRecipeInApp": "Ricetta completa solo nell’app",
    "socialCaption": "Testo IA",
    "socialCaptionBusy": "Creazione del testo …",
    "socialCaptionError": "Impossibile creare il testo",
    "socialCaptionHint": "Instagram e TikTok non importano il testo automaticamente – viene copiato negli appunti al momento della condivisione, basta incollarlo.",
    "socialCaptionInClipboard": "Testo copiato – incollalo nell'app",
    "socialRegenerate": "Nuovo",
    "socialCopy": "Copia",
    "socialCopied": "Testo copiato",
    "socialShareBtn": "Condividi immagine",
    "socialBusy": "Creazione immagine …",
    "socialDownloaded": "Immagine salvata",
    "socialMadeWith": "Creato con Solano Essence",
    "socialPhotoFailed": "Impossibile incorporare la foto della ricetta – scheda creata senza foto.",
    "socialFormatHintStory": "Storia/Reel: scegli “Storia” nella condivisione Instagram – il 9:16 entra senza ritaglio.",
    "socialFormatHintSquare": "Quadrato: tieni premuta l’immagine → salva in Foto → pubblica come post su Instagram.",
    "socialLongPressHint": "Suggerimento: tieni premuta l'immagine per salvarla in Foto.",
    "socialShareFailedHint": "Condivisione non possibile – tieni premuta l'immagine per salvarla.",
    "quickActionShoppingList": "Lista spesa",
    "quickActionDuplicate": "Duplica",
    "addedToShoppingList": "Ingredienti aggiunti alla lista",
    "privacyPrivateDesc": "Visibile solo a te.",
    "privacyNutritionistDesc": "Condivisa con i tuoi clienti.",
    "privacyPublicDesc": "Visibile a tutta la community Solano.",
    "addedToDiaryFlash": "Aggiunto al diario",
    "healthScoreTitle": "Health Score",
    "healthScoreGreat": "Molto equilibrato",
    "healthScoreGood": "Equilibrato",
    "healthScoreImprove": "Da rivedere",
    "goalFitTitle": "Adatto per",
    "goalWeightLoss": "Dimagrimento",
    "goalMaintenance": "Mantenimento",
    "goalMuscleGain": "Massa muscolare",
    "aiCoachBtn": "AI Coach",
    "aiCoachTitle": "Modifica ricetta con AI",
    "aiCoachDesc": "Descrivi come vuoi modificare la ricetta. L'AI genererà una nuova versione con ingredienti, passi e macro aggiornati.",
    "aiCoachPlaceholder": "Es. rendila vegetariana / +proteine / senza lattosio / 700 kcal / per 4 persone",
    "aiCoachRun": "Genera con AI",
    "aiCoachRunning": "AI al lavoro…",
    "aiCoachDone": "Ricetta modificata dall'AI",
    "aiCoachError": "L'AI non è riuscita a modificare la ricetta",
    "aiCoachBadge": "Modificata con AI",
    "aiCoachRestore": "Ripristina originale",
    "aiCoachChipVeggie": "Vegetariana",
    "aiCoachChipHiPro": "Più proteine",
    "aiCoachChipNoLactose": "Senza lattosio",
    "aiCoachChipKcal": "700 kcal",
    "aiCoachChipServings": "Per 4",
    "aiCoachChipCheap": "Più economica",
    "aiEstimateBadge": "Valori nutrizionali stimati",
    "goalPortionDependent": "dipende da porzione e bilancio",
    "recomputeBtn": "Ricalcola",
    "recomputing": "Ricalcolo…",
    "recomputedOk": "Macronutrienti ricalcolati",
    "recomputeError": "Impossibile ricalcolare",
    "formName": "Nome",
    "formDescription": "Descrizione",
    "formIngredients": "Ingredienti (uno per riga)",
    "formIngredientsPh": "80g pasta\n1 cucchiaio olio evo\n...",
    "formServings": "Porzioni",
    "formPrepMin": "Prep. (min)",
    "formKcalServing": "Kcal/porz",
    "formMealType": "Tipo pasto",
    "formProtein": "P (g)",
    "formCarbs": "C (g)",
    "formFat": "G (g)",
    "formDate": "Data",
    "nameRequired": "Nome ricetta obbligatorio",
    "recipeSaved": "Ricetta salvata",
    "addedToDiary": "Aggiunta al diario!",
    "shareExpired": "Il link è scaduto.",
    "shareNotFound": "Ricetta condivisa non trovata."
  },
  "groupChallenges": {
    "section": "Sfide comuni",
    "new": "Nuova",
    "auto": "AUTO",
    "manual": "MANUALE",
    "autoTip": "Verificata automaticamente dai dati dell'app",
    "manualTip": "Check-in manuale (a fiducia)",
    "daysRemaining": "{n} giorni rimasti",
    "lastDay": "Ultimo giorno!",
    "today": "Oggi",
    "yourProgress": "Il tuo progresso",
    "daysUnit": "giorni",
    "wearableHint": "Connetti lo smartwatch (Vital.io) per la verifica automatica",
    "targetReached": "Obiettivo raggiunto oggi",
    "needMore": "Mancano {n} {unit}",
    "markDone": "Segna oggi come fatto",
    "doneToday": "Fatto oggi",
    "noOneCheckedIn": "Nessuno ha ancora un check-in",
    "leaderInFront": "in testa",
    "newTitle": "Nuova sfida di gruppo",
    "newDesc": "Scegli un obiettivo, la durata e gli amici da invitare.",
    "chooseGoal": "Scegli un obiettivo",
    "customTitleLabel": "Sfida personalizzata",
    "customHint": "Manuale · check-in a fiducia",
    "autoDisclaimer": "Le sfide con badge AUTO vengono verificate automaticamente dai dati registrati nell'app (acqua, allenamenti, pasti, smartwatch). Non è possibile barare.",
    "fldTitle": "Titolo",
    "fldEmoji": "Emoji",
    "fldTargetPerDay": "Target/gg",
    "fldUnit": "Unità",
    "titlePlaceholder": "es. Meditazione mattutina",
    "unitPlaceholder": "es. minuti",
    "target": "Target",
    "duration": "Durata",
    "d7": "7 giorni",
    "d30": "30 giorni",
    "inviteFriends": "Invita amici",
    "selectedCount": "({n} selezionati)",
    "create": "Crea sfida",
    "creating": "Creo…",
    "emptyTitle": "Nessuna sfida attiva",
    "emptyDesc": "Sfidati con gli amici: 10k passi, 5 porzioni di verdura, allenamenti settimanali…",
    "emptyCta": "Crea la prima sfida",
    "inviteBadge": "Invito sfida",
    "inviteDetails": "{days} giorni · {n} già dentro",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "detailSubtitle": "Classifica per giorni completati",
    "detailStats": "{d} giorni · {n} partecipanti",
    "you": "Tu",
    "leave": "Esci dalla sfida",
    "del": "Elimina sfida",
    "confirmDelete": "Eliminare definitivamente la sfida per tutti i partecipanti?",
    "confirmLeave": "Vuoi uscire da questa sfida?",
    "toastCreated": "Sfida creata!",
    "toastCheckinDone": "Bravo! Check-in registrato 🎯",
    "toastCheckinRemoved": "Check-in annullato",
    "toastAccepted": "Sfida accettata!",
    "toastDeleted": "Sfida eliminata",
    "toastLeft": "Sei uscito dalla sfida",
    "toastAutoNotYet": "Sfida auto-verificata: ti mancano {n} {unit}. Registra i dati sull'app!",
    "toastError": "Errore",
    "loading": "Caricamento sfide…"
  },
  "privacy": {
    "title": "Privacy e note legali",
    "exportPdf": "Esporta come PDF",
    "sections": {
      "privacy": "Informativa sulla privacy",
      "beta": "Avviso importante",
      "medical": "Avviso medico",
      "consents": "Gestisci consensi",
      "delete": "Elimina account e dati",
      "contact": "Contatto / richiesta privacy"
    }
  },
  "addMeal": {
    "addPhoto": "Aggiungi foto",
    "addPhotoSub": "Fotografa il pasto",
    "tbShare": "Condividi",
    "tbQr": "QR",
    "tbFav": "Preferito",
    "tbDuplicate": "Duplica",
    "tbPhoto": "Foto",
    "tbClear": "Pulisci",
    "tbClose": "Chiudi",
    "favoriteAdded": "Aggiunto ai preferiti",
    "favoriteRemoved": "Rimosso dai preferiti",
    "duplicated": "Pasto duplicato",
    "duplicatePickTitle": "Duplica un pasto",
    "duplicatePickSubtitle": "Scegli un pasto recente da riutilizzare",
    "duplicatePickEmpty": "Nessun pasto recente da duplicare",
    "quickLogTitle": "Log rapido",
    "sauceTitle": "Aggiungi una salsa?",
    "quickLogSubtitle": "Registra un preferito con un tocco o duplica un pasto recente",
    "favTab": "Preferiti",
    "recentTab": "Recenti",
    "favPickEmpty": "Nessun preferito — salva un pasto con l'icona cuore",
    "favTapToLog": "Tocca per registrare",
    "favLogged": "“{name}” registrato",
    "duplicateFromDiary": "Duplica dal diario",
    "shareTapToOpen": "Tocca il link per aprirlo nella tua app Solano Essence:",
    "sharedOk": "Ricetta condivisa",
    "sharedCopied": "Link copiato — incolla su WhatsApp o dove vuoi",
    "imported": "Ricetta importata dal link",
    "shareExpired": "Il link è scaduto (validità 90 giorni)",
    "shareNotFound": "Ricetta non trovata",
    "eatWhereTitle": "Dove hai mangiato?",
    "eatHome": "A casa",
    "eatOut": "Fuori casa",
    "eatHomeHint": "Gli ingredienti corrispondenti vengono scaricati automaticamente dalla dispensa.",
    "eatOutHint": "Mangiato fuori — non viene scaricato nulla dalla dispensa."
  },
  "features": {
    "title": "Le mie funzioni",
    "subtitle": "Scegli quali strumenti vuoi vedere nella tua dashboard",
    "summary": "{on}/{total} attive",
    "enabled": "Funzione attivata",
    "disabled": "Funzione disattivata",
    "footnote": "Puoi cambiare queste impostazioni in qualsiasi momento. Le funzioni disattivate non mostreranno più widget, promemoria o notifiche.",
    "items": {
      "water": {
        "label": "Acqua giornaliera",
        "desc": "Traccia i bicchieri e i ml di acqua bevuti"
      },
      "weight": {
        "label": "Peso e girovita",
        "desc": "Registra peso e misure per il grafico progressi"
      },
      "sleep": {
        "label": "Sonno e HRV",
        "desc": "Sincronizza durata del sonno e variabilità cardiaca"
      },
      "steps_wearable": {
        "label": "Passi e wearable",
        "desc": "Passi giornalieri da Apple Health / Fitbit / Garmin"
      },
      "workouts": {
        "label": "Allenamenti",
        "desc": "Registra sessioni e kcal bruciate"
      },
      "supplements": {
        "label": "Integratori",
        "desc": "Promemoria e check-in per gli integratori"
      },
      "gamification": {
        "label": "Gamification",
        "desc": "Punti, badge, livelli e streak"
      },
      "pantry": {
        "label": "Dispensa",
        "desc": "Gestisci gli ingredienti disponibili in casa"
      },
      "plate_solano": {
        "label": "Piatto Solano",
        "desc": "Distribuzione 50/25/25 (verdure/proteine/carbo)"
      },
      "mediterranean_score": {
        "label": "Punteggio Mediterraneo",
        "desc": "Aderenza alla dieta mediterranea"
      },
      "coach_ai": {
        "label": "Coach AI",
        "desc": "Suggerimenti e feedback automatici dell'AI"
      }
    }
  }
};

export default it;
